const LEARN_PORTAL_VIDEO_SOURCE = '/Indian%20students%20in%20classroom%20from%20different%20angle%2C%20working%20on%20computers%20and%20laptops%2C%20screen%20displays%20showing%20ReactJS%2C%20NodeJS%2C%20JavaScript%2C%20Java%2C%20AI%2C%20Fullstack%20development%20code%20and%20interfaces%2C%20dynamic%20learn.mp4';
const LEARN_PORTAL_IFRAME_SOURCE = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.955006094373!2d77.6534307!3d13.038535999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17c0b817865b%3A0xf75d1d70fe4ea288!2sAlgodoor%20Technologies!5e0!3m2!1sen!2sin!4v1687244417645!5m2!1sen!2sin';

export const LEARN_TREE = [
  {
    id: 'html',
    label: 'HTML',
    fullForm: 'HyperText Markup Language',
    topics: [
      { id: 'html-introduction', title: 'Introduction' },
      { id: 'html-browser-basics', title: 'Browser Basics' },
      { id: 'html-request-lifecycle', title: 'Request Lifecycle' },
      { id: 'html-document-structure', title: 'Document Structure' },
      { id: 'html-head-tag', title: 'Head Tag' },
      { id: 'html-body-tag', title: 'Body Tag' },
      { id: 'html-heading-tag', title: 'Heading Tag' },
      { id: 'html-paragraph-tag', title: 'Paragraph Tag' },
      { id: 'html-anchor-tag', title: 'Anchor Tag' },
      { id: 'html-image-tag', title: 'Image Tag' },
      { id: 'html-responsive-images', title: 'Responsive Images' },
      { id: 'html-list-tags', title: 'List Tags' },
      { id: 'html-description-tags', title: 'Description Tags' },
      { id: 'html-table-tags', title: 'Table Tags' },
      { id: 'html-caption-tag', title: 'Caption Tag' },
      { id: 'html-form-tag', title: 'Form Tag' },
      { id: 'html-input-tag', title: 'Input Tag' },
      { id: 'html-label-tag', title: 'Label Tag' },
      { id: 'html-fieldset-legend-tags', title: 'Fieldset and Legend' },
      { id: 'html-button-tag', title: 'Button Tag' },
      { id: 'html-select-tag', title: 'Select Tag' },
      { id: 'html-textarea-tag', title: 'Textarea Tag' },
      { id: 'html-forms-validation', title: 'Forms and Validation' },
      { id: 'html-common-text-tags', title: 'Common Text Tags' },
      { id: 'html-quote-code-tags', title: 'Quote and Code Tags' },
      { id: 'html-figure-tags', title: 'Figure and Figcaption' },
      { id: 'html-semantic-tags', title: 'Semantic Tags' },
      { id: 'html-atomic-design-systems', title: 'Atomic Design and Design Systems' },
      { id: 'html-details-dialog-tags', title: 'Details and Dialog' },
      { id: 'html-audio-video-tags', title: 'Audio and Video' },
      { id: 'html-media-source-track', title: 'Source and Track' },
      { id: 'html-canvas-svg-tags', title: 'Canvas and SVG' },
      { id: 'html-object-embed-tags', title: 'Object and Embed' },
      { id: 'html-map-area-tags', title: 'Map and Area' },
      { id: 'html-iframe-tag', title: 'Iframe Tag' },
      { id: 'html-meta-tag', title: 'Meta Tag' },
      { id: 'html-link-tag', title: 'Link Tag' },
      { id: 'html-script-tag', title: 'Script Tag' },
      { id: 'html-comment-doctype', title: 'Comment and Doctype' },
      { id: 'html-colors-palette', title: 'HTML Colors' },
      { id: 'html-attributes-core', title: 'Core Attributes' },
      { id: 'html-global-attributes', title: 'Global Attributes' },
      { id: 'html-form-media-attributes', title: 'Form and Media Attributes' },
      { id: 'html-event-attributes', title: 'Event Attributes' },
      { id: 'html-browser-support', title: 'Browser Support' },
      { id: 'html-media-dom-api', title: 'Media DOM API' },
      { id: 'html-url-encoding', title: 'URL Encoding' },
      { id: 'html-language-codes', title: 'Language Codes' },
      { id: 'html-legacy-tags', title: 'Legacy Tags' },
      { id: 'html-accessibility', title: 'Accessibility' },
      { id: 'html-seo-basics', title: 'SEO Basics' },
      { id: 'html-performance', title: 'Performance' },
      { id: 'html-interview-qna', title: 'Interview QnA' },
    ],
  },
  {
    id: 'css',
    label: 'CSS',
    fullForm: 'Cascading Style Sheets',
    topics: [
      { id: 'css-introduction', title: 'Introduction' },
      { id: 'css-syntax', title: 'Syntax' },
      { id: 'css-selectors', title: 'Selectors' },
      { id: 'css-specificity', title: 'Specificity' },
      { id: 'css-cssom-cascade-inheritance', title: 'CSSOM Cascade and Inheritance' },
      { id: 'css-colors', title: 'Colors' },
      { id: 'css-backgrounds', title: 'Backgrounds' },
      { id: 'css-box-model', title: 'Box Model' },
      { id: 'css-margin-padding', title: 'Margin and Padding' },
      { id: 'css-display', title: 'Display' },
      { id: 'css-position', title: 'Position' },
      { id: 'css-flexbox', title: 'Flexbox' },
      { id: 'css-grid', title: 'Grid' },
      { id: 'css-layout-float-flex-grid', title: 'Layout Systems and Float' },
      { id: 'css-typography', title: 'Typography' },
      { id: 'css-units', title: 'Units' },
      { id: 'css-responsive', title: 'Responsive Design' },
      { id: 'css-transitions', title: 'Transitions' },
      { id: 'css-animations', title: 'Animations' },
      { id: 'css-animations-transforms-svg', title: 'Animations Transforms and SVG' },
      { id: 'css-variables', title: 'Variables' },
      { id: 'css-preprocessors-frameworks-cssinjs', title: 'Preprocessors Frameworks and CSS-in-JS' },
      { id: 'css-pseudo-classes', title: 'Pseudo-classes' },
      { id: 'css-pseudo-elements', title: 'Pseudo-elements' },
      { id: 'css-interview-qna', title: 'Interview QnA' },
    ],
  },
  {
    id: 'javascript',
    label: 'JavaScript',
    fullForm: 'JavaScript Programming Language',
    topics: [
      { id: 'js-introduction', title: 'Introduction and Setup' },
      { id: 'js-variables-datatypes', title: 'Variables and Data Types' },
      { id: 'js-operators-conditions', title: 'Operators and Conditions' },
      { id: 'js-loops-functions', title: 'Loops and Functions' },
      { id: 'js-arrays-objects', title: 'Arrays and Objects' },
      { id: 'js-dom', title: 'DOM (Document Object Model) Basics' },
      { id: 'js-events', title: 'Event Handling' },
      { id: 'js-es6', title: 'ES6+ Features' },
      { id: 'js-execution-context-call-stack', title: 'Execution Context and Call Stack' },
      { id: 'js-hoisting-tdz', title: 'Hoisting and Temporal Dead Zone' },
      { id: 'js-scope-closures', title: 'Scope and Closures' },
      { id: 'js-this-keyword', title: 'this Keyword and Binding Rules' },
      { id: 'js-prototypes-inheritance', title: 'Prototypes and Inheritance' },
      { id: 'js-event-loop', title: 'Event Loop Microtasks and Macrotasks' },
      { id: 'js-promises', title: 'Promises Deep Dive' },
      { id: 'js-async', title: 'Asynchronous JavaScript (async/await)' },
      { id: 'js-fetch-api', title: 'Fetch API (Application Programming Interface)' },
      { id: 'js-modules-tooling', title: 'Modules Bundling and Tooling' },
      { id: 'js-browser-storage', title: 'Browser Storage and Caching' },
      { id: 'js-web-workers', title: 'Web Workers and Background Threads' },
      { id: 'js-testing-strategy', title: 'Testing Strategy and Libraries' },
      { id: 'js-patterns-module-principles', title: 'Patterns and Module Principles' },
      { id: 'js-functional-programming', title: 'Functional Programming Essentials' },
      { id: 'js-pwa-service-workers', title: 'PWA Service Workers and Workbox' },
      { id: 'js-tooling-webpack-ecosystem', title: 'Tooling Webpack Parcel Rollup' },
      { id: 'js-transpilation-babel', title: 'Transpilation with Babel' },
      { id: 'js-code-quality-hooks', title: 'ESLint Husky and Git Hooks' },
      { id: 'js-devtools-debugging', title: 'DevTools Debugging and Profiling' },
      { id: 'js-performance-memory', title: 'Performance and Memory Optimization' },
      { id: 'js-security', title: 'JavaScript Security Basics' },
      { id: 'js-error-handling', title: 'Error Handling and Debugging' },
      { id: 'js-interview-qna', title: 'Interview QnA' },
    ],
  },
  {
    id: 'java',
    label: 'Java',
    fullForm: 'Java Programming Language',
    topics: [
      { id: 'java-introduction', title: 'Introduction and Setup' },
      { id: 'java-jdk-jre-jvm', title: 'JDK JRE JVM and Bytecode' },
      { id: 'java-structure', title: 'Program Structure and Execution Flow' },
      { id: 'java-variables-datatypes', title: 'Variables and Data Types' },
      { id: 'java-operators', title: 'Operators' },
      { id: 'java-control-flow', title: 'Control Flow (if switch loops)' },
      { id: 'java-arrays-strings', title: 'Arrays and Strings' },
      { id: 'java-methods', title: 'Methods and Parameter Passing' },
      { id: 'java-packages-imports', title: 'Packages and Imports' },
      { id: 'java-access-modifiers', title: 'Access Modifiers' },
      { id: 'java-classes-objects', title: 'Classes and Objects' },
      { id: 'java-constructors', title: 'Constructors and Initialization Blocks' },
      { id: 'java-this-super', title: 'this and super Keywords' },
      { id: 'java-static-final', title: 'static final and Constants' },
      { id: 'java-oops-pillars', title: 'OOPS Pillars' },
      { id: 'java-inheritance', title: 'Inheritance and Method Overriding' },
      { id: 'java-polymorphism', title: 'Compile-time and Runtime Polymorphism' },
      { id: 'java-abstraction', title: 'Abstraction and Abstract Classes' },
      { id: 'java-encapsulation', title: 'Encapsulation and Data Hiding' },
      { id: 'java-interfaces', title: 'Interfaces and Default Static Methods' },
      { id: 'java-inner-nested-classes', title: 'Inner and Nested Classes' },
      { id: 'java-enums', title: 'Enums' },
      { id: 'java-wrapper-autoboxing', title: 'Wrapper Classes and Autoboxing' },
      { id: 'java-exception-handling', title: 'Exception Handling' },
      { id: 'java-custom-exceptions', title: 'Custom Exceptions and Best Practices' },
      { id: 'java-generics', title: 'Generics' },
      { id: 'java-collections-overview', title: 'Collections Framework Overview' },
      { id: 'java-list-set-map', title: 'List Set Map and Queue Implementations' },
      { id: 'java-comparator-comparable', title: 'Comparable Comparator and Sorting' },
      { id: 'java-iterators', title: 'Iterators and Enhanced for Loop' },
      { id: 'java-functional-interfaces-lambda', title: 'Functional Interfaces and Lambda' },
      { id: 'java-streams-api', title: 'Streams API' },
      { id: 'java-optional', title: 'Optional and Null-safe Programming' },
      { id: 'java-date-time-api', title: 'Date and Time API' },
      { id: 'java-io-file-handling', title: 'File Handling and Java IO' },
      { id: 'java-nio-path-files', title: 'NIO Path Files and Channels' },
      { id: 'java-serialization', title: 'Serialization and Deserialization' },
      { id: 'java-annotations-reflection', title: 'Annotations and Reflection' },
      { id: 'java-jdbc', title: 'JDBC and Database Connectivity' },
      { id: 'java-multithreading-basics', title: 'Multithreading Basics' },
      { id: 'java-concurrency-api', title: 'Executor Framework and Concurrency API' },
      { id: 'java-synchronization-locks', title: 'Synchronization Locks and Thread Safety' },
      { id: 'java-concurrent-collections', title: 'Concurrent Collections and Atomics' },
      { id: 'java-memory-management-gc', title: 'Memory Management and Garbage Collection' },
      { id: 'java-jvm-performance', title: 'JVM Performance Tuning Basics' },
      { id: 'java-design-principles', title: 'SOLID DRY KISS and Clean Code' },
      { id: 'java-design-patterns-creational', title: 'Creational Design Patterns' },
      { id: 'java-design-patterns-structural', title: 'Structural Design Patterns' },
      { id: 'java-design-patterns-behavioral', title: 'Behavioral Design Patterns' },
      { id: 'java-unit-testing-junit-mockito', title: 'Unit Testing with JUnit and Mockito' },
      { id: 'java-build-tools-maven-gradle', title: 'Build Tools Maven and Gradle' },
      { id: 'java-logging-monitoring', title: 'Logging and Monitoring Basics' },
      { id: 'java-security-basics', title: 'Java Security Basics' },
      { id: 'java-rest-api-basics', title: 'REST API Basics in Java' },
      { id: 'java-interview-qna', title: 'Interview QnA' },
    ],
  },
  {
    id: 'springboot-microservices',
    label: 'Spring Boot + Microservices',
    fullForm: 'Spring Boot Framework and Microservices Architecture',
    topics: [
      { id: 'sbm-introduction', title: 'Introduction and Architecture Overview' },
      { id: 'sbm-spring-core-ioc-di', title: 'Spring Core IoC and Dependency Injection' },
      { id: 'sbm-spring-boot-starters-autoconfig', title: 'Spring Boot Starters and Auto Configuration' },
      { id: 'sbm-project-setup', title: 'Project Setup and Environment Profiles' },
      { id: 'sbm-rest-controllers', title: 'REST Controllers and Request Mapping' },
      { id: 'sbm-validation-exception-handling', title: 'Validation and Global Exception Handling' },
      { id: 'sbm-spring-data-jpa', title: 'Spring Data JPA and Hibernate Basics' },
      { id: 'sbm-jpa-relationships', title: 'Entity Relationships and Fetch Strategies' },
      { id: 'sbm-transactions', title: 'Transactions and Propagation Levels' },
      { id: 'sbm-security-authn-authz', title: 'Spring Security Authentication and Authorization' },
      { id: 'sbm-jwt-oauth2', title: 'JWT and OAuth2 Basics' },
      { id: 'sbm-cache-redis', title: 'Caching with Redis' },
      { id: 'sbm-messaging-kafka-rabbitmq', title: 'Messaging with Kafka and RabbitMQ' },
      { id: 'sbm-testing-unit-integration', title: 'Unit and Integration Testing' },
      { id: 'sbm-openapi-swagger', title: 'API Documentation with OpenAPI Swagger' },
      { id: 'sbm-actuator-observability', title: 'Actuator Metrics and Observability' },
      { id: 'sbm-logging-tracing', title: 'Centralized Logging and Distributed Tracing' },
      { id: 'sbm-containerization-docker', title: 'Containerization with Docker' },
      { id: 'sbm-kubernetes-basics', title: 'Kubernetes Deployment Basics' },
      { id: 'sbm-microservices-fundamentals', title: 'Microservices Fundamentals and Boundaries' },
      { id: 'sbm-service-discovery', title: 'Service Discovery (Eureka or Consul)' },
      { id: 'sbm-config-server', title: 'Centralized Configuration Server' },
      { id: 'sbm-api-gateway', title: 'API Gateway Patterns' },
      { id: 'sbm-resilience-patterns', title: 'Resilience Patterns (Retry Circuit Breaker Bulkhead)' },
      { id: 'sbm-feign-webclient', title: 'Inter-service Communication (Feign and WebClient)' },
      { id: 'sbm-saga-distributed-transactions', title: 'Saga and Distributed Transactions' },
      { id: 'sbm-event-driven-architecture', title: 'Event Driven Architecture' },
      { id: 'sbm-idempotency-consistency', title: 'Idempotency Consistency and Data Integrity' },
      { id: 'sbm-microservices-security', title: 'Microservices Security Patterns' },
      { id: 'sbm-rate-limiting-throttling', title: 'Rate Limiting and Throttling' },
      { id: 'sbm-performance-scalability', title: 'Performance and Scalability Tuning' },
      { id: 'sbm-ci-cd-pipelines', title: 'CI/CD Pipelines for Spring Services' },
      { id: 'sbm-cloud-deployment', title: 'Cloud Deployment Strategies' },
      { id: 'sbm-hexagonal-clean-architecture', title: 'Hexagonal and Clean Architecture' },
      { id: 'sbm-ddd-microservices', title: 'Domain Driven Design in Microservices' },
      { id: 'sbm-versioning-backward-compatibility', title: 'API Versioning and Backward Compatibility' },
      { id: 'sbm-production-checklist', title: 'Production Readiness Checklist' },
      { id: 'sbm-interview-qna', title: 'Interview QnA' },
    ],
  },
  {
    id: 'typescript',
    label: 'TypeScript',
    fullForm: 'TypeScript (Typed superset of JavaScript)',
    topics: [
      { id: 'ts-introduction', title: 'Why TypeScript and Setup' },
      { id: 'ts-types', title: 'Basic Types and Type Inference' },
      { id: 'ts-functions', title: 'Function Types' },
      { id: 'ts-interfaces', title: 'Interfaces and Type Aliases' },
      { id: 'ts-generics', title: 'Generics' },
      { id: 'ts-union-intersection', title: 'Union and Intersection Types' },
      { id: 'ts-classes', title: 'Classes and Access Modifiers' },
      { id: 'ts-utility-types', title: 'Utility Types' },
      { id: 'ts-react', title: 'Using TypeScript with React' },
      { id: 'ts-best-practices', title: 'TypeScript Best Practices' },
    ],
  },
  {
    id: 'react',
    label: 'React (Latest)',
    fullForm: 'React JavaScript Library',
    topics: [
      { id: 'react-introduction', title: 'React Fundamentals' },
      { id: 'react-components-jsx', title: 'Components and JSX (JavaScript XML)' },
      { id: 'react-props-state', title: 'Props and State' },
      { id: 'react-hooks-basics', title: 'Hooks Basics (useState, useEffect)' },
      { id: 'react-forms', title: 'Forms and Controlled Inputs' },
      { id: 'react-routing', title: 'Routing with React Router' },
      { id: 'react-context', title: 'Context API (Application Programming Interface)' },
      { id: 'react-performance', title: 'Performance Optimization' },
      { id: 'react-testing', title: 'Testing Basics' },
      { id: 'react-project-structure', title: 'Project Structure and Standards' },
    ],
  },
  {
    id: 'nextjs',
    label: 'Next.js (Latest)',
    fullForm: 'Next.js React Framework',
    topics: [
      { id: 'next-introduction', title: 'Introduction to Next.js' },
      { id: 'next-routing', title: 'App Router and Nested Routes' },
      { id: 'next-server-client', title: 'Server and Client Components' },
      { id: 'next-data-fetching', title: 'Data Fetching Patterns' },
      { id: 'next-api-routes', title: 'API Routes and Server Actions' },
      { id: 'next-auth', title: 'Authentication Patterns' },
      { id: 'next-seo', title: 'SEO (Search Engine Optimization)' },
      { id: 'next-performance', title: 'Image and Performance Optimization' },
      { id: 'next-deploy', title: 'Deployment Workflow' },
      { id: 'next-best-practices', title: 'Best Practices for Production' },
    ],
  },
  {
    id: 'angular',
    label: 'Angular (Latest)',
    fullForm: 'Angular Framework by Google',
    topics: [
      { id: 'angular-introduction', title: 'Angular Architecture Basics' },
      { id: 'angular-components', title: 'Components and Templates' },
      { id: 'angular-databinding', title: 'Data Binding' },
      { id: 'angular-directives', title: 'Directives and Pipes' },
      { id: 'angular-services-di', title: 'Services and DI (Dependency Injection)' },
      { id: 'angular-routing', title: 'Routing and Lazy Loading' },
      { id: 'angular-forms', title: 'Template and Reactive Forms' },
      { id: 'angular-http', title: 'HTTP (HyperText Transfer Protocol) Client' },
      { id: 'angular-rxjs', title: 'RxJS (Reactive Extensions for JavaScript) Basics' },
      { id: 'angular-testing', title: 'Testing in Angular' },
    ],
  },
  {
    id: 'node-express',
    label: 'Node.js + Express.js',
    fullForm: 'Node.js Runtime and Express.js Framework',
    topics: [
      { id: 'node-introduction', title: 'Node.js Fundamentals' },
      { id: 'node-modules-npm', title: 'Modules and NPM (Node Package Manager)' },
      { id: 'express-introduction', title: 'Express.js Basics' },
      { id: 'express-routing', title: 'Routing and Middleware' },
      { id: 'rest-api', title: 'REST API (Representational State Transfer API) Design' },
      { id: 'auth-jwt', title: 'Authentication with JWT (JSON Web Token)' },
      { id: 'validation', title: 'Validation and Sanitization' },
      { id: 'error-logging', title: 'Error Handling and Logging' },
      { id: 'node-testing', title: 'Testing Backend Endpoints' },
      { id: 'node-deployment', title: 'Deployment and Environment Management' },
    ],
  },
  {
    id: 'mongodb',
    label: 'MongoDB',
    fullForm: 'MongoDB NoSQL Database',
    topics: [
      { id: 'mongo-introduction', title: 'MongoDB Basics and Setup' },
      { id: 'mongo-documents', title: 'Documents and Collections' },
      { id: 'mongo-crud', title: 'CRUD (Create Read Update Delete) Operations' },
      { id: 'mongo-query', title: 'Query Operators and Filtering' },
      { id: 'mongo-indexing', title: 'Indexing and Performance Basics' },
      { id: 'mongo-aggregation', title: 'Aggregation Pipeline' },
      { id: 'mongo-schema-design', title: 'Schema Design Decisions' },
      { id: 'mongo-relations', title: 'Embedding vs Referencing' },
      { id: 'mongo-security', title: 'Security and Backup Basics' },
      { id: 'mongo-mongoose', title: 'Mongoose Integration with Node.js' },
    ],
  },
  {
    id: 'aws-devops',
    label: 'AWS with DevOps Essentials',
    fullForm: 'Amazon Web Services with DevOps Essentials',
    topics: [
      { id: 'aws-cloud-basics', title: 'Cloud and AWS Fundamentals' },
      { id: 'aws-core-services', title: 'Core Services (EC2, S3, IAM, VPC)' },
      { id: 'linux-basics', title: 'Linux Essentials for Cloud Engineers' },
      { id: 'networking-basics', title: 'Networking Basics (DNS, HTTP, HTTPS)' },
      { id: 'docker-basics', title: 'Docker Container Basics' },
      { id: 'ci-cd-intro', title: 'CI/CD (Continuous Integration/Continuous Delivery) Basics' },
      { id: 'aws-deployments', title: 'Deployment Strategies on AWS' },
      { id: 'monitoring-observability', title: 'Monitoring and Observability' },
      { id: 'security-best-practices', title: 'Security and IAM Best Practices' },
      { id: 'devops-project', title: 'Mini End-to-End DevOps Project' },
    ],
  },
  {
    id: 'system-design',
    label: 'System Design',
    fullForm: 'System Design and Scalable Architecture',
    topics: [
      { id: 'sd-introduction', title: 'Introduction' },
      { id: 'sd-what-is-system-design', title: 'What is System Design?' },
      { id: 'sd-high-level-design', title: 'High Level Design' },
      { id: 'sd-low-level-design', title: 'Low Level Design' },
      { id: 'sd-hld-deep-dive', title: 'Detailed HLD Discussion' },
      { id: 'sd-basic-fundamentals', title: 'Basic Fundamentals' },
      { id: 'sd-databases', title: 'Databases' },
      { id: 'sd-consistency-availability', title: 'Consistency and Availability' },
      { id: 'sd-cache', title: 'Cache' },
      { id: 'sd-networking', title: 'Networking' },
      { id: 'sd-load-balancers', title: 'Load Balancers' },
      { id: 'sd-message-queues', title: 'Message Queues' },
      { id: 'sd-monolith-vs-microservices', title: 'Monoliths vs Microservices' },
      { id: 'sd-monitoring-logging', title: 'Monitoring and Logging' },
      { id: 'sd-security', title: 'Security' },
      { id: 'sd-system-design-tradeoffs', title: 'System Design Tradeoffs' },
      { id: 'sd-netflix-hld-example', title: 'Netflix HLD Example' },
      { id: 'sd-lld-deep-dive', title: 'Detailed LLD Discussion' },
      { id: 'sd-oops-concepts', title: 'OOPS Concepts' },
      { id: 'sd-design-patterns', title: 'Design Patterns' },
      { id: 'sd-concurrency-thread-safety', title: 'Concurrency and Thread Safety' },
      { id: 'sd-uml-diagrams', title: 'UML Diagrams' },
      { id: 'sd-apis', title: 'APIs' },
      { id: 'sd-common-lld-problems', title: 'Common LLD Problems' },
      { id: 'sd-interview-qna', title: 'Interview QnA' },
    ],
  },
];

export const HTML_LESSONS = {
  'html-introduction': {
    heading: 'Introduction to HTML',
    easySummary: 'HTML is the language that gives structure and meaning to every web page.',
    theory: [
      'HTML stands for HyperText Markup Language. It is called a markup language because you do not mainly use it to calculate or loop like a programming language. You use it to mark what each piece of content means. A heading is marked as a heading. A paragraph is marked as a paragraph. A link is marked as a link. This meaning is what browsers, screen readers, search engines, and developers depend on.',
      'When a browser receives an HTML file, it starts reading from top to bottom. It does not guess your intention. It depends on the tags you write. If you use a heading tag for a page title, the browser and assistive tools understand that. If you use a random div for everything, the page may still look correct after CSS, but the structure quality becomes weak.',
      'HTML is the first layer of frontend development. CSS comes after HTML to control look and layout. JavaScript comes after that to control behavior, events, and dynamic updates. Students often try to jump quickly to React or JavaScript, but weak HTML knowledge creates confusion later because forms, accessibility, SEO, and component structure all depend on HTML fundamentals.',
      'Good HTML is not only for beginners. In large companies, good HTML reduces bugs, improves maintainability, and makes code review easier. If a senior engineer opens your file and can immediately understand the content hierarchy, your code is already stronger before any design discussion starts.',
      'In interviews, HTML questions often look simple but are used to judge depth. If you explain only definitions, your answer looks shallow. If you explain semantics, browser behavior, accessibility impact, and practical usage, your answer becomes much stronger.',
      'A strong learning path in HTML starts from document structure, moves to common tags one by one, then grows into forms, semantics, accessibility, performance, SEO, and interview preparation. That is why this tree is now split into smaller topic branches.',
    ],
    practicalTips: [
      'Think first about meaning, then about styling.',
      'Use proper indentation so tree structure is visually obvious.',
      'Write a real heading and a real paragraph even in your smallest demo files.',
      'Do not overuse div when a semantic tag already fits better.',
    ],
    examples: [
      {
        title: 'First HTML page',
        description: 'A minimal page with real structure.',
        code: '<!DOCTYPE html>\n<html lang="en">\n  <body>\n    <h1>Welcome to HTML</h1>\n    <p>This is my first structured web page.</p>\n  </body>\n</html>',
        outputHtml: '<h1>Welcome to HTML</h1><p>This is my first structured web page.</p>',
      },
    ],
  },
  'html-browser-basics': {
    heading: 'How Browser Reads HTML',
    easySummary: 'The browser reads HTML and builds a DOM tree before styling and scripting become useful.',
    theory: [
      'A browser reads raw HTML text and converts it into structured nodes in memory. That structure is called the DOM, which stands for Document Object Model. This DOM is the live representation of your page. CSS applies styles on this structure, and JavaScript reads or changes this structure.',
      'The reading process is important because HTML order matters. Content that appears earlier can be parsed earlier. Heavy scripts can block parsing. Poor structure can slow rendering or make debugging more difficult. This is one reason why page performance begins with HTML decisions, not only with later optimization steps.',
      'If you place meaningful content early and keep the document clean, the browser can do its work more efficiently. If the document is deeply nested without reason, full of unnecessary wrappers, or blocked by scripts, rendering becomes harder to reason about.',
      'Interviewers sometimes ask what happens after HTML reaches the browser. A good answer mentions parsing, DOM creation, CSS parsing, render tree, layout, and paint. You do not need a compiler-level answer, but you should clearly understand that HTML is the starting point of all later rendering work.',
      'For students, this topic matters because many later concepts, such as DOM selection, hydration, SEO previews, or accessibility trees, become much easier to understand once you know that the browser is building a structured model from your tags.',
    ],
    practicalTips: [
      'Keep important content higher in the document when possible.',
      'Avoid unnecessary wrappers that only increase DOM depth.',
      'Learn to inspect DOM in browser dev tools while studying examples.',
    ],
    examples: [
      {
        title: 'Simple parse order demo',
        description: 'The browser reads document from top to bottom.',
        code: '<body>\n  <h1>Page Start</h1>\n  <p>Browser parses this content before later nodes.</p>\n  <section>\n    <p>More content comes next.</p>\n  </section>\n</body>',
        outputHtml: '<h1>Page Start</h1><p>Browser parses this content before later nodes.</p><section><p>More content comes next.</p></section>',
      },
    ],
  },
  'html-document-structure': {
    heading: 'HTML Document Structure',
    easySummary: 'Every page should have a predictable outer structure so browsers and tools can understand it correctly.',
    theory: [
      'A standard HTML document starts with <!DOCTYPE html>, then html, head, and body. This is not useless ceremony. Each part has a job. The doctype tells the browser to use standards mode. The html tag wraps the full document. The head stores metadata. The body stores visible page content.',
      'Students often copy code without understanding why this structure exists. The reason is separation of concerns inside the document itself. Metadata, resource hints, and configuration belong in head. Content meant for the user belongs in body. This keeps the file organized and prevents confusion.',
      'When teams build at scale, predictable document structure helps templates, layout systems, SEO tooling, and browser debugging. If different pages mix metadata and body content incorrectly, problems appear in previews, indexing, or rendering behavior.',
      'This structure also teaches discipline. Once you understand that every tag has a valid place and purpose, you naturally write cleaner pages. Clean structure is one of the first signs of a careful frontend engineer.',
      'Interview questions around document structure are usually simple on the surface. The deeper answer is not just naming tags, but explaining why each part exists and what breaks when structure is sloppy.',
    ],
    practicalTips: [
      'Always include lang on the html tag.',
      'Keep metadata in head and visible elements in body.',
      'Use a starter template while learning until structure becomes natural.',
    ],
    examples: [
      {
        title: 'Standard structure',
        description: 'A clean document template for new pages.',
        code: '<!DOCTYPE html>\n<html lang="en">\n  <head>\n    <meta charset="UTF-8" />\n    <title>My Page</title>\n  </head>\n  <body>\n    <h1>Hello</h1>\n  </body>\n</html>',
        outputHtml: '<h1>Hello</h1>',
      },
    ],
  },
  'html-head-tag': {
    heading: 'Head Tag',
    easySummary: 'The head tag stores metadata, resource references, and page-level configuration.',
    theory: [
      'The head tag is not for visible content. It is for information about the page. This includes character encoding, title, viewport settings, SEO metadata, social sharing metadata, icon references, stylesheet links, and script references that belong in head.',
      'Because head content is mostly invisible, beginners sometimes ignore it. That creates poor titles, broken mobile scaling, missing previews, and weak indexing. In production, head quality directly affects how the page appears in browser tabs, search results, and shared links.',
      'The head tag is also important because it controls the environment in which the visible page runs. A missing charset can break text. A missing viewport tag can damage the mobile experience. A missing title makes the page feel unfinished and unprofessional.',
      'From an interview perspective, the head tag is a good place to show that you understand not just tags, but product impact. If someone asks what belongs in head, answer with purpose, not only a list of tags. Explain why title, meta description, viewport, and linked resources matter.',
      'Well-managed head content becomes even more important in frameworks where metadata is generated dynamically. Understanding plain HTML first makes those systems much easier later.',
    ],
    practicalTips: [
      'Never place visible page text inside head.',
      'Write a meaningful title for every page.',
      'Include charset and viewport early in your learning templates.',
    ],
    examples: [
      {
        title: 'Useful head section',
        description: 'A small but practical head block.',
        code: '<head>\n  <meta charset="UTF-8" />\n  <meta name="viewport" content="width=device-width, initial-scale=1.0" />\n  <title>Student Notes</title>\n</head>',
        outputHtml: '<p>Head content does not render as normal body UI.</p>',
      },
    ],
  },
  'html-body-tag': {
    heading: 'Body Tag',
    easySummary: 'The body tag contains the visible and interactive part of a web page.',
    theory: [
      'Everything the user directly sees on the page usually lives inside the body tag. Headings, paragraphs, forms, images, cards, lists, videos, buttons, and sections all appear here. If head is the page configuration area, body is the user-facing area.',
      'The body tag should not be treated like a dumping ground. Good HTML inside body still needs structure. Content should be grouped logically. Main content should be separate from navigation and footer. Headings should introduce sections. Buttons should represent actions, and links should represent navigation.',
      'A clean body makes styling easier because structure reflects meaning. It also makes JavaScript easier because selectors can target predictable content areas instead of fragile random wrappers.',
      'Students often think body is just a container. It is more than that. It is where content architecture becomes visible. If the body is chaotic, the whole page becomes harder to maintain.',
      'In interviews, you can stand out by explaining that strong body structure improves semantics, accessibility, and readability for the entire application.',
    ],
    practicalTips: [
      'Group related content using sections or articles where appropriate.',
      'Do not place metadata or configuration tags meant for head inside body.',
      'Keep body structure readable and intentionally ordered.',
    ],
    examples: [
      {
        title: 'Simple body layout',
        description: 'Visible content goes here.',
        code: '<body>\n  <header><h1>Course Portal</h1></header>\n  <main><p>Welcome to the student dashboard.</p></main>\n</body>',
        outputHtml: '<header><h1>Course Portal</h1></header><main><p>Welcome to the student dashboard.</p></main>',
      },
    ],
  },
  'html-heading-tag': {
    heading: 'Heading Tag',
    easySummary: 'Heading tags define content hierarchy from the most important title to smaller sub-sections.',
    theory: [
      'HTML provides six heading levels: h1 to h6. These are not only visual size tools. They communicate hierarchy. h1 is usually the main page heading. h2 starts major sections. h3 begins sub-sections inside those sections, and so on.',
      'A good heading structure helps readers scan the page quickly. It also helps screen reader users jump between sections. Search engines also use headings as signals for content structure and topic clarity. This means headings matter for both usability and discoverability.',
      'One of the most common beginner mistakes is using heading tags only because they look bold or large. That is incorrect. Visual styling should come from CSS. Heading tags should be chosen based on document meaning and structure.',
      'In interview questions, heading hierarchy often appears in accessibility and SEO discussions. A strong answer mentions hierarchy, readability, screen reader navigation, and why only one primary h1 is usually a good default for a normal page.',
      'If you can explain heading hierarchy clearly, you show that you understand content architecture, not just syntax.',
    ],
    practicalTips: [
      'Use one clear h1 for the main page idea when possible.',
      'Do not skip levels without reason in a simple document.',
      'Use CSS for font size, not wrong heading levels.',
    ],
    examples: [
      {
        title: 'Full heading and text example',
        description: 'This example shows all heading tags from h1 to h6 along with paragraph and common text formatting tags.',
        code: '<!DOCTYPE html>\n<html lang="en">\n  <body>\n    <h1>H1 Main Page Heading</h1>\n    <h2>H2 Section Heading</h2>\n    <h3>H3 Sub-section Heading</h3>\n    <h4>H4 Smaller Heading</h4>\n    <h5>H5 Minor Heading</h5>\n    <h6>H6 Small Label Heading</h6>\n\n    <p>Paragraph text is used for normal reading content. It helps explain ideas clearly in a full sentence or group of sentences.</p>\n\n    <p>\n      <strong>Strong text</strong><br />\n      <em>Emphasized text</em><br />\n      <u>Underlined text</u><br />\n      <s>Strikethrough text</s><br />\n      <mark>Highlighted text</mark><br />\n      <small>Small helper text</small>\n    </p>\n  </body>\n</html>',
        outputHtml: '<h1>H1 Main Page Heading</h1><h2>H2 Section Heading</h2><h3>H3 Sub-section Heading</h3><h4>H4 Smaller Heading</h4><h5>H5 Minor Heading</h5><h6>H6 Small Label Heading</h6><p>Paragraph text is used for normal reading content. It helps explain ideas clearly in a full sentence or group of sentences.</p><p><strong>Strong text</strong><br /><em>Emphasized text</em><br /><u>Underlined text</u><br /><s>Strikethrough text</s><br /><mark>Highlighted text</mark><br /><small>Small helper text</small></p>',
      },
    ],
  },
  'html-paragraph-tag': {
    heading: 'Paragraph Tag',
    easySummary: 'The paragraph tag is used for normal blocks of textual content.',
    theory: [
      'The p tag represents a paragraph of text. It is one of the most common HTML tags because almost every content-heavy page uses paragraphs to explain ideas, describe products, write lessons, or communicate instructions.',
      'A paragraph is not just any text line. It is a meaningful block of related sentences. Browsers automatically give paragraph tags spacing because they are expected to represent separate thought units. This makes reading easier.',
      'Students sometimes use many br tags instead of proper paragraphs. That creates messy structure because line breaks are not the same as content blocks. A paragraph communicates meaning. A line break only changes visual flow.',
      'In production content systems, paragraphs are critical for readability, responsive design, and content extraction. Editors, search engines, assistive tools, and translation systems all benefit from proper paragraph structure.',
      'A solid interview answer about p tags should mention readability, structure, default spacing behavior, and why paragraphs are better than plain text with repeated break tags.',
    ],
    practicalTips: [
      'Use separate p tags for separate ideas.',
      'Avoid using many br tags where proper paragraphs are needed.',
      'Keep paragraph length manageable for easier reading.',
    ],
    examples: [
      {
        title: 'Two real paragraphs',
        description: 'Each paragraph contains one focused idea.',
        code: '<p>HTML gives structure to content.</p>\n<p>CSS adds design and layout on top of that structure.</p>',
        outputHtml: '<p>HTML gives structure to content.</p><p>CSS adds design and layout on top of that structure.</p>',
      },
    ],
  },
  'html-anchor-tag': {
    heading: 'Anchor Tag',
    easySummary: 'The anchor tag creates navigation between pages, sections, files, and external resources.',
    theory: [
      'The anchor tag, written as a, is one of the most important tags on the web because the web itself is built on linking. Without links, pages become isolated documents. With links, content becomes navigable and discoverable.',
      'The href attribute tells the browser where to go when the link is activated. That destination can be another page, an external website, a file download, an email address, a phone number, or even a section on the same page using an id reference.',
      'An anchor tag should be used for navigation, not for actions that only change interface state. If clicking should take the user somewhere, use a. If clicking performs an action like submit, open modal, or toggle visibility, use button. This distinction matters a lot in accessibility and interviews.',
      'Anchor text should be meaningful. Generic text like click here is weak because it gives poor context to users and assistive technology. Good link text tells where the user will go or what they will get.',
      'Advanced discussion around anchor tags includes target, rel, security considerations for new tabs, internal page anchors, crawlability, and how proper linking improves site structure and SEO.',
      'Interviewers often ask the difference between link and button. A strong answer should cover semantics, user expectation, keyboard behavior, and navigation purpose.',
    ],
    practicalTips: [
      'Use meaningful link text instead of vague phrases.',
      'Use rel="noreferrer" or related rel values when opening external pages in new tabs.',
      'Use links for navigation and buttons for actions.',
      'Test keyboard access using the Tab key.',
    ],
    examples: [
      {
        title: 'Internal and external links',
        description: 'One link stays in the project, one opens an external reference.',
        code: '<a href="about.html">About Page</a>\n<br />\n<a href="https://developer.mozilla.org" target="_blank" rel="noreferrer">Open MDN Reference</a>',
        outputHtml: '<a href="#">About Page</a><br /><a href="https://developer.mozilla.org" target="_blank" rel="noreferrer">Open MDN Reference</a>',
      },
    ],
  },
  'html-image-tag': {
    heading: 'Image Tag',
    easySummary: 'The image tag displays visual media and must be used with descriptive alternative text.',
    theory: [
      'The img tag is a void element, which means it does not wrap inner text content like paragraph or heading tags do. Its main job is to embed an image resource in the page using the src attribute.',
      'The alt attribute is essential. It provides alternative text when the image cannot be seen or loaded, and it helps screen readers communicate image meaning. Alt text should describe the function or information of the image, not just repeat that it is an image.',
      'Images affect both user experience and performance. Large images can slow a page heavily. Missing width and height can cause layout shifts. Decorative images and informative images should be handled differently. These are all common discussion points in strong frontend interviews.',
      'In product work, images are not just decoration. They affect loading speed, accessibility, visual trust, conversion, and SEO in some contexts. That is why good engineers think about both content meaning and delivery cost.',
      'A complete answer about img should include src, alt, sizing, performance, and accessibility impact.',
    ],
    practicalTips: [
      'Always decide whether the image is informative or decorative before writing alt text.',
      'Provide width and height where possible to reduce layout shift.',
      'Keep files optimized and avoid oversized assets.',
    ],
    examples: [
      {
        title: 'Image with useful alt',
        description: 'A basic image tag with accessible text.',
        code: '<img src="/main-image.png" alt="Algodoor learning platform preview" width="220" height="124" />',
        outputHtml: '<img src="/main-image.png" alt="Algodoor learning platform preview" width="220" height="124" />',
      },
    ],
  },
  'html-list-tags': {
    heading: 'List Tags',
    easySummary: 'Lists group related items in either unordered or ordered form.',
    theory: [
      'HTML lists are used when content naturally belongs to a grouped set of items. The ul tag creates an unordered list, usually shown with bullets. The ol tag creates an ordered list, usually shown with numbers. Each item inside either list uses the li tag.',
      'Lists make content easier to scan. They are excellent for steps, features, requirements, agendas, FAQs, learning points, and dashboard summaries. When content is list-like, using paragraphs or break tags instead loses structure.',
      'A common mistake is using lists only for styling menus without thinking about meaning. Lists are often appropriate in navigation or grouped content, but you should always ask whether the content truly represents a collection of peer items.',
      'In interviews, list questions may look easy, but they can be used to test how well you understand semantic grouping. A thoughtful answer explains when order matters and why li exists as a dedicated item tag.',
      'Lists are a simple but powerful example of how HTML helps the browser understand relationships between pieces of content.',
    ],
    practicalTips: [
      'Use ul when order does not matter.',
      'Use ol when sequence matters.',
      'Keep each li focused on one item or idea.',
    ],
    examples: [
      {
        title: 'Ordered and unordered lists',
        description: 'A quick example of both list types.',
        code: '<h3>Tools</h3>\n<ul>\n  <li>HTML</li>\n  <li>CSS</li>\n</ul>\n<h3>Learning Order</h3>\n<ol>\n  <li>Structure</li>\n  <li>Styling</li>\n</ol>',
        outputHtml: '<h3>Tools</h3><ul><li>HTML</li><li>CSS</li></ul><h3>Learning Order</h3><ol><li>Structure</li><li>Styling</li></ol>',
      },
    ],
  },
  'html-table-tags': {
    heading: 'Table Tags',
    easySummary: 'Tables should be used for real row-column data, not for page layout.',
    theory: [
      'A table is appropriate when information has a clear grid relationship. Examples include marksheets, schedules, pricing comparisons, attendance, and analytics summaries. HTML provides table, tr, th, and td to express that relationship clearly.',
      'The th tag represents header cells. These cells explain the meaning of a row or column. This is useful both visually and semantically. Screen readers can use header relationships to give better context while reading table data.',
      'In older web development, tables were often misused for full page layout. Modern frontend practice avoids that because layout should be handled with CSS. Tables remain powerful, but only for true tabular data.',
      'A strong interview answer about tables should mention semantics, accessibility, scalability on mobile, and why table markup is still relevant in dashboards and admin systems.',
      'When you use tables correctly, you make dense information much easier to read and compare.',
    ],
    practicalTips: [
      'Use th for headers instead of styling td to look like headers.',
      'Keep tables for data, not layout.',
      'Think about mobile readability when the table grows wider.',
    ],
    examples: [
      {
        title: 'Student score table',
        description: 'A basic but correct data table.',
        code: '<table border="1" cellpadding="6">\n  <tr><th>Name</th><th>Marks</th></tr>\n  <tr><td>Riya</td><td>88</td></tr>\n  <tr><td>Aman</td><td>92</td></tr>\n</table>',
        outputHtml: '<table border="1" cellpadding="6"><tr><th>Name</th><th>Marks</th></tr><tr><td>Riya</td><td>88</td></tr><tr><td>Aman</td><td>92</td></tr></table>',
      },
    ],
  },
  'html-form-tag': {
    heading: 'Form Tag',
    easySummary: 'The form tag creates a submission boundary for collecting user data.',
    theory: [
      'The form tag wraps related inputs that belong to the same submission flow. It defines a unit of data collection. When the user submits, the browser understands which controls are part of that form.',
      'Forms are critical in almost every product: login, signup, profile editing, checkout, contact, filters, feedback, search, and admin workflows. This makes form fundamentals one of the most valuable HTML topics in real development.',
      'A form is not only about putting inputs on screen. It is about trust, clarity, validation, and data quality. Users should understand what is being asked, which fields are required, and what happens on submit.',
      'Interviewers may ask what a form does, how submit behavior works, or when to use GET versus POST. A stronger answer also mentions accessibility, field grouping, labels, and validation responsibilities.',
      'If you understand the form tag well, later frameworks feel easier because they still sit on top of native browser form behavior.',
    ],
    practicalTips: [
      'Use one form per clear submission unit.',
      'Group related controls together inside the form.',
      'Keep submit intent obvious to the user.',
    ],
    examples: [
      {
        title: 'Basic contact form',
        description: 'A form wraps the related inputs and button.',
        code: '<form>\n  <label for="name">Name</label>\n  <input id="name" type="text" />\n  <button type="submit">Send</button>\n</form>',
        outputHtml: '<form><label for="demo-name">Name</label> <input id="demo-name" type="text" /><button type="button">Send</button></form>',
      },
    ],
  },
  'html-input-tag': {
    heading: 'Input Tag',
    easySummary: 'The input tag collects different kinds of small user data through type-based behavior.',
    theory: [
      'The input tag is one of the most flexible HTML elements because it can represent many control types. By changing the type attribute, the same tag can accept text, email, password, number, date, checkbox, radio, file, and more.',
      'This flexibility is powerful, but it also means you need to choose the right type carefully. The right type improves browser behavior, validation, mobile keyboard selection, and overall user experience. For example, email type can help browsers check email format and show a more suitable keyboard on mobile devices.',
      'An input should almost never stand alone without a label in real interfaces. Users need to know what the field means. Screen readers especially depend on proper label association. Placeholder text is not a full replacement for a label.',
      'Interview questions often include differences between input types, validation behavior, checked states, controlled vs uncontrolled usage in frameworks, and accessibility best practices. Native HTML understanding gives you a big advantage in those discussions.',
      'In practical development, input choice affects form quality, conversion, and error rates much more than many beginners expect.',
    ],
    practicalTips: [
      'Choose the correct type instead of defaulting everything to text.',
      'Always connect inputs with labels.',
      'Use required carefully and communicate expectations clearly.',
    ],
    examples: [
      {
        title: 'Different input types',
        description: 'Each input type helps a different data need.',
        code: '<label>Email</label>\n<input type="email" />\n<br /><br />\n<label>Age</label>\n<input type="number" />',
        outputHtml: '<label>Email</label><input type="email" /><br /><br /><label>Age</label><input type="number" />',
      },
    ],
  },
  'html-label-tag': {
    heading: 'Label Tag',
    easySummary: 'The label tag explains what an input means and improves accessibility and usability.',
    theory: [
      'The label tag gives a human-readable name to a form control. Without labels, users may see empty fields and guess what belongs there. Screen reader users face an even bigger problem because the control may have no reliable identity.',
      'A label is usually connected to an input using the for attribute on label and the matching id on the input. When connected properly, clicking the label often focuses or activates the related control. This improves usability for everyone, especially on touch devices and for small controls like checkboxes or radio buttons.',
      'Using placeholders instead of labels is a common mistake. Placeholder text disappears once the user types and may not provide a persistent identity for the field. Labels remain the correct structural solution.',
      'A strong interview answer about labels should include accessibility impact, click behavior, association methods, and why labels matter beyond just visual text.',
      'Good forms feel easier partly because labels remove ambiguity. That makes label tags small but very high-value in real product interfaces.',
    ],
    practicalTips: [
      'Use for and id for a clear label-input connection.',
      'Keep label text direct and specific.',
      'Do not replace labels with placeholders only.',
    ],
    examples: [
      {
        title: 'Connected label and input',
        description: 'The label helps identify and focus the field.',
        code: '<label for="email">Email Address</label>\n<input id="email" type="email" />',
        outputHtml: '<label for="email-view">Email Address</label><input id="email-view" type="email" />',
      },
    ],
  },
  'html-button-tag': {
    heading: 'Button Tag',
    easySummary: 'The button tag represents an action, not navigation.',
    theory: [
      'The button tag is used when the user should perform an action such as submit a form, open a modal, start a process, toggle a panel, or confirm a step. It is different from an anchor tag, which should be used for navigation.',
      'Buttons have useful built-in behavior. They can receive focus properly, they respond to keyboard interaction, and inside forms they can trigger submission behavior depending on the type. This is why using a real button is better than using a div with an onClick handler for action controls.',
      'The type attribute matters. A button inside a form becomes submit by default in many cases. If you only want a UI action and not a form submission, set type="button" explicitly. This is a common interview and debugging topic.',
      'Well-written button text should describe the action clearly. Save, Continue, Send Feedback, and Open Details are much clearer than vague terms. Good button semantics also improve accessibility and product clarity.',
      'In interviews, be ready to explain button vs link, default submit behavior, and keyboard accessibility. These questions are simple but reveal real frontend maturity.',
    ],
    practicalTips: [
      'Use type="button" for non-submit actions inside forms.',
      'Make button text action-oriented.',
      'Use buttons for actions, not page navigation.',
    ],
    examples: [
      {
        title: 'Action button',
        description: 'A proper button for an interface action.',
        code: '<button type="button">Open Details</button>',
        outputHtml: '<button type="button">Open Details</button>',
      },
    ],
  },
  'html-select-tag': {
    heading: 'Select Tag',
    easySummary: 'The select tag lets the user choose one item from a predefined option list.',
    theory: [
      'The select tag is useful when users should choose from a known list of options. It reduces input ambiguity because the user is selecting from values you provide instead of typing free-form content.',
      'Each option inside a select is represented using the option tag. This gives the browser a structured list. In product design, select is useful for course categories, country lists, statuses, filters, and many settings forms.',
      'Select should be used carefully. If the list is too long or needs search, other patterns may work better. But as a native HTML control, select provides good accessibility and browser support when used correctly.',
      'In interviews, select is often discussed in form usability, label association, default values, and accessibility. Native controls usually provide stronger baseline accessibility than complex custom dropdown implementations.',
      'Understanding select helps students appreciate when native HTML is enough and when extra UI complexity is truly justified.',
    ],
    practicalTips: [
      'Connect select with a clear label.',
      'Keep options understandable and consistent.',
      'Avoid huge lists if search or grouping is needed.',
    ],
    examples: [
      {
        title: 'Course selector',
        description: 'A native dropdown list.',
        code: '<label for="course">Choose Course</label>\n<select id="course">\n  <option>HTML</option>\n  <option>CSS</option>\n  <option>JavaScript</option>\n</select>',
        outputHtml: '<label for="course-view">Choose Course</label><select id="course-view"><option>HTML</option><option>CSS</option><option>JavaScript</option></select>',
      },
    ],
  },
  'html-textarea-tag': {
    heading: 'Textarea Tag',
    easySummary: 'The textarea tag collects multi-line user input such as messages, notes, or descriptions.',
    theory: [
      'The textarea tag is used when the user needs more than a short single-line field. It is commonly used for feedback, comments, descriptions, support messages, bios, and explanation boxes.',
      'Unlike input, textarea is designed for larger text blocks. This makes it better suited for cases where users need to write naturally across multiple lines. It also carries different layout expectations in interface design.',
      'Good textarea usage includes clear labels, reasonable sizing, helpful instructions, and sometimes character guidance. When used poorly, users may feel uncertain about how much to write or what the expected format is.',
      'In interviews, textarea is not a difficult syntax topic, but it can be part of broader questions around form usability, validation, and accessibility. Native controls are often better than overbuilt custom alternatives.',
      'As with all text-entry fields, labels and semantics remain important. A large input area without context is still poor UX even if the control itself is correct.',
    ],
    practicalTips: [
      'Use textarea for long-form input only.',
      'Provide a clear label and purpose.',
      'Size the field to match expected content volume.',
    ],
    examples: [
      {
        title: 'Feedback box',
        description: 'A textarea for detailed user input.',
        code: '<label for="feedback">Feedback</label>\n<textarea id="feedback" rows="4" cols="30"></textarea>',
        outputHtml: '<label for="feedback-view">Feedback</label><textarea id="feedback-view" rows="4" cols="30"></textarea>',
      },
    ],
  },
  'html-semantic-tags': {
    heading: 'Semantic Tags',
    easySummary: 'Semantic tags describe what a section of the page means, not only how it looks.',
    theory: [
      'Semantic tags include header, nav, main, section, article, aside, and footer. These tags help define the role of different page regions. That makes the document easier to understand for developers, search engines, and assistive technologies.',
      'Before semantic tags are learned properly, many students build everything using div. A page made from only div tags can sometimes look correct, but the meaning is hidden. Semantic tags reduce that ambiguity and create stronger structure by default.',
      'div and span are non-semantic containers. div is block-level and usually wraps larger layout chunks, while span is inline and wraps small text pieces inside a line. Use them when no semantic tag represents the content role clearly.',
      'section, article, aside, header, and footer are semantic containers. section groups a thematic part of a page, article holds self-contained content, aside contains secondary information, header introduces a page or section, and footer closes a page or section with supporting details.',
      'This matters especially in larger applications because clean semantics make templates easier to review, improve navigation landmarks for screen reader users, and reduce the need for extra ARIA in many common layouts.',
      'Interviewers often ask what semantic HTML means. A good answer should not stop at naming tags. Explain that semantics improve structure, accessibility, maintainability, and sometimes SEO clarity as well.',
      'Semantic HTML is one of the most valuable habits to build early because it improves almost every future page you write.',
    ],
    practicalTips: [
      'Prefer semantic tags when a clear page role exists.',
      'Use main for the central page content region.',
      'Use div/span for grouping and styling hooks only when semantic meaning is not available.',
      'Do not use semantic tags randomly; use them where meaning is accurate.',
    ],
    referenceSections: [
      {
        title: 'div, span, and semantic layout tags',
        intro: 'This is the interview-friendly difference summary most companies expect.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'type', label: 'Type' },
          { key: 'meaning', label: 'Meaning' },
          { key: 'typicalUse', label: 'Typical use' },
        ],
        rows: [
          { tag: '<div>', type: 'Non-semantic block', meaning: 'No specific content role', typicalUse: 'Layout wrappers, grouping blocks' },
          { tag: '<span>', type: 'Non-semantic inline', meaning: 'No specific content role', typicalUse: 'Small inline text styling or hooks' },
          { tag: '<header>', type: 'Semantic sectioning helper', meaning: 'Introductory content', typicalUse: 'Logo, title, primary heading, top actions' },
          { tag: '<section>', type: 'Semantic sectioning content', meaning: 'Thematic grouping of related content', typicalUse: 'Feature sections, chapter sections, grouped topic blocks' },
          { tag: '<article>', type: 'Semantic sectioning content', meaning: 'Self-contained independent content', typicalUse: 'Blog post, card item, discussion post, news item' },
          { tag: '<aside>', type: 'Semantic complementary content', meaning: 'Secondary or supporting information', typicalUse: 'Sidebar notes, tips, related links, ads' },
          { tag: '<footer>', type: 'Semantic sectioning helper', meaning: 'Closing metadata or support content', typicalUse: 'Copyright, author info, bottom links' },
        ],
      },
    ],
    examples: [
      {
        title: 'Semantic layout visual with labels',
        description: 'Structured view showing body, header, section, article, aside, and footer with names written inside.',
        code: '<div style="font-family:Arial,sans-serif;border:2px solid #0f172a;border-radius:12px;padding:12px;background:#f8fafc;max-width:760px;">\n  <div style="font-weight:700;margin-bottom:8px;letter-spacing:0.4px;">BODY</div>\n  <header style="border:2px dashed #2563eb;border-radius:8px;padding:10px;margin-bottom:10px;background:#dbeafe;font-weight:700;">HEADER</header>\n  <div style="display:grid;grid-template-columns:2fr 1fr;gap:10px;">\n    <section style="border:2px dashed #16a34a;border-radius:8px;padding:10px;background:#dcfce7;">\n      <div style="font-weight:700;margin-bottom:8px;">SECTION</div>\n      <article style="border:2px dashed #f59e0b;border-radius:8px;padding:10px;background:#fef3c7;font-weight:700;">ARTICLE</article>\n    </section>\n    <aside style="border:2px dashed #7c3aed;border-radius:8px;padding:10px;background:#ede9fe;font-weight:700;">ASIDE</aside>\n  </div>\n  <footer style="border:2px dashed #e11d48;border-radius:8px;padding:10px;margin-top:10px;background:#ffe4e6;font-weight:700;">FOOTER</footer>\n</div>',
        outputHtml: '<div style="font-family:Arial,sans-serif;border:2px solid #0f172a;border-radius:12px;padding:12px;background:#f8fafc;max-width:760px;"><div style="font-weight:700;margin-bottom:8px;letter-spacing:0.4px;">BODY</div><header style="border:2px dashed #2563eb;border-radius:8px;padding:10px;margin-bottom:10px;background:#dbeafe;font-weight:700;">HEADER</header><div style="display:grid;grid-template-columns:2fr 1fr;gap:10px;"><section style="border:2px dashed #16a34a;border-radius:8px;padding:10px;background:#dcfce7;"><div style="font-weight:700;margin-bottom:8px;">SECTION</div><article style="border:2px dashed #f59e0b;border-radius:8px;padding:10px;background:#fef3c7;font-weight:700;">ARTICLE</article></section><aside style="border:2px dashed #7c3aed;border-radius:8px;padding:10px;background:#ede9fe;font-weight:700;">ASIDE</aside></div><footer style="border:2px dashed #e11d48;border-radius:8px;padding:10px;margin-top:10px;background:#ffe4e6;font-weight:700;">FOOTER</footer></div>',
      },
      {
        title: 'Semantic page regions',
        description: 'A simple layout using semantic landmarks.',
        code: '<header>Site Header</header>\n<nav>Main Navigation</nav>\n<main>\n  <section>Lesson Content</section>\n</main>\n<footer>Footer</footer>',
        outputHtml: '<header>Site Header</header><nav>Main Navigation</nav><main><section>Lesson Content</section></main><footer>Footer</footer>',
      },
    ],
  },
  'html-audio-video-tags': {
    heading: 'Audio and Video Tags',
    easySummary: 'HTML provides native media tags so browsers can play audio and video without heavy custom markup.',
    theory: [
      'The audio and video tags allow you to embed playable media directly into a page. These are native browser features, which means you can often build useful media experiences without complex custom players at the beginning.',
      'Media tags support attributes such as controls, autoplay, loop, muted, poster, and multiple source elements. Choosing these carefully affects both usability and performance. For example, controls usually improve usability, while autoplay can be disruptive unless handled carefully.',
      'Video in particular has product implications around bandwidth, layout, loading strategy, captions, and engagement. HTML gives the structural entry point, but good engineering also considers delivery and accessibility.',
      'In interview settings, you may be asked how video tags differ from iframe embeds, when native media is preferred, and what accessibility concerns exist. Captions, controls, and fallback text are common discussion points.',
      'These tags are a good example of HTML doing more than static text. It can represent rich media while still staying semantic and structured.',
    ],
    practicalTips: [
      'Use controls unless you have a strong custom player reason.',
      'Think about bandwidth before adding large media.',
      'Provide fallback or captions strategy for better accessibility.',
    ],
    examples: [
      {
        title: 'Native video element',
        description: 'A starter video tag with controls.',
        code: `<video controls width="320" poster="/main-image.png">\n  <source src="${LEARN_PORTAL_VIDEO_SOURCE}" type="video/mp4" />\n  Your browser does not support video.\n</video>`,
        outputHtml: `<video controls width="320" poster="/main-image.png"><source src="${LEARN_PORTAL_VIDEO_SOURCE}" type="video/mp4" /></video>`,
      },
    ],
  },
  'html-iframe-tag': {
    heading: 'Iframe Tag',
    easySummary: 'The iframe tag embeds another page or document inside the current page.',
    theory: [
      'An iframe creates a frame that can show another HTML document inside your current page. It is useful for maps, videos, external widgets, documentation previews, and controlled embeds.',
      'Iframes are powerful, but they should be used carefully. They add complexity, can affect performance, and may introduce security concerns depending on what is embedded. They also create a different document context, which means styling and scripting do not work exactly like normal in-page elements.',
      'A very important interview topic is iframe security. The sandbox attribute can restrict what the embedded content is allowed to do. A good frontend engineer knows that embeds are not only layout decisions but also trust and security decisions.',
      'From a product perspective, iframe use should be intentional. If a native element or direct integration is enough, that may be simpler. If isolation is required, iframe becomes more useful.',
      'Understanding iframe helps students think beyond basic tags and toward real-world integration concerns.',
    ],
    practicalTips: [
      'Use title on iframe for accessibility.',
      'Use sandbox when embedding third-party content if possible.',
      'Avoid unnecessary embeds that hurt performance.',
    ],
    examples: [
      {
        title: 'Sandboxed iframe',
        description: 'A safer embed configuration starter.',
        code: `<iframe src="${LEARN_PORTAL_IFRAME_SOURCE}" title="Algodoor Technologies Bangalore" width="320" height="220" style="border:0;" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
        outputHtml: `<iframe src="${LEARN_PORTAL_IFRAME_SOURCE}" title="Algodoor Technologies Bangalore" width="320" height="220" style="border:0;" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
      },
    ],
  },
  'html-meta-tag': {
    heading: 'Meta Tag',
    easySummary: 'Meta tags provide information about the page to the browser and external systems.',
    theory: [
      'Meta tags usually live inside the head section and describe information about the page rather than showing visible content directly. Common uses include charset, viewport, description, theme color, indexing hints, and social preview metadata.',
      'This tag family matters more than many students expect. A missing viewport tag can harm mobile rendering. A missing description can reduce search result clarity. Wrong social metadata can produce weak shared previews.',
      'Meta tags also show how HTML interacts with systems beyond the visible browser window. Search engines, social platforms, and browser behavior all depend on metadata contracts defined here.',
      'In interviews, a good answer about meta tags covers not only syntax but also practical impact. Explain why metadata matters to mobile usability, discoverability, and product presentation.',
      'Meta knowledge becomes especially useful in frameworks, but the foundation is plain HTML. If you know the raw tags first, framework abstractions become much easier to reason about.',
    ],
    practicalTips: [
      'Always include charset and viewport in basic pages.',
      'Use description metadata for page summaries.',
      'Keep metadata aligned with actual page content.',
    ],
    examples: [
      {
        title: 'Common meta tags',
        description: 'A practical head metadata block.',
        code: '<meta charset="UTF-8" />\n<meta name="viewport" content="width=device-width, initial-scale=1.0" />\n<meta name="description" content="Learn HTML from basics to interview level." />',
        outputHtml: '<p>Meta tags work in the head and do not show visible body output by default.</p>',
      },
    ],
  },
  'html-link-tag': {
    heading: 'Link Tag',
    easySummary: 'The link tag connects external resources such as stylesheets, icons, and related metadata files.',
    theory: [
      'The link tag is most commonly used to connect external stylesheets to a page. It lives in the head and tells the browser to fetch and apply related resources. Without it, your CSS file exists but is not attached to the page.',
      'The link tag can also be used for icons, preconnect hints, canonical links, and other resource relationships. So its job is broader than stylesheets alone. It helps the browser understand how the current document relates to external assets or URLs.',
      'Students usually first meet the link tag when adding CSS. That is correct, but interviewers may go further and ask about canonical URLs, favicon links, or resource hints. Understanding link as a relationship tag helps answer those questions better.',
      'This tag is a good example of how HTML can express dependencies and relationships, not only content blocks.',
      'When your stylesheet does not load, link is often the first thing to inspect: path, rel value, and document placement all matter.',
    ],
    practicalTips: [
      'Use rel="stylesheet" when connecting a CSS file.',
      'Keep link tags in head for predictable loading.',
      'Check file paths carefully when styles do not appear.',
    ],
    examples: [
      {
        title: 'Attach a stylesheet',
        description: 'The browser reads this and loads external CSS.',
        code: '<link rel="stylesheet" href="styles.css" />',
        outputHtml: '<p>Link tags connect external resources and do not directly render body content.</p>',
      },
    ],
  },
  'html-script-tag': {
    heading: 'Script Tag',
    easySummary: 'The script tag connects or embeds JavaScript so the page can become interactive.',
    theory: [
      'The script tag is the main bridge between HTML and JavaScript. It can either contain inline script or reference an external JavaScript file using the src attribute. Without script, most dynamic behaviors on a page do not exist.',
      'Script loading strategy matters. A blocking script can pause HTML parsing. That is why attributes such as defer are important. Strong frontend engineers do not only know how to add JavaScript, they also know how loading order affects rendering and performance.',
      'In modern apps, frameworks often handle script management, but underneath those abstractions the browser still follows HTML script behavior rules. That is why learning this at the raw HTML level remains valuable.',
      'Interviewers may ask about defer, async, inline script trade-offs, and when script should be loaded. A good answer mentions parsing impact, execution timing, and page interactivity.',
      'Script is powerful, but the page should still start from solid HTML. Good frontend architecture does not use JavaScript to repair poor structure unnecessarily.',
    ],
    practicalTips: [
      'Prefer external scripts for maintainability.',
      'Use defer for scripts that do not need to block parsing.',
      'Keep structure meaningful even before JavaScript enhancement.',
    ],
    examples: [
      {
        title: 'Deferred script',
        description: 'A common pattern for external JavaScript loading.',
        code: '<script defer src="app.js"></script>',
        outputHtml: '<p>Deferred scripts run after HTML parsing completes.</p>',
      },
    ],
  },
  'html-accessibility': {
    heading: 'Accessibility in HTML',
    easySummary: 'Accessibility means building HTML that works with keyboard, screen readers, zoom, and assistive tech by default.',
    theory: [
      'Accessibility starts at HTML authoring time. If tags are semantic, heading structure is logical, forms are labeled, and interactive controls are keyboard-operable, many accessibility issues are prevented before CSS and JavaScript are added.',
      'WCAG (Web Content Accessibility Guidelines) is the global baseline. WCAG is organized into four principles: Perceivable, Operable, Understandable, and Robust. Teams usually target WCAG 2.1 AA or WCAG 2.2 AA for production-grade public websites.',
      'Level A is the minimum baseline and removes critical blockers. Level AA is the practical industry standard for most products (contrast, resize behavior, form labels, keyboard flow). Level AAA is the strictest level and is used selectively because some criteria are not feasible for all content types.',
      'Use native elements first: button for actions, a for navigation, label + input for forms, fieldset + legend for grouped form controls, table + caption + th for tabular data. Avoid replacing semantic elements with generic div/span + custom roles unless absolutely necessary.',
      'Heading hierarchy should be structured and sequential. Keep one primary h1 per page in most cases, then use h2 for major sections and h3-h6 for nested subsections without skipping levels purely for visual size.',
      'Accessible forms require more than placeholders: each control needs a visible label, errors must be announced and linked to the field, required state must be clear, and helper text should be connected with aria-describedby when needed.',
      'A quick rule: ARIA can enhance semantics but should not fight native HTML. Prefer native behavior first, then add ARIA only when native HTML cannot express the required meaning.',
    ],
    practicalTips: [
      'Ship with keyboard-first checks: Tab, Shift+Tab, Enter, Space, and Escape on all key flows.',
      'Treat WCAG AA as default acceptance criteria for new pages and forms.',
      'Use automated checks plus manual screen-reader and zoom testing before release.',
    ],
    referenceSections: [
      {
        title: 'WCAG levels A vs AA vs AAA',
        intro: 'Practical difference teams should know in interviews and production reviews.',
        columns: [
          { key: 'level', label: 'Level' },
          { key: 'goal', label: 'Goal' },
          { key: 'examples', label: 'Typical expectations' },
        ],
        rows: [
          {
            level: 'A',
            goal: 'Minimum access baseline',
            examples: 'Keyboard access to core actions, basic alt text, no critical traps',
          },
          {
            level: 'AA',
            goal: 'Industry standard for most products',
            examples: 'Good color contrast, scalable text, visible focus, form labels and errors',
          },
          {
            level: 'AAA',
            goal: 'Highest strictness, selective adoption',
            examples: 'Stricter contrast/readability and broader support constraints',
          },
        ],
      },
      {
        title: 'Accessible form checklist (use and avoid)',
        intro: 'What to use and what to avoid while building forms.',
        columns: [
          { key: 'area', label: 'Area' },
          { key: 'use', label: 'Use this' },
          { key: 'avoid', label: 'Avoid this' },
        ],
        rows: [
          {
            area: 'Labels',
            use: 'label with for/id or wrapped input',
            avoid: 'Placeholder-only fields with no label',
          },
          {
            area: 'Grouping',
            use: 'fieldset + legend for related controls',
            avoid: 'Unlabeled groups of radio/checkbox controls',
          },
          {
            area: 'Errors',
            use: 'Inline error text linked via aria-describedby',
            avoid: 'Color-only error indication',
          },
          {
            area: 'Required state',
            use: 'required plus clear text marker',
            avoid: 'Hidden required rules with surprise submit errors',
          },
          {
            area: 'Controls',
            use: 'button type="submit" and semantic inputs',
            avoid: 'Clickable div/span for form submission',
          },
        ],
      },
      {
        title: 'Semantic parent-child structure rules',
        intro: 'Common HTML nesting rules frequently asked in interviews.',
        columns: [
          { key: 'element', label: 'Element' },
          { key: 'shouldContain', label: 'Should contain / be used with' },
          { key: 'shouldNot', label: 'Should not contain / common mistake' },
        ],
        rows: [
          {
            element: 'ul / ol',
            shouldContain: 'li as direct children',
            shouldNot: 'Random text or block content without li',
          },
          {
            element: 'table',
            shouldContain: 'caption, thead/tbody/tfoot, tr, th/td',
            shouldNot: 'Layout-only usage for non-tabular design',
          },
          {
            element: 'select',
            shouldContain: 'option and optional optgroup',
            shouldNot: 'div/span children',
          },
          {
            element: 'fieldset',
            shouldContain: 'legend + grouped controls',
            shouldNot: 'Used only for visual border decoration',
          },
          {
            element: 'label',
            shouldContain: 'Text describing one control',
            shouldNot: 'Disconnected text that is not tied to input',
          },
          {
            element: 'button',
            shouldContain: 'Action text/icons and proper type',
            shouldNot: 'Anchor behavior for page navigation',
          },
          {
            element: 'a',
            shouldContain: 'Navigational destination with href',
            shouldNot: 'Action-only behavior without valid navigation intent',
          },
        ],
      },
      {
        title: 'Heading hierarchy rules',
        intro: 'Simple heading standards for accessible and SEO-friendly pages.',
        columns: [
          { key: 'rule', label: 'Rule' },
          { key: 'reason', label: 'Reason' },
        ],
        rows: [
          { rule: 'Use one primary h1 in most page layouts', reason: 'Clear top-level topic for users and crawlers' },
          { rule: 'Follow h1 -> h2 -> h3 order based on section depth', reason: 'Improves navigation for assistive tech' },
          { rule: 'Do not skip heading levels only for visual size', reason: 'Breaks document outline logic' },
          { rule: 'Use CSS for appearance, not heading misuse', reason: 'Keeps semantics correct and maintainable' },
          { rule: 'Keep headings meaningful and concise', reason: 'Faster scan and stronger comprehension' },
        ],
      },
      {
        title: 'Quick accessibility anti-patterns',
        intro: 'Common mistakes to avoid in interviews and production code review.',
        columns: [
          { key: 'antiPattern', label: 'Anti-pattern' },
          { key: 'better', label: 'Better approach' },
        ],
        rows: [
          { antiPattern: 'div onClick for critical actions', better: 'Use button and keyboard semantics by default' },
          { antiPattern: 'No visible focus styles', better: 'Keep a strong focus indicator for keyboard users' },
          { antiPattern: 'Image with empty or wrong alt', better: 'Meaningful alt text or decorative empty alt intentionally' },
          { antiPattern: 'Form errors shown only in toast', better: 'Inline field error + summary + focus to first invalid field' },
          { antiPattern: 'Color-only state communication', better: 'Add text/icon pattern and ARIA states where needed' },
        ],
      },
    ],
    examples: [
      {
        title: 'Accessible form structure starter',
        description: 'Shows semantic grouping, explicit labels, helper text, and required indicators.',
        code: '<form aria-labelledby="signup-title">\n  <h2 id="signup-title">Sign up</h2>\n  <fieldset>\n    <legend>Account details</legend>\n\n    <label for="name">Full name <span aria-hidden="true">*</span></label>\n    <input id="name" name="name" type="text" required aria-describedby="name-help" />\n    <p id="name-help">Use your legal name as per ID.</p>\n\n    <label for="email">Email <span aria-hidden="true">*</span></label>\n    <input id="email" name="email" type="email" required />\n\n    <button type="submit">Create account</button>\n  </fieldset>\n</form>',
        outputHtml: '<form aria-labelledby="signup-title"><h2 id="signup-title">Sign up</h2><fieldset><legend>Account details</legend><label for="name">Full name <span aria-hidden="true">*</span></label><input id="name" name="name" type="text" required aria-describedby="name-help" /><p id="name-help">Use your legal name as per ID.</p><label for="email">Email <span aria-hidden="true">*</span></label><input id="email" name="email" type="email" required /><button type="submit">Create account</button></fieldset></form>',
      },
      {
        title: 'Heading hierarchy skeleton',
        description: 'Demonstrates clean heading order for section depth.',
        code: '<h1>HTML Accessibility Guide</h1>\n<section>\n  <h2>Keyboard Access</h2>\n  <h3>Focus Order</h3>\n  <h3>Visible Focus</h3>\n</section>\n<section>\n  <h2>Accessible Forms</h2>\n  <h3>Labels and Errors</h3>\n</section>',
        outputHtml: '<h1>HTML Accessibility Guide</h1><section><h2>Keyboard Access</h2><h3>Focus Order</h3><h3>Visible Focus</h3></section><section><h2>Accessible Forms</h2><h3>Labels and Errors</h3></section>',
      },
    ],
  },
  'html-seo-basics': {
    heading: 'SEO Basics with HTML',
    easySummary: 'SEO starts with clear structure, strong metadata, and crawlable content.',
    theory: [
      'Search Engine Optimization, or SEO, is not only about keywords. HTML plays a major role because search engines depend on structure, headings, links, metadata, and content clarity to understand the page.',
      'A meaningful title, useful meta description, logical heading order, good internal links, and semantic structure make a page easier to interpret. HTML cannot guarantee top ranking, but weak HTML can definitely make understanding harder for search systems.',
      'Students often think SEO belongs only to marketing. In reality, frontend engineers heavily influence SEO through markup quality, metadata management, rendering decisions, and performance-sensitive HTML structure.',
      'Interviewers may ask which HTML parts help SEO. A strong answer includes title, meta description, heading hierarchy, anchor text, semantic structure, image alt where relevant, and crawlable content organization.',
      'Learning SEO basics at the HTML layer makes you more valuable because your pages are not only functional, but also discoverable and understandable.',
    ],
    practicalTips: [
      'Write one clear page title and a matching description.',
      'Use headings to reflect real content structure.',
      'Create meaningful internal links between related topics or pages.',
    ],
    examples: [
      {
        title: 'SEO-oriented head block',
        description: 'Basic metadata for indexing clarity.',
        code: '<title>Learn HTML Anchor Tag</title>\n<meta name="description" content="Understand the anchor tag with theory and examples." />',
        outputHtml: '<p>Title and description help browsers and search engines understand the page.</p>',
      },
    ],
  },
  'html-performance': {
    heading: 'HTML Performance Basics',
    easySummary: 'Better HTML structure and loading choices can make pages feel faster and more stable.',
    theory: [
      'Performance is often discussed in JavaScript terms, but HTML contributes from the very beginning. A clean structure, correct media sizing, good script loading, and early important content all help the page feel faster.',
      'One major issue is layout shift. If an image loads without known dimensions, the page may jump. If scripts block parsing, content may appear later than necessary. If the document is deeply bloated, debugging and rendering become harder.',
      'HTML also affects how soon users see meaningful content. The order of your content in the document matters. The browser can only render what it has already parsed and prepared.',
      'In interviews, performance questions often connect HTML with Core Web Vitals, lazy loading, render-blocking resources, and layout stability. Even at beginner level, understanding these relationships helps you speak like a stronger engineer.',
      'Good performance work is rarely one big trick. It is many small good decisions, and HTML is one of the earliest places where those decisions begin.',
    ],
    practicalTips: [
      'Set width and height on images where possible.',
      'Use loading="lazy" for non-critical images.',
      'Avoid blocking scripts when they are not necessary.',
    ],
    examples: [
      {
        title: 'Stable image loading',
        description: 'Dimensions help reduce layout jump.',
        code: '<img src="/main-image.png" alt="Hero banner" width="320" height="180" loading="lazy" />',
        outputHtml: '<img src="/main-image.png" alt="Hero banner" width="320" height="180" loading="lazy" />',
      },
    ],
  },
};

export const HTML_INTERVIEW_QNA = [
  {
    section: 'Beginner Round',
    questions: [
      {
        id: 'qna-html-1',
        question: 'What is HTML and how is it different from CSS and JavaScript?',
        resourceTopicId: 'html-introduction',
      },
      {
        id: 'qna-html-2',
        question: 'What is the purpose of head and body in an HTML document?',
        resourceTopicId: 'html-document-structure',
      },
      {
        id: 'qna-html-3',
        question: 'Why is <!DOCTYPE html> required and what happens if it is missing?',
        resourceTopicId: 'html-comment-doctype',
      },
      {
        id: 'qna-html-4',
        question: 'What is the difference between block and inline elements with examples?',
        resourceTopicId: 'html-common-text-tags',
      },
      {
        id: 'qna-html-5',
        question: 'What is the difference between an anchor tag and a button tag?',
        resourceTopicId: 'html-anchor-tag',
      },
      {
        id: 'qna-html-6',
        question: 'Why is the label tag important in forms and accessibility?',
        resourceTopicId: 'html-label-tag',
      },
      {
        id: 'qna-html-7',
        question: 'Why should every page have a logical heading hierarchy starting from h1?',
        resourceTopicId: 'html-heading-tag',
      },
      {
        id: 'qna-html-8',
        question: 'What is alt text and when should alt be empty versus descriptive?',
        resourceTopicId: 'html-image-tag',
      },
      {
        id: 'qna-html-9',
        question: 'What are semantic tags and why are they better than only div wrappers?',
        resourceTopicId: 'html-semantic-tags',
      },
      {
        id: 'qna-html-10',
        question: 'What is accessibility in HTML in simple terms?',
        resourceTopicId: 'html-accessibility',
      },
    ],
  },
  {
    section: 'Intermediate Round',
    questions: [
      {
        id: 'qna-html-11',
        question: 'What are WCAG guidelines and why do frontend teams follow them?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-12',
        question: 'Explain the difference between WCAG Level A, AA, and AAA.',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-13',
        question: 'How do fieldset and legend improve form usability and accessibility?',
        resourceTopicId: 'html-fieldset-legend-tags',
      },
      {
        id: 'qna-html-14',
        question: 'What are essential rules for creating accessible forms in HTML?',
        resourceTopicId: 'html-form-tag',
      },
      {
        id: 'qna-html-15',
        question: 'Which HTML elements should be used for actions vs navigation and why?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-16',
        question: 'What is the difference between oninput and onchange events in forms?',
        resourceTopicId: 'html-event-attributes',
      },
      {
        id: 'qna-html-17',
        question: 'What is the difference between id and class attributes, and when should each be used?',
        resourceTopicId: 'html-attributes-core',
      },
      {
        id: 'qna-html-18',
        question: 'How should lists and tables be structured with correct parent-child relationships?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-19',
        question: 'How does proper HTML improve accessibility before ARIA is added?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-20',
        question: 'How should images be authored in HTML for both accessibility and performance?',
        resourceTopicId: 'html-image-tag',
      },
      {
        id: 'qna-html-21',
        question: 'When should you use table captions, and why are they important in data tables?',
        resourceTopicId: 'html-caption-tag',
      },
      {
        id: 'qna-html-22',
        question: 'How does the browser parse HTML and build the DOM?',
        resourceTopicId: 'html-browser-basics',
      },
      {
        id: 'qna-html-23',
        question: 'What is the purpose of meta tags in SEO and mobile rendering?',
        resourceTopicId: 'html-meta-tag',
      },
      {
        id: 'qna-html-24',
        question: 'What are common accessibility anti-patterns in HTML code reviews?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-25',
        question: 'How do you verify keyboard accessibility without using a mouse?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-26',
        question: 'Which form-related elements require strict parent-child structure (for example select-option and fieldset-legend)?',
        resourceTopicId: 'html-accessibility',
      },
    ],
  },
  {
    section: 'Advanced and FAANG-Level Round',
    questions: [
      {
        id: 'qna-html-27',
        question: 'How would you define an accessibility acceptance checklist for a new page?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-28',
        question: 'How do heading hierarchy mistakes affect accessibility audits and SEO together?',
        resourceTopicId: 'html-heading-tag',
      },
      {
        id: 'qna-html-29',
        question: 'How do HTML structure decisions affect performance and rendering?',
        resourceTopicId: 'html-performance',
      },
      {
        id: 'qna-html-30',
        question: 'How do you prevent keyboard traps and broken focus order in dialogs and overlays?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-31',
        question: 'How do async and defer differ for script loading, and when should each be used?',
        resourceTopicId: 'html-script-tag',
      },
      {
        id: 'qna-html-32',
        question: 'How would you approach browser support for newer HTML features in production?',
        resourceTopicId: 'html-browser-support',
      },
      {
        id: 'qna-html-33',
        question: 'What security concerns should you remember while using iframe and external links?',
        resourceTopicId: 'html-iframe-tag',
      },
      {
        id: 'qna-html-34',
        question: 'How do you use media element APIs (play, pause, currentTime events) in real products?',
        resourceTopicId: 'html-media-dom-api',
      },
      {
        id: 'qna-html-35',
        question: 'Why is URL encoding important in query params and dynamic links?',
        resourceTopicId: 'html-url-encoding',
      },
      {
        id: 'qna-html-36',
        question: 'Why should lang be set correctly at page and component level for multilingual content?',
        resourceTopicId: 'html-language-codes',
      },
      {
        id: 'qna-html-37',
        question: 'How would you explain semantic HTML, accessibility, and SEO together in one architecture answer?',
        resourceTopicId: 'html-semantic-tags',
      },
      {
        id: 'qna-html-38',
        question: 'When should ARIA be added, and when should native HTML be preferred?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-39',
        question: 'How would you make a complex multi-step form accessible for keyboard and screen reader users?',
        resourceTopicId: 'html-form-tag',
      },
      {
        id: 'qna-html-40',
        question: 'Why do strong frontend interviews still ask simple tags like a, img, button, and form?',
        resourceTopicId: 'html-introduction',
      },
      {
        id: 'qna-html-41',
        question: 'When modernizing old code, which deprecated HTML tags should be replaced first and why?',
        resourceTopicId: 'html-legacy-tags',
      },
      {
        id: 'qna-html-42',
        question: 'How do link tags in head influence performance and page behavior?',
        resourceTopicId: 'html-link-tag',
      },
      {
        id: 'qna-html-43',
        question: 'What is the difference between aria-* attributes and semantic HTML usage?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-44',
        question: 'How would you structure a production-ready form for usability, validation, and accessibility?',
        resourceTopicId: 'html-form-tag',
      },
      {
        id: 'qna-html-45',
        question: 'What are the most common incorrect parent-child HTML structures that break accessibility?',
        resourceTopicId: 'html-accessibility',
      },
      {
        id: 'qna-html-46',
        question: 'What trade-offs do you consider when embedding third-party content via iframe?',
        resourceTopicId: 'html-iframe-tag',
      },
      {
        id: 'qna-html-47',
        question: 'How does good HTML improve maintainability in large frontend codebases?',
        resourceTopicId: 'html-document-structure',
      },
      {
        id: 'qna-html-48',
        question: 'How would you optimize media-heavy HTML pages without breaking user experience?',
        resourceTopicId: 'html-audio-video-tags',
      },
      {
        id: 'qna-html-49',
        question: 'How do global attributes like data-* and aria-* help in scalable frontend apps?',
        resourceTopicId: 'html-global-attributes',
      },
      {
        id: 'qna-html-50',
        question: 'What are your must-check HTML items before shipping a page to production?',
        resourceTopicId: 'html-seo-basics',
      },
      {
        id: 'qna-html-51',
        question: 'Explain end-to-end browser request lifecycle from click to rendered response.',
        resourceTopicId: 'html-request-lifecycle',
      },
      {
        id: 'qna-html-52',
        question: 'How do srcset, sizes, and picture improve responsive image delivery?',
        resourceTopicId: 'html-responsive-images',
      },
      {
        id: 'qna-html-53',
        question: 'How do you implement accessible form validation using native attributes and validation APIs?',
        resourceTopicId: 'html-forms-validation',
      },
      {
        id: 'qna-html-54',
        question: 'How does atomic design improve consistency in a large frontend codebase?',
        resourceTopicId: 'html-atomic-design-systems',
      },
      {
        id: 'qna-html-55',
        question: 'How would you align semantic HTML decisions with design-system components?',
        resourceTopicId: 'html-atomic-design-systems',
      },
    ],
  },
];

const BROWSER_SUPPORT_COLUMNS = [
  { key: 'tag', label: 'Element' },
  { key: 'chrome', label: 'Chrome', icon: 'chrome', iconLabel: 'C' },
  { key: 'edge', label: 'Edge', icon: 'edge', iconLabel: 'E' },
  { key: 'firefox', label: 'Firefox', icon: 'firefox', iconLabel: 'F' },
  { key: 'safari', label: 'Safari', icon: 'safari', iconLabel: 'S' },
  { key: 'opera', label: 'Opera', icon: 'opera', iconLabel: 'O' },
];

Object.assign(HTML_LESSONS, {
  'html-description-tags': {
    heading: 'Description List Tags',
    easySummary: 'Use dl, dt, and dd when content is a term-and-description pair.',
    theory: [
      'Description lists are useful when you are not showing a normal bullet list, but a set of named terms with matching explanations. Common use cases include glossaries, FAQs with very short answers, product metadata, configuration labels, and interview definitions.',
      'The dl tag wraps the full list. The dt tag defines the term, and the dd tag defines the description or value. This is better than using random paragraphs because the relationship between the label and its explanation becomes explicit in the markup.',
      'Students often forget description lists because ul and ol are more common. But in real products, dl is very useful when content has a clear key-value or concept-definition shape. Understanding it improves both semantics and readability.',
    ],
    practicalTips: [
      'Use description lists for terms and definitions, not for every list on the page.',
      'Keep each term clear and each description focused.',
      'Style them with CSS later, but keep semantic pairing in HTML first.',
    ],
    referenceSections: [
      {
        title: 'Core tags in a description list',
        intro: 'These three tags work together as one semantic unit.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'usage', label: 'Typical usage' },
        ],
        rows: [
          { tag: '<dl>', purpose: 'Wraps the description list', usage: 'Glossary, key-value info, definitions' },
          { tag: '<dt>', purpose: 'Defines the term or label', usage: 'HTML, CSS, API, Username' },
          { tag: '<dd>', purpose: 'Defines the explanation or value', usage: 'Meaning of term, supporting definition' },
        ],
      },
    ],
    examples: [
      {
        title: 'Simple glossary example',
        description: 'A description list works well for definitions.',
        code: '<dl>\n  <dt>HTML</dt>\n  <dd>Structure of the web page.</dd>\n  <dt>CSS</dt>\n  <dd>Styling and layout of the page.</dd>\n</dl>',
        outputHtml: '<dl><dt><strong>HTML</strong></dt><dd>Structure of the web page.</dd><dt><strong>CSS</strong></dt><dd>Styling and layout of the page.</dd></dl>',
      },
    ],
  },
  'html-caption-tag': {
    heading: 'Caption Tag',
    easySummary: 'The caption tag gives a table a visible title and context.',
    theory: [
      'A table without context can be hard to understand. The caption tag solves that by adding a short title or explanation directly tied to the table. This makes the data clearer for both sighted users and assistive technologies.',
      'The caption tag belongs inside a table and usually appears at the top. It should describe what the table is about, not just repeat the surrounding heading. In dashboards and reports, captions are useful because tables often appear in repeated patterns with similar columns.',
      'Students sometimes ignore caption because the table already has headers. But headers explain columns, while caption explains the overall purpose of the whole table.',
    ],
    practicalTips: [
      'Use caption when the table needs a quick overall label.',
      'Keep caption short but meaningful.',
      'Do not confuse column headers with table caption.',
    ],
    referenceSections: [
      {
        title: 'Caption in table structure',
        intro: 'Caption adds meaning at the table level, while th explains row or column meaning.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'role', label: 'Role' },
          { key: 'note', label: 'Note' },
        ],
        rows: [
          { tag: '<caption>', role: 'Table title', note: 'Appears as a label for the whole table' },
          { tag: '<th>', role: 'Header cell', note: 'Explains a specific row or column meaning' },
        ],
      },
    ],
    examples: [
      {
        title: 'Table with caption',
        description: 'A better table includes a caption for context.',
        code: '<table border="1" cellpadding="6">\n  <caption>Monthly Attendance</caption>\n  <tr><th>Name</th><th>Days</th></tr>\n  <tr><td>Riya</td><td>24</td></tr>\n</table>',
        outputHtml: '<table border="1" cellpadding="6"><caption>Monthly Attendance</caption><tr><th>Name</th><th>Days</th></tr><tr><td>Riya</td><td>24</td></tr></table>',
      },
    ],
  },
  'html-fieldset-legend-tags': {
    heading: 'Fieldset and Legend',
    easySummary: 'Fieldset groups related form controls and legend gives that group a visible label.',
    theory: [
      'Forms become easier to understand when related controls are grouped together. The fieldset tag creates that grouping, and the legend tag names the group. This is helpful in address sections, billing blocks, account preferences, and multi-part forms.',
      'Legend is important because it gives meaning to the whole group, not just one input. Screen readers can use that context to help users understand how multiple fields belong together. That makes fieldset and legend much more than just visual wrappers.',
      'Many students create grouped forms with only div tags. That may work visually, but it loses the explicit group meaning that native form markup provides.',
    ],
    practicalTips: [
      'Use fieldset when several controls represent one logical section.',
      'Write a clear legend that describes the group purpose.',
      'Do not use legend as decoration only; use it as a true group label.',
    ],
    referenceSections: [
      {
        title: 'Grouping tags for forms',
        intro: 'These tags improve form structure and accessibility.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'example', label: 'Typical example' },
        ],
        rows: [
          { tag: '<fieldset>', purpose: 'Groups related controls', example: 'Contact info, payment info' },
          { tag: '<legend>', purpose: 'Names the group', example: 'Personal Details, Billing Address' },
        ],
      },
    ],
    examples: [
      {
        title: 'Grouped contact section',
        description: 'Legend makes the form group clear.',
        code: '<form>\n  <fieldset>\n    <legend>Contact Details</legend>\n    <label for="phone">Phone</label>\n    <input id="phone" type="tel" />\n  </fieldset>\n</form>',
        outputHtml: '<form><fieldset><legend>Contact Details</legend><label for="phone-render">Phone</label><input id="phone-render" type="tel" /></fieldset></form>',
      },
    ],
  },
  'html-common-text-tags': {
    heading: 'Common Text Tags',
    easySummary: 'HTML has many small text tags that add meaning, emphasis, or context to inline content.',
    theory: [
      'Not all text is the same. Sometimes a word is an abbreviation, sometimes it is inserted or deleted text, sometimes it marks a date, and sometimes it needs direction control. HTML provides many small tags so text meaning is not lost.',
      'This matters because semantic inline tags improve accessibility, readability, and machine understanding. A highlighted word should not be treated the same as deleted text. A keyboard key hint should not be treated the same as a variable name.',
      'Many of these tags look minor, but they are useful in documentation, admin panels, tutorials, international content, and product UI copy.',
    ],
    practicalTips: [
      'Choose the tag based on meaning, not only appearance.',
      'Use CSS later for look; keep HTML responsible for intent.',
      'Do not force every visual effect into HTML when CSS can handle appearance better.',
    ],
    referenceSections: [
      {
        title: 'Frequently used text-level elements',
        intro: 'These inline tags are small but useful in real interfaces and content systems.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'description', label: 'Simple meaning' },
          { key: 'status', label: 'Status' },
        ],
        rows: [
          { tag: '<abbr>', description: 'Abbreviation or acronym', status: 'Yes' },
          { tag: '<address>', description: 'Contact information', status: 'Yes' },
          { tag: '<b>', description: 'Attention without extra importance', status: 'Yes' },
          { tag: '<bdi>', description: 'Text isolation for mixed direction', status: 'Yes' },
          { tag: '<bdo>', description: 'Override text direction', status: 'Yes' },
          { tag: '<br>', description: 'Single line break', status: 'Yes' },
          { tag: '<data>', description: 'Machine-readable value with visible label', status: 'Yes' },
          { tag: '<del>', description: 'Deleted text', status: 'Yes' },
          { tag: '<dfn>', description: 'Term being defined', status: 'Yes' },
          { tag: '<em>', description: 'Emphasized text', status: 'Yes' },
          { tag: '<i>', description: 'Alternate voice or mood', status: 'Yes' },
          { tag: '<ins>', description: 'Inserted text', status: 'Yes' },
          { tag: '<mark>', description: 'Highlighted text', status: 'Yes' },
          { tag: '<small>', description: 'Side note or fine print', status: 'Yes' },
          { tag: '<sub>', description: 'Subscript text', status: 'Yes' },
          { tag: '<sup>', description: 'Superscript text', status: 'Yes' },
          { tag: '<time>', description: 'Specific date or time', status: 'Yes' },
          { tag: '<u>', description: 'Distinct text styling', status: 'Yes' },
          { tag: '<wbr>', description: 'Possible word-break point', status: 'Yes' },
        ],
        notes: [
          'Use <abbr> when a short form needs expansion help through title or nearby explanation.',
          'Use <time> when the content represents a real date or time value.',
          'Use <u> carefully because users may confuse it with a link if styling is unclear.',
        ],
      },
    ],
    examples: [
      {
        title: 'Inline text semantics demo',
        description: 'Several small text tags used in one paragraph.',
        code: '<p><abbr title="Application Programming Interface">API</abbr> docs were <mark>updated</mark> on <time datetime="2026-07-22">22 July 2026</time>. Press <kbd>Ctrl</kbd> + <kbd>S</kbd> to save.</p>',
        outputHtml: '<p><abbr title="Application Programming Interface">API</abbr> docs were <mark>updated</mark> on <time datetime="2026-07-22">22 July 2026</time>. Press <kbd>Ctrl</kbd> + <kbd>S</kbd> to save.</p>',
      },
    ],
  },
  'html-quote-code-tags': {
    heading: 'Quote and Code Tags',
    easySummary: 'Use quote and code-related tags when content represents citations, code, keyboard input, or program output.',
    theory: [
      'Technical content and documentation often need more than plain paragraphs. HTML provides tags for inline quotes, block quotes, code samples, preformatted text, keyboard shortcuts, program output, and variable names.',
      'These tags matter because code and quoted text should be understood differently from normal prose. A keyboard shortcut should not be marked like an emphasis tag, and a block quote should not be built from a random div and italics.',
      'In learning platforms and documentation-heavy products, these tags make lessons clearer and more structured.',
    ],
    practicalTips: [
      'Use <pre> when spacing and line breaks must be preserved.',
      'Use <code> for code fragments, not for entire visual boxes alone.',
      'Use <blockquote> only for longer quoted sections from another source.',
    ],
    referenceSections: [
      {
        title: 'Quote and developer text elements',
        intro: 'These tags are common in tutorials, docs, and admin interfaces.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'bestUse', label: 'Best use' },
        ],
        rows: [
          { tag: '<blockquote>', purpose: 'Long quoted section', bestUse: 'Quoted paragraph from a source' },
          { tag: '<q>', purpose: 'Short inline quote', bestUse: 'Quoted phrase inside sentence' },
          { tag: '<cite>', purpose: 'Title of a work', bestUse: 'Book, article, film title' },
          { tag: '<code>', purpose: 'Inline code snippet', bestUse: 'Variable, function, tag name' },
          { tag: '<pre>', purpose: 'Preformatted block', bestUse: 'Code block or preserved spacing' },
          { tag: '<kbd>', purpose: 'Keyboard input', bestUse: 'Ctrl, Enter, Esc' },
          { tag: '<samp>', purpose: 'Program output', bestUse: 'Console response text' },
          { tag: '<var>', purpose: 'Variable name', bestUse: 'Math or code variable' },
        ],
      },
    ],
    examples: [
      {
        title: 'Code and keyboard example',
        description: 'Useful for tutorials and docs.',
        code: '<p>Use <code>encodeURIComponent()</code> to encode a URL part. Press <kbd>Enter</kbd> to submit.</p>\n<pre>&lt;a href="about.html"&gt;About&lt;/a&gt;</pre>',
        outputHtml: '<p>Use <code>encodeURIComponent()</code> to encode a URL part. Press <kbd>Enter</kbd> to submit.</p><pre>&lt;a href="about.html"&gt;About&lt;/a&gt;</pre>',
      },
    ],
  },
  'html-figure-tags': {
    heading: 'Figure and Figcaption',
    easySummary: 'Figure groups self-contained media and figcaption explains it.',
    theory: [
      'When an image, chart, code block, or illustration has its own identity inside the content, figure is often a good semantic choice. Figcaption adds the visible explanation or caption for that item.',
      'This is useful when media belongs conceptually together. An image with a description below it is stronger semantically inside figure than as unrelated tags placed near each other.',
      'Figure and figcaption are helpful in articles, learning platforms, blog posts, product explainers, and documentation.',
    ],
    practicalTips: [
      'Use figure when media and its caption are one logical unit.',
      'Keep figcaption short and helpful.',
      'Do not overuse figure for every decorative image.',
    ],
    referenceSections: [
      {
        title: 'Media grouping tags',
        intro: 'These tags help tie media and caption together semantically.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'role', label: 'Role' },
          { key: 'usage', label: 'Usage' },
        ],
        rows: [
          { tag: '<figure>', role: 'Wraps standalone media/content', usage: 'Image, chart, code sample' },
          { tag: '<figcaption>', role: 'Caption for the figure', usage: 'Explain image, source, note' },
        ],
      },
    ],
    examples: [
      {
        title: 'Image with figcaption',
        description: 'A cleaner pattern for meaningful media.',
        code: '<figure>\n  <img src="/main-image.png" alt="Algodoor platform preview" width="240" />\n  <figcaption>Preview of the Algodoor learning platform interface.</figcaption>\n</figure>',
        outputHtml: '<figure><img src="/main-image.png" alt="Algodoor platform preview" width="240" /><figcaption>Preview of the Algodoor learning platform interface.</figcaption></figure>',
      },
    ],
  },
  'html-details-dialog-tags': {
    heading: 'Details, Summary, Dialog, and Search',
    easySummary: 'These tags help build expandable content, dialogs, and focused content regions.',
    theory: [
      'The details and summary tags are useful when content can stay hidden until needed. They are great for FAQs, extra notes, and collapsible explanations without needing a custom JavaScript widget first.',
      'Dialog is meant for dialog windows and modal-like interactions. Search is a newer semantic section for search-related UI. These tags show how HTML continues evolving toward richer interface structure.',
      'Students should know not only what these tags do, but also when native HTML is enough and when a richer scripted component is needed for production behavior.',
    ],
    practicalTips: [
      'Use details for expandable content when native behavior is enough.',
      'Use summary as the visible clickable label of details.',
      'Treat dialog as a semantic tool, but test browser behavior carefully.',
    ],
    referenceSections: [
      {
        title: 'Expandable and modal-related tags',
        intro: 'These elements support richer UI patterns directly in HTML.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'support', label: 'Modern support' },
        ],
        rows: [
          { tag: '<details>', purpose: 'Collapsible content container', support: 'Yes' },
          { tag: '<summary>', purpose: 'Visible heading for details', support: 'Yes' },
          { tag: '<dialog>', purpose: 'Dialog window element', support: 'Partial' },
          { tag: '<search>', purpose: 'Search region semantics', support: 'Partial' },
        ],
      },
    ],
    examples: [
      {
        title: 'Expandable note',
        description: 'A small details and summary example.',
        code: '<details>\n  <summary>Open tip</summary>\n  <p>Semantic HTML reduces the need for extra ARIA in many basic layouts.</p>\n</details>',
        outputHtml: '<details open><summary>Open tip</summary><p>Semantic HTML reduces the need for extra ARIA in many basic layouts.</p></details>',
      },
    ],
  },
  'html-media-source-track': {
    heading: 'Source, Track, and Picture',
    easySummary: 'These tags help media adapt across formats, devices, and accessibility needs.',
    theory: [
      'Source lets audio, video, and picture elements define multiple possible resources. That helps the browser choose the best supported or most suitable file. Track adds timed text data such as subtitles or captions. Picture helps responsive images adapt to screen conditions.',
      'These tags matter because media delivery is not one-size-fits-all. Different formats, captions, image sizes, and art directions often matter in real products. HTML provides the structure to express those choices.',
      'Students often learn img, video, and audio first, then later discover that source, track, and picture are what make media setups production-ready.',
    ],
    practicalTips: [
      'Use track when captions or subtitles matter.',
      'Use picture when different image sources are needed for different conditions.',
      'Use source to provide multiple media files where format support varies.',
    ],
    referenceSections: [
      {
        title: 'Media helper tags',
        intro: 'These tags work with media elements to improve adaptability and accessibility.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'usedWith', label: 'Used with' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { tag: '<source>', usedWith: 'audio, video, picture', purpose: 'Alternative media source candidate' },
          { tag: '<track>', usedWith: 'video, audio', purpose: 'Subtitles, captions, descriptions' },
          { tag: '<picture>', usedWith: 'img', purpose: 'Responsive or art-directed image source selection' },
        ],
      },
    ],
    examples: [
      {
        title: 'Video with subtitles track',
        description: 'Track is used for timed text data.',
        code: `<video controls width="320">\n  <source src="${LEARN_PORTAL_VIDEO_SOURCE}" type="video/mp4" />\n  <track kind="captions" srclang="en" label="English captions" default />\n</video>`,
        outputHtml: `<video controls width="320"><source src="${LEARN_PORTAL_VIDEO_SOURCE}" type="video/mp4" /></video>`,
      },
    ],
  },
  'html-canvas-svg-tags': {
    heading: 'Canvas and SVG Tags',
    easySummary: 'Canvas and SVG are both graphics tools, but they work in different ways.',
    theory: [
      'Canvas is a drawing surface that is controlled by scripting. SVG is markup-based vector graphics that stays part of the DOM. This difference affects styling, accessibility, animation, and performance patterns.',
      'Canvas is often better for highly dynamic pixel drawing. SVG is often better for icons, diagrams, and shapes that need DOM-level accessibility or styling. Strong engineers choose based on the product need, not habit.',
      'Students should understand that both belong near HTML because they define visual containers and graphic content in the document structure, even though canvas especially depends on JavaScript for actual drawing.',
    ],
    practicalTips: [
      'Use SVG for scalable icons and line graphics.',
      'Use canvas when the drawing is frequent and script-driven.',
      'Think about accessibility and interactivity before choosing.',
    ],
    referenceSections: [
      {
        title: 'Graphics container comparison',
        intro: 'Both are useful, but they serve different types of graphics work.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'model', label: 'Model' },
          { key: 'bestFor', label: 'Best for' },
        ],
        rows: [
          { tag: '<canvas>', model: 'Pixel-based drawing surface', bestFor: 'Games, charts, dynamic drawing' },
          { tag: '<svg>', model: 'Vector markup in the DOM', bestFor: 'Icons, diagrams, scalable graphics' },
        ],
      },
    ],
    examples: [
      {
        title: 'Simple inline SVG',
        description: 'SVG stays readable directly in markup.',
        code: '<svg width="120" height="120" viewBox="0 0 120 120">\n  <circle cx="60" cy="60" r="40" fill="#2563eb" />\n</svg>',
        outputHtml: '<svg width="120" height="120" viewBox="0 0 120 120"><circle cx="60" cy="60" r="40" fill="#2563eb" /></svg>',
      },
    ],
  },
  'html-object-embed-tags': {
    heading: 'Object, Embed, and Param',
    easySummary: 'These tags are used for embedded external resources, but modern usage is more selective.',
    theory: [
      'Object and embed are older but still relevant when external content or plugin-like resources must be embedded. Param can provide parameters to object content. In modern frontend work, iframe, video, audio, canvas, and native browser features often replace older plugin-based approaches.',
      'Students should know these tags because they still appear in legacy systems, documentation, and interview discussions about browser history and compatibility. Understanding them also helps explain why modern HTML moved away from many plugin-dependent patterns.',
      'Today, object and embed are used more carefully. They are not the first choice for normal UI, but they remain part of the HTML vocabulary.',
    ],
    practicalTips: [
      'Prefer modern native elements when they solve the need more clearly.',
      'Use object or embed only when the resource truly needs that container style.',
      'Understand that older embedding patterns may have weaker accessibility or security trade-offs.',
    ],
    referenceSections: [
      {
        title: 'Embedded resource tags',
        intro: 'These tags are most useful in special or legacy-heavy cases.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'meaning', label: 'Meaning' },
          { key: 'modernNote', label: 'Modern note' },
        ],
        rows: [
          { tag: '<object>', meaning: 'General embedded object container', modernNote: 'Still valid, but used selectively' },
          { tag: '<embed>', meaning: 'External embedded content container', modernNote: 'Use carefully for specific media or docs' },
          { tag: '<param>', meaning: 'Parameter for object content', modernNote: 'Mostly legacy contexts' },
        ],
      },
    ],
    examples: [
      {
        title: 'Basic object example',
        description: 'Object can point to an external file resource.',
        code: '<object data="/main-image.png" type="image/png" width="220"></object>',
        outputHtml: '<object data="/main-image.png" type="image/png" width="220"></object>',
      },
    ],
  },
  'html-map-area-tags': {
    heading: 'Map and Area',
    easySummary: 'Map and area create clickable regions inside one image.',
    theory: [
      'Image maps let different parts of one image point to different destinations. The map tag defines the image map, and the area tag defines each clickable region inside it.',
      'This is less common in many modern app interfaces, but it is still useful to know because it appears in educational material, legacy content, and some specialized visual navigation patterns.',
      'The key idea is that one image can contain multiple interactive zones without needing separate overlaid buttons.',
    ],
    practicalTips: [
      'Use alt text on area for accessibility.',
      'Keep clickable regions meaningful and test them carefully.',
      'Prefer simpler navigation patterns if the image map becomes hard to maintain.',
    ],
    referenceSections: [
      {
        title: 'Image map tags',
        intro: 'Map and area work together to define clickable image regions.',
        columns: [
          { key: 'tag', label: 'Tag' },
          { key: 'role', label: 'Role' },
          { key: 'importantAttrs', label: 'Important attributes' },
        ],
        rows: [
          { tag: '<map>', role: 'Named image map container', importantAttrs: 'name' },
          { tag: '<area>', role: 'Clickable region in the map', importantAttrs: 'shape, coords, href, alt' },
        ],
      },
    ],
    examples: [
      {
        title: 'Basic map structure',
        description: 'This shows the HTML structure even if coordinates are simplified.',
        code: '<img src="/main-image.png" usemap="#coursemap" alt="Course map preview" width="240" />\n<map name="coursemap">\n  <area shape="rect" coords="0,0,120,120" href="#" alt="Open section" />\n</map>',
        outputHtml: '<img src="/main-image.png" alt="Course map preview" width="240" />',
      },
    ],
  },
  'html-comment-doctype': {
    heading: 'Comment and Doctype',
    easySummary: 'Comments help humans read code, and doctype tells the browser to use standards mode.',
    theory: [
      'The doctype declaration appears at the very top of an HTML document and tells the browser to render the page in standards mode. Without it, browsers can behave in older compatibility modes that produce confusing layout behavior.',
      'Comments are not shown to users in the rendered page. They are written for developers and maintainers. Good comments explain why something exists when the intent is not obvious. They should not repeat obvious code.',
      'These two pieces may look small, but both matter. Doctype helps the browser. Comments help humans. Together they improve reliability and maintainability from the first line of the file.',
    ],
    practicalTips: [
      'Always start full HTML pages with <!DOCTYPE html>.',
      'Keep comments short and useful.',
      'Do not leave outdated comments that no longer match the code.',
    ],
    referenceSections: [
      {
        title: 'Document setup basics',
        intro: 'These are early pieces of the HTML file that support correctness and maintainability.',
        columns: [
          { key: 'item', label: 'Item' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'visibility', label: 'Visible to user?' },
        ],
        rows: [
          { item: '<!DOCTYPE html>', purpose: 'Standards-mode document declaration', visibility: 'No' },
          { item: '<!-- comment -->', purpose: 'Developer note in markup', visibility: 'No' },
        ],
      },
    ],
    examples: [
      {
        title: 'Comment and doctype starter',
        description: 'A simple example of both.',
        code: '<!DOCTYPE html>\n<!-- Main landing page -->\n<html lang="en">\n  <body>\n    <h1>Home</h1>\n  </body>\n</html>',
        outputHtml: '<h1>Home</h1>',
      },
    ],
  },
  'html-colors-palette': {
    heading: 'HTML Color Support and Palette Practice',
    easySummary: 'HTML itself does not define color systems, but color values commonly appear through inline style, SVG, and presentational examples.',
    theory: [
      'Modern color styling should usually be done in CSS, not old presentational HTML attributes. Still, students need to understand color values because they appear in inline styles, SVG, email templates, quick prototypes, and demo code.',
      'Color values can be written as names, hex codes, rgb, rgba, hsl, and more. Knowing a few clear palette examples helps students connect visible color blocks to real code values.',
      'This topic is also useful because many beginners see color in examples before they properly study CSS. A simple visual palette helps make the values memorable.',
    ],
    practicalTips: [
      'Prefer CSS for production color styling.',
      'Learn common hex values and named colors for quick reading.',
      'Always check contrast when text sits on a colored background.',
    ],
    referenceSections: [
      {
        title: 'Common palette examples',
        intro: 'These colors are easy to recognize and useful while learning.',
        columns: [
          { key: 'name', label: 'Color name' },
          { key: 'hex', label: 'Hex code' },
          { key: 'note', label: 'Good use' },
        ],
        rows: [
          { name: 'Blue', hex: '#2563eb', note: 'Primary actions and emphasis' },
          { name: 'Green', hex: '#16a34a', note: 'Success states' },
          { name: 'Amber', hex: '#f59e0b', note: 'Warnings or attention' },
          { name: 'Red', hex: '#dc2626', note: 'Errors and destructive actions' },
          { name: 'Slate', hex: '#334155', note: 'Readable body text' },
          { name: 'Rose', hex: '#e11d48', note: 'Accent or alert styling' },
        ],
      },
    ],
    examples: [
      {
        title: 'Palette grid with names and codes',
        description: 'A simple color board students can edit and extend.',
        code: '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;font-family:Arial,sans-serif;">\n  <div style="background:#2563eb;color:#fff;padding:16px;border-radius:12px;">Blue<br />#2563eb</div>\n  <div style="background:#16a34a;color:#fff;padding:16px;border-radius:12px;">Green<br />#16a34a</div>\n  <div style="background:#f59e0b;color:#111;padding:16px;border-radius:12px;">Amber<br />#f59e0b</div>\n  <div style="background:#dc2626;color:#fff;padding:16px;border-radius:12px;">Red<br />#dc2626</div>\n  <div style="background:#334155;color:#fff;padding:16px;border-radius:12px;">Slate<br />#334155</div>\n  <div style="background:#e11d48;color:#fff;padding:16px;border-radius:12px;">Rose<br />#e11d48</div>\n</div>',
        outputHtml: '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;font-family:Arial,sans-serif;"><div style="background:#2563eb;color:#fff;padding:16px;border-radius:12px;">Blue<br />#2563eb</div><div style="background:#16a34a;color:#fff;padding:16px;border-radius:12px;">Green<br />#16a34a</div><div style="background:#f59e0b;color:#111;padding:16px;border-radius:12px;">Amber<br />#f59e0b</div><div style="background:#dc2626;color:#fff;padding:16px;border-radius:12px;">Red<br />#dc2626</div><div style="background:#334155;color:#fff;padding:16px;border-radius:12px;">Slate<br />#334155</div><div style="background:#e11d48;color:#fff;padding:16px;border-radius:12px;">Rose<br />#e11d48</div></div>',
      },
    ],
  },
  'html-attributes-core': {
    heading: 'Core HTML Attributes',
    easySummary: 'Attributes give extra meaning, behavior, and configuration to HTML elements.',
    theory: [
      'Attributes are written inside the opening tag and help define how an element behaves or what extra meaning it carries. Without attributes, many HTML tags would be too limited for real-world work. For example, a link needs href, an image needs src and alt, and a form often needs action and method.',
      'Students often memorize attributes tag by tag, but a better approach is to understand categories: identification, accessibility, navigation, forms, media, layout hints, and machine-readable metadata.',
      'Strong frontend engineers think carefully about attributes because many bugs, accessibility issues, and browser behaviors come from missing or misused attributes rather than from the tag itself.',
    ],
    practicalTips: [
      'Learn the essential attributes of common tags first.',
      'Use double quotes consistently around attribute values.',
      'Ask whether the attribute is semantic, behavioral, or both.',
    ],
    referenceSections: [
      {
        title: 'Common core attributes by element type',
        intro: 'These are some of the highest-value attributes students should know early.',
        columns: [
          { key: 'attribute', label: 'Attribute' },
          { key: 'belongsTo', label: 'Commonly used on' },
          { key: 'meaning', label: 'Simple purpose' },
        ],
        rows: [
          { attribute: 'href', belongsTo: '<a>, <area>, <link>, <base>', meaning: 'Destination URL' },
          { attribute: 'src', belongsTo: '<img>, <script>, <iframe>, <audio>, <video>, <source>, <track>', meaning: 'Resource URL' },
          { attribute: 'alt', belongsTo: '<img>, <area>, file-type <input>', meaning: 'Alternative text or backup meaning' },
          { attribute: 'type', belongsTo: '<button>, <input>, <script>, <link>, <source>', meaning: 'Defines behavior or resource type' },
          { attribute: 'value', belongsTo: '<input>, <button>, <option>, <progress>, <meter>', meaning: 'Current or configured value' },
          { attribute: 'name', belongsTo: 'form controls, iframe, meta, map', meaning: 'Named identity for submission or reference' },
          { attribute: 'for', belongsTo: '<label>, <output>', meaning: 'Connects label/output to related control(s)' },
          { attribute: 'action', belongsTo: '<form>', meaning: 'Where form data is sent' },
          { attribute: 'method', belongsTo: '<form>', meaning: 'HTTP method for submission' },
          { attribute: 'target', belongsTo: '<a>, <form>, <base>, <area>', meaning: 'Where linked or submitted content opens' },
        ],
      },
    ],
    examples: [
      {
        title: 'Attribute mix in one small snippet',
        description: 'Different tags depend on different core attributes.',
        code: '<a href="https://developer.mozilla.org" target="_blank" rel="noreferrer">Reference</a>\n<img src="/main-image.png" alt="Platform preview" width="180" />',
        outputHtml: '<a href="https://developer.mozilla.org" target="_blank" rel="noreferrer">Reference</a><br /><img src="/main-image.png" alt="Platform preview" width="180" />',
      },
    ],
  },
  'html-global-attributes': {
    heading: 'Global Attributes',
    easySummary: 'Global attributes can be used on almost any HTML element.',
    theory: [
      'Global attributes are powerful because they are not tied to only one tag. They work across most HTML elements and help with identity, accessibility, interactivity, direction, editing, and custom data.',
      'These attributes appear constantly in real projects. Class and id are common, but many students do not learn contenteditable, hidden, inputmode, popover, or translate until much later. Knowing them earlier gives you more expressive control with native HTML.',
      'A good mental model is to treat global attributes as cross-cutting tools. They do not replace semantic tags, but they enhance how those tags behave in the browser and in the application.',
    ],
    practicalTips: [
      'Use class for styling groups and id for unique identity.',
      'Use hidden and inert carefully because they affect interaction and visibility.',
      'Use data-* when you need lightweight custom metadata.',
    ],
    referenceSections: [
      {
        title: 'Important global attributes',
        intro: 'These attributes can be reused across many element types.',
        columns: [
          { key: 'attribute', label: 'Attribute' },
          { key: 'description', label: 'Simple description' },
          { key: 'bestUse', label: 'Good use case' },
        ],
        rows: [
          { attribute: 'accesskey', description: 'Keyboard shortcut hint', bestUse: 'Power-user interfaces' },
          { attribute: 'class', description: 'Reusable class names', bestUse: 'Styling and hooks' },
          { attribute: 'contenteditable', description: 'Makes content editable', bestUse: 'Editable notes or demos' },
          { attribute: 'data-*', description: 'Stores custom data', bestUse: 'Analytics or UI metadata' },
          { attribute: 'dir', description: 'Text direction', bestUse: 'LTR and RTL content' },
          { attribute: 'draggable', description: 'Marks element as draggable', bestUse: 'Drag interfaces' },
          { attribute: 'enterkeyhint', description: 'Virtual keyboard enter key hint', bestUse: 'Mobile forms' },
          { attribute: 'hidden', description: 'Hides non-relevant content', bestUse: 'Conditional UI pieces' },
          { attribute: 'id', description: 'Unique element identifier', bestUse: 'Labels, anchors, scripts' },
          { attribute: 'inert', description: 'Makes section non-interactive', bestUse: 'Background UI under modal' },
          { attribute: 'inputmode', description: 'Hints keyboard type', bestUse: 'Mobile numeric or email entry' },
          { attribute: 'lang', description: 'Language declaration', bestUse: 'Page and content localization' },
          { attribute: 'popover', description: 'Popover behavior', bestUse: 'Modern lightweight popovers' },
          { attribute: 'spellcheck', description: 'Spelling and grammar hint', bestUse: 'Editable content areas' },
          { attribute: 'style', description: 'Inline style', bestUse: 'Small demos or exceptions' },
          { attribute: 'tabindex', description: 'Keyboard focus order control', bestUse: 'Custom interactions' },
          { attribute: 'title', description: 'Extra information tooltip', bestUse: 'Clarifying short labels' },
          { attribute: 'translate', description: 'Allow or block translation', bestUse: 'Brand names or code-like tokens' },
        ],
      },
    ],
    examples: [
      {
        title: 'Global attributes in action',
        description: 'A single element can use several global attributes together.',
        code: '<div id="tip-box" class="note" data-level="beginner" title="Helpful note" lang="en">Useful learning tip</div>',
        outputHtml: '<div id="tip-box" class="note" data-level="beginner" title="Helpful note" lang="en">Useful learning tip</div>',
      },
    ],
  },
  'html-form-media-attributes': {
    heading: 'Form and Media Attribute Reference',
    easySummary: 'Form and media elements depend on specific attributes for behavior, validation, and playback control.',
    theory: [
      'Form and media elements have attribute sets that strongly influence user experience. A form control without correct attributes may accept the wrong data, expose the wrong keyboard, or fail accessibility expectations. Media without the right attributes may not show controls, preload correctly, or offer subtitles.',
      'This topic is best learned as grouped reference rather than scattered memorization. That way students can see patterns: validation-related attributes, playback-related attributes, sizing-related attributes, and source-related attributes.',
      'In interviews, these attributes are often used to test practical awareness. It is not only about syntax, but about how the chosen attributes shape behavior.',
    ],
    practicalTips: [
      'Learn common form attributes first, then media-specific ones.',
      'Think about validation, accessibility, and device behavior together.',
      'Use the browser dev tools to inspect how attributes change element behavior.',
    ],
    referenceSections: [
      {
        title: 'Form attributes',
        intro: 'These attributes appear frequently in real forms.',
        columns: [
          { key: 'attribute', label: 'Attribute' },
          { key: 'usedOn', label: 'Used on' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { attribute: 'accept', usedOn: '<input type="file">', purpose: 'Accepted file types' },
          { attribute: 'accept-charset', usedOn: '<form>', purpose: 'Submission encoding set' },
          { attribute: 'autocomplete', usedOn: '<form>, <input>', purpose: 'Enable browser autocomplete' },
          { attribute: 'autofocus', usedOn: '<button>, <input>, <select>, <textarea>', purpose: 'Receive focus on load' },
          { attribute: 'checked', usedOn: '<input>', purpose: 'Pre-select checkbox or radio' },
          { attribute: 'cols / rows', usedOn: '<textarea>', purpose: 'Visible text area size' },
          { attribute: 'disabled', usedOn: 'form controls, fieldset, option groups', purpose: 'Disable interaction' },
          { attribute: 'enctype', usedOn: '<form>', purpose: 'Submission encoding for POST' },
          { attribute: 'list', usedOn: '<input>', purpose: 'Connect input to datalist' },
          { attribute: 'max / min / step', usedOn: '<input>, <meter>, <progress>', purpose: 'Range and interval control' },
          { attribute: 'maxlength / minlength', usedOn: '<input>, <textarea>', purpose: 'Character length limits' },
          { attribute: 'multiple', usedOn: '<input>, <select>', purpose: 'Allow more than one value' },
          { attribute: 'pattern', usedOn: '<input>', purpose: 'Regex validation pattern' },
          { attribute: 'placeholder', usedOn: '<input>, <textarea>', purpose: 'Short input hint' },
          { attribute: 'readonly', usedOn: '<input>, <textarea>', purpose: 'Non-editable but readable control' },
          { attribute: 'required', usedOn: '<input>, <select>, <textarea>', purpose: 'Must be filled before submit' },
          { attribute: 'selected', usedOn: '<option>', purpose: 'Pre-select option' },
          { attribute: 'size', usedOn: '<input>, <select>', purpose: 'Width or visible item count' },
          { attribute: 'wrap', usedOn: '<textarea>', purpose: 'Text wrapping behavior' },
        ],
      },
      {
        title: 'Media and embedded content attributes',
        intro: 'These attributes control playback, loading, and embedded behavior.',
        columns: [
          { key: 'attribute', label: 'Attribute' },
          { key: 'usedOn', label: 'Used on' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { attribute: 'autoplay', usedOn: '<audio>, <video>', purpose: 'Start playback automatically' },
          { attribute: 'controls', usedOn: '<audio>, <video>', purpose: 'Show play/pause and related controls' },
          { attribute: 'crossorigin', usedOn: 'media, img, link, script', purpose: 'Cross-origin resource policy hint' },
          { attribute: 'height / width', usedOn: 'img, iframe, video, canvas, embed, object, input', purpose: 'Rendered dimensions' },
          { attribute: 'loading', usedOn: '<img>', purpose: 'Lazy or eager load hint' },
          { attribute: 'loop', usedOn: '<audio>, <video>', purpose: 'Replay after finish' },
          { attribute: 'muted', usedOn: '<audio>, <video>', purpose: 'Mute playback' },
          { attribute: 'poster', usedOn: '<video>', purpose: 'Image before video starts' },
          { attribute: 'preload', usedOn: '<audio>, <video>', purpose: 'Load strategy hint' },
          { attribute: 'sandbox', usedOn: '<iframe>', purpose: 'Restrict embedded content abilities' },
          { attribute: 'srcdoc', usedOn: '<iframe>', purpose: 'Inline HTML for iframe content' },
          { attribute: 'srclang / kind / default / label', usedOn: '<track>', purpose: 'Timed text configuration' },
          { attribute: 'srcset / sizes', usedOn: '<img>, <source>', purpose: 'Responsive image source selection' },
          { attribute: 'usemap / ismap', usedOn: '<img>, <object>', purpose: 'Image map behavior' },
        ],
      },
    ],
    examples: [
      {
        title: 'Validation and playback attributes',
        description: 'A quick mix of form and media attributes.',
        code: '<input type="email" required placeholder="Enter email" />\n<video controls muted poster="/main-image.png" width="240"></video>',
        outputHtml: '<input type="email" required placeholder="Enter email" /><br /><br /><video controls muted poster="/main-image.png" width="240"></video>',
      },
    ],
  },
  'html-event-attributes': {
    heading: 'Global Event Attributes',
    easySummary: 'HTML event attributes connect element or window events to JavaScript actions.',
    theory: [
      'HTML can trigger JavaScript through event attributes. In modern applications, many teams prefer event binding through JavaScript or frameworks, but understanding the native event categories is still important because the underlying browser model stays the same.',
      'Events are best understood in groups: window lifecycle, form interactions, keyboard input, mouse input, drag and scroll, clipboard, media playback, and smaller special events such as toggle.',
      'Students do not need to memorize every event immediately, but they should recognize the categories and know what kind of user action or browser state each group represents.',
    ],
    practicalTips: [
      'Learn the event category before memorizing every individual event name.',
      'Use event handling to support interaction, not to replace semantic HTML structure.',
      'Prefer maintainable event wiring in scripts for larger apps, but still understand the raw attribute forms.',
    ],
    referenceSections: [
      {
        title: 'Window events',
        intro: 'These are commonly associated with the body or page lifecycle.',
        columns: [
          { key: 'attribute', label: 'Event' },
          { key: 'trigger', label: 'Fires when' },
        ],
        rows: [
          { attribute: 'onafterprint', trigger: 'Document finishes printing' },
          { attribute: 'onbeforeprint', trigger: 'Document is about to print' },
          { attribute: 'onbeforeunload', trigger: 'Page is about to unload' },
          { attribute: 'onerror', trigger: 'An error occurs' },
          { attribute: 'onhashchange', trigger: 'URL hash changes' },
          { attribute: 'onload', trigger: 'Page finishes loading' },
          { attribute: 'onmessage', trigger: 'A message event is received' },
          { attribute: 'onoffline', trigger: 'Browser goes offline' },
          { attribute: 'ononline', trigger: 'Browser goes online' },
          { attribute: 'onpagehide', trigger: 'User navigates away' },
          { attribute: 'onpageshow', trigger: 'User navigates to page' },
          { attribute: 'onpopstate', trigger: 'History state changes' },
          { attribute: 'onresize', trigger: 'Window size changes' },
          { attribute: 'onstorage', trigger: 'Web storage updates' },
          { attribute: 'onunload', trigger: 'Page fully unloads' },
        ],
      },
      {
        title: 'Form and keyboard events',
        intro: 'These are useful when responding to user input or validation changes.',
        columns: [
          { key: 'attribute', label: 'Event' },
          { key: 'trigger', label: 'Fires when' },
        ],
        rows: [
          { attribute: 'onblur', trigger: 'Element loses focus' },
          { attribute: 'onchange', trigger: 'Element value changes' },
          { attribute: 'oncontextmenu', trigger: 'Context menu is requested' },
          { attribute: 'onfocus', trigger: 'Element gets focus' },
          { attribute: 'oninput', trigger: 'User enters input' },
          { attribute: 'oninvalid', trigger: 'Element is invalid' },
          { attribute: 'onreset', trigger: 'Form reset occurs' },
          { attribute: 'onsearch', trigger: 'Search input updates' },
          { attribute: 'onselect', trigger: 'Text is selected' },
          { attribute: 'onsubmit', trigger: 'Form is submitted' },
          { attribute: 'onkeydown', trigger: 'Key is pressed down' },
          { attribute: 'onkeypress', trigger: 'Key press occurs' },
          { attribute: 'onkeyup', trigger: 'Key is released' },
        ],
      },
      {
        title: 'Mouse, drag, clipboard, media, and misc events',
        intro: 'These event groups cover a wide range of interactive behavior.',
        columns: [
          { key: 'attribute', label: 'Event' },
          { key: 'trigger', label: 'Fires when' },
        ],
        rows: [
          { attribute: 'onclick / ondblclick', trigger: 'Mouse click or double-click' },
          { attribute: 'onmousedown / onmouseup', trigger: 'Mouse button press or release' },
          { attribute: 'onmousemove', trigger: 'Pointer moves over element' },
          { attribute: 'onmouseover / onmouseout', trigger: 'Pointer enters or leaves element' },
          { attribute: 'onwheel', trigger: 'Mouse wheel scrolls' },
          { attribute: 'ondrag / ondragstart / ondragend', trigger: 'Drag starts, continues, or ends' },
          { attribute: 'ondragenter / ondragleave / ondragover / ondrop', trigger: 'Drag interacts with drop target' },
          { attribute: 'onscroll', trigger: 'Element scroll position changes' },
          { attribute: 'oncopy / oncut / onpaste', trigger: 'Clipboard interaction occurs' },
          { attribute: 'onabort / oncanplay / oncanplaythrough', trigger: 'Media loading or play readiness changes' },
          { attribute: 'ondurationchange / onemptied / onended', trigger: 'Media state updates' },
          { attribute: 'onloadeddata / onloadedmetadata / onloadstart', trigger: 'Media loading milestones occur' },
          { attribute: 'onpause / onplay / onplaying', trigger: 'Media playback state changes' },
          { attribute: 'onprogress / onratechange / onseeked / onseeking', trigger: 'Media buffering, speed, or seek updates happen' },
          { attribute: 'onstalled / onsuspend / ontimeupdate / onvolumechange / onwaiting', trigger: 'Media fetch or playback support states change' },
          { attribute: 'ontoggle', trigger: 'Details element opens or closes' },
        ],
      },
    ],
    examples: [
      {
        title: 'Simple input event demo',
        description: 'A basic inline event example for learning only.',
        code: '<input type="text" onfocus="this.style.background=\'#e0f2fe\'" onblur="this.style.background=\'white\'" placeholder="Focus me" />',
        outputHtml: '<input type="text" placeholder="Focus me" />',
      },
    ],
  },
  'html-browser-support': {
    heading: 'HTML Browser Support Snapshot',
    easySummary: 'Most core HTML elements are well supported, but some newer or advanced elements still need attention.',
    theory: [
      'Students should know that browser support is not equal across every HTML feature. Basic elements such as headings, paragraphs, links, lists, tables, forms, and images are very well supported. Newer features such as dialog, search, popover-related behavior, and some media subtleties can vary more.',
      'A support table is useful not because you should memorize every browser detail, but because it teaches you to think about compatibility when selecting a feature. Production engineering is partly about choosing features that match the support expectations of your users.',
      'The goal of this topic is to help students recognize which elements are almost universally safe and which ones deserve an extra compatibility check.',
    ],
    practicalTips: [
      'Treat modern basic semantic tags as broadly safe in current browsers.',
      'Check newer elements and advanced attributes before depending on them heavily.',
      'Progressive enhancement is often safer than assuming every feature is universal.',
    ],
    referenceSections: [
      {
        title: 'Core HTML element support',
        intro: 'These elements are broadly supported across modern browsers.',
        columns: BROWSER_SUPPORT_COLUMNS,
        rows: [
          { tag: '<a>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<img>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<form>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<table>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<audio>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<video>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<details>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<dialog>', chrome: 'Yes', edge: 'Yes', firefox: 'Partial', safari: 'Yes', opera: 'Yes' },
        ],
      },
      {
        title: 'Modern and advanced feature support',
        intro: 'These need a little more attention in compatibility planning.',
        columns: BROWSER_SUPPORT_COLUMNS,
        rows: [
          { tag: '<search>', chrome: 'Partial', edge: 'Partial', firefox: 'Partial', safari: 'Partial', opera: 'Partial' },
          { tag: '<track>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<picture>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<template>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<slot>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<meter>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
          { tag: '<progress>', chrome: 'Yes', edge: 'Yes', firefox: 'Yes', safari: 'Yes', opera: 'Yes' },
        ],
        notes: [
          'This table is a modern support snapshot for learning, not a historical version-by-version matrix.',
          'Always test critical product features in the actual browser mix your users depend on.',
        ],
      },
    ],
    examples: [
      {
        title: 'Progressive enhancement mindset',
        description: 'A small note block for compatibility thinking.',
        code: '<section>\n  <h2>Compatibility Tip</h2>\n  <p>Use strong semantic basics first, then layer newer features carefully.</p>\n</section>',
        outputHtml: '<section><h2>Compatibility Tip</h2><p>Use strong semantic basics first, then layer newer features carefully.</p></section>',
      },
    ],
  },
  'html-media-dom-api': {
    heading: 'HTML Audio and Video DOM API',
    easySummary: 'Audio and video elements expose methods, properties, and events that scripts can control directly.',
    theory: [
      'The media DOM API lets JavaScript control audio and video elements in the browser. This means a player is not just a visual tag on the page. It is an object with methods, state, properties, and many lifecycle events.',
      'Students should know this topic because modern products often build custom media interfaces, playback logic, learning trackers, or subtitle controls on top of the native media API. Understanding the native API makes those systems easier to build.',
      'A good frontend engineer does not memorize every property at once, but they do understand the categories: playback methods, timing state, loading state, tracks, volume, mute, and events.',
    ],
    practicalTips: [
      'Learn the small core first: play, pause, currentTime, duration, paused, volume, and controls.',
      'Use events to react to playback state instead of guessing timing manually.',
      'Keep native controls on while learning the API so behavior stays visible.',
    ],
    referenceSections: [
      {
        title: 'Audio and video methods',
        intro: 'These methods are the core commands of the media API.',
        columns: [
          { key: 'method', label: 'Method' },
          { key: 'description', label: 'What it does' },
        ],
        rows: [
          { method: 'addTextTrack()', description: 'Adds a new text track to the media element' },
          { method: 'canPlayType()', description: 'Checks whether a format is likely playable' },
          { method: 'load()', description: 'Reloads the media resource' },
          { method: 'play()', description: 'Starts playback' },
          { method: 'pause()', description: 'Pauses playback' },
        ],
      },
      {
        title: 'Audio and video properties',
        intro: 'These properties describe media state, tracks, timing, and playback configuration.',
        columns: [
          { key: 'property', label: 'Property' },
          { key: 'description', label: 'Simple meaning' },
        ],
        rows: [
          { property: 'audioTracks', description: 'Available audio tracks' },
          { property: 'autoplay', description: 'Whether autoplay is enabled' },
          { property: 'buffered', description: 'Buffered time ranges' },
          { property: 'controller', description: 'Current media controller object' },
          { property: 'controls', description: 'Whether controls are shown' },
          { property: 'crossOrigin', description: 'Cross-origin setting of media' },
          { property: 'currentSrc', description: 'Currently selected media source URL' },
          { property: 'currentTime', description: 'Current playback time in seconds' },
          { property: 'defaultMuted', description: 'Whether media is muted by default' },
          { property: 'defaultPlaybackRate', description: 'Default playback speed' },
          { property: 'duration', description: 'Total media length in seconds' },
          { property: 'ended', description: 'Whether playback has ended' },
          { property: 'error', description: 'Media error state object' },
          { property: 'loop', description: 'Whether playback restarts automatically' },
          { property: 'mediaGroup', description: 'Group identity for related media' },
          { property: 'muted', description: 'Whether audio is muted now' },
          { property: 'networkState', description: 'Current network loading state' },
          { property: 'paused', description: 'Whether playback is paused' },
          { property: 'playbackRate', description: 'Current playback speed' },
          { property: 'played', description: 'Played time ranges' },
          { property: 'preload', description: 'Preferred preload behavior' },
          { property: 'readyState', description: 'Current readiness state' },
          { property: 'seekable', description: 'Seekable time ranges' },
          { property: 'seeking', description: 'Whether seeking is happening now' },
          { property: 'src', description: 'Current media source' },
          { property: 'startDate', description: 'Date object for time offset support' },
          { property: 'textTracks', description: 'Available text tracks' },
          { property: 'videoTracks', description: 'Video tracks list; largely deprecated in practice' },
          { property: 'volume', description: 'Current volume level' },
        ],
      },
      {
        title: 'Important media events',
        intro: 'These events help scripts react to playback lifecycle and buffering state.',
        columns: [
          { key: 'event', label: 'Event' },
          { key: 'meaning', label: 'Simple meaning' },
        ],
        rows: [
          { event: 'onabort', meaning: 'Loading was aborted' },
          { event: 'oncanplay', meaning: 'Media can start playing' },
          { event: 'oncanplaythrough', meaning: 'Media can likely play to the end without buffering' },
          { event: 'oncuechange', meaning: 'Track cue changed' },
          { event: 'ondurationchange', meaning: 'Media duration changed' },
          { event: 'onemptied', meaning: 'Media became unexpectedly unavailable' },
          { event: 'onended', meaning: 'Playback reached the end' },
          { event: 'onerror', meaning: 'Media load or playback error occurred' },
          { event: 'onloadeddata / onloadedmetadata / onloadstart', meaning: 'Different stages of media loading occurred' },
          { event: 'onpause / onplay / onplaying', meaning: 'Playback state changed' },
          { event: 'onprogress', meaning: 'Browser is fetching media data' },
          { event: 'onratechange', meaning: 'Playback speed changed' },
          { event: 'onseeked / onseeking', meaning: 'Seek action ended or is ongoing' },
          { event: 'onstalled / onsuspend / onwaiting', meaning: 'Playback or loading is delayed or paused' },
          { event: 'ontimeupdate', meaning: 'Current playback time updated' },
          { event: 'onvolumechange', meaning: 'Volume or mute state changed' },
        ],
      },
    ],
    examples: [
      {
        title: 'Small media API starter',
        description: 'A button can trigger video playback through JavaScript.',
        code: `<video id="demo-video" width="320" controls>\n  <source src="${LEARN_PORTAL_VIDEO_SOURCE}" type="video/mp4" />\n</video>\n<button type="button" onclick="document.getElementById('demo-video').play()">Play Video</button>`,
        outputHtml: `<video id="demo-video" width="320" controls><source src="${LEARN_PORTAL_VIDEO_SOURCE}" type="video/mp4" /></video><br /><button type="button">Play Video</button>`,
      },
    ],
  },
  'html-url-encoding': {
    heading: 'URL Structure and Encoding',
    easySummary: 'URLs are addresses, and encoding makes unsafe characters safe to send over the web.',
    theory: [
      'A URL, or Uniform Resource Locator, is the address used to request a page or resource from a server. Real URLs often contain paths, query values, fragments, and user-provided values. When those values contain unsafe characters, they need encoding.',
      'URL encoding converts characters into a transport-safe format. For example, spaces cannot travel directly in a normal URL, so they are encoded, often as %20. This matters in search queries, API calls, dynamic routes, and user input passed in links.',
      'Students should learn URL encoding because it connects HTML, browser behavior, and JavaScript logic. If you build forms, links, filters, or search pages, encoded values become a real concern quickly.',
    ],
    practicalTips: [
      'Treat user input in URLs carefully and encode it before sending.',
      'Recognize %20 as the encoded form of a space in many contexts.',
      'In JavaScript, use encodeURIComponent() for query value pieces.',
    ],
    referenceSections: [
      {
        title: 'Common URL encoding examples',
        intro: 'These are some values students see very often in query strings and paths.',
        columns: [
          { key: 'character', label: 'Character' },
          { key: 'encoded', label: 'Encoded form' },
          { key: 'note', label: 'Simple note' },
        ],
        rows: [
          { character: 'space', encoded: '%20', note: 'Very common in query values' },
          { character: '#', encoded: '%23', note: 'Needed when hash should be literal data' },
          { character: '&', encoded: '%26', note: 'Prevents query splitting' },
          { character: '?', encoded: '%3F', note: 'Prevents starting a new query unexpectedly' },
          { character: '=', encoded: '%3D', note: 'Prevents key-value confusion' },
          { character: '/', encoded: '%2F', note: 'Useful when slash must stay part of data' },
          { character: '€', encoded: '%E2%82%AC', note: 'Example of multi-byte UTF-8 encoding' },
        ],
      },
      {
        title: 'Practical URL encoding tools',
        intro: 'Different environments offer built-in helpers for encoding.',
        columns: [
          { key: 'environment', label: 'Environment' },
          { key: 'tool', label: 'Common function' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { environment: 'JavaScript', tool: 'encodeURIComponent()', purpose: 'Encode a URL component safely' },
          { environment: 'Server-side platforms', tool: 'Platform-specific URL encoding helpers', purpose: 'Encode data before sending or redirecting' },
          { environment: 'Browser form submission', tool: 'Built-in form encoding behavior', purpose: 'Encodes submitted form values automatically' },
        ],
      },
    ],
    examples: [
      {
        title: 'Encoding a search string in JavaScript',
        description: 'This shows the most common frontend helper.',
        code: '<script>\n  const rawValue = "HTML & CSS basics";\n  const encoded = encodeURIComponent(rawValue);\n  document.write(encoded);\n</script>',
        outputHtml: '<code>HTML%20%26%20CSS%20basics</code>',
      },
    ],
  },
  'html-language-codes': {
    heading: 'Language Codes and lang Attribute',
    easySummary: 'The lang attribute helps browsers, screen readers, and search engines understand language correctly.',
    theory: [
      'The lang attribute should be declared on the html tag for the page and can also be applied to smaller content sections when language changes. This is important for pronunciation, search understanding, translation tools, accessibility, and region-specific processing.',
      'Students often treat lang as optional, but strong markup includes it from the start. It is a small attribute with broad impact. Search systems and assistive tools both benefit when language is clearly declared.',
      'Language codes usually follow standards such as en, hi, fr, es, or more specific variants like zh-Hans and zh-Hant. The important thing for beginners is to use the correct code for the content language.',
    ],
    practicalTips: [
      'Always set lang on the main html tag.',
      'Use a more specific language code only when it genuinely fits the content.',
      'If a quote or phrase switches language, you can set lang on that smaller element too.',
    ],
    referenceSections: [
      {
        title: 'Common language code examples',
        intro: 'These are useful starter codes for multilingual web content.',
        columns: [
          { key: 'language', label: 'Language' },
          { key: 'code', label: 'Code' },
          { key: 'note', label: 'Note' },
        ],
        rows: [
          { language: 'English', code: 'en', note: 'Very common page default' },
          { language: 'Hindi', code: 'hi', note: 'Useful for Indian-language content' },
          { language: 'French', code: 'fr', note: 'Common European language code' },
          { language: 'Spanish', code: 'es', note: 'Widely used across regions' },
          { language: 'Japanese', code: 'ja', note: 'Useful for East Asian content' },
          { language: 'Chinese Simplified', code: 'zh-Hans', note: 'Specific script variant' },
          { language: 'Chinese Traditional', code: 'zh-Hant', note: 'Specific script variant' },
          { language: 'Arabic', code: 'ar', note: 'Often combined with RTL direction awareness' },
        ],
      },
    ],
    examples: [
      {
        title: 'Language declaration example',
        description: 'Declare the page language clearly at the root.',
        code: '<!DOCTYPE html>\n<html lang="en">\n  <body>\n    <p>Hello world</p>\n  </body>\n</html>',
        outputHtml: '<p>Hello world</p>',
      },
    ],
  },
  'html-legacy-tags': {
    heading: 'Legacy and Deprecated HTML Tags',
    easySummary: 'Some older tags still appear in examples or old codebases, but modern HTML replaces them with better patterns.',
    theory: [
      'Legacy tags matter because frontend engineers often inherit older codebases. You do not need to use these tags in new work, but you should recognize them and know what modern alternatives replaced them.',
      'Many deprecated tags were visual shortcuts from older web development, such as center, font, big, tt, and marquee. Modern HTML separates meaning from appearance, so CSS now handles most of those visual concerns more cleanly.',
      'Understanding obsolete tags also helps in interviews because it shows historical awareness and stronger judgment about modern best practice.',
    ],
    practicalTips: [
      'Do not introduce deprecated tags in new code.',
      'When reading older projects, identify the modern semantic or CSS replacement.',
      'Marquee is important as a learning example of why visual behavior belongs in CSS or JavaScript, not in outdated presentational tags.',
    ],
    referenceSections: [
      {
        title: 'Legacy tags and modern replacements',
        intro: 'These tags may still appear in old snippets, but modern code should avoid them.',
        columns: [
          { key: 'tag', label: 'Legacy tag' },
          { key: 'status', label: 'Status' },
          { key: 'replacement', label: 'Modern replacement' },
        ],
        rows: [
          { tag: '<acronym>', status: 'Deprecated', replacement: '<abbr>' },
          { tag: '<applet>', status: 'Deprecated', replacement: '<embed> or <object>' },
          { tag: '<basefont>', status: 'Deprecated', replacement: 'CSS typography rules' },
          { tag: '<big>', status: 'Deprecated', replacement: 'CSS font-size' },
          { tag: '<center>', status: 'Deprecated', replacement: 'CSS text-align or layout' },
          { tag: '<dir>', status: 'Deprecated', replacement: '<ul>' },
          { tag: '<font>', status: 'Deprecated', replacement: 'CSS font-family, font-size, color' },
          { tag: '<frame> / <frameset> / <noframes>', status: 'Deprecated', replacement: 'Modern layout + iframe where needed' },
          { tag: '<marquee>', status: 'Deprecated', replacement: 'CSS animation or JavaScript-driven motion' },
          { tag: '<strike>', status: 'Deprecated', replacement: '<s> or <del>' },
          { tag: '<tt>', status: 'Deprecated', replacement: 'CSS monospace font or <code>' },
        ],
      },
    ],
    examples: [
      {
        title: 'Replacing marquee thinking',
        description: 'Use CSS animation instead of deprecated marquee.',
        code: '<div style="overflow:hidden;white-space:nowrap;">\n  <span style="display:inline-block;animation: move 6s linear infinite;">Moving text can be built with modern CSS.</span>\n</div>\n<style>\n  @keyframes move {\n    from { transform: translateX(100%); }\n    to { transform: translateX(-100%); }\n  }\n</style>',
        outputHtml: '<div style="overflow:hidden;white-space:nowrap;"><span style="display:inline-block;animation: move 6s linear infinite;">Moving text can be built with modern CSS.</span></div>',
      },
    ],
  },
});

export const CSS_LESSONS = {
  'css-introduction': {
    heading: 'Introduction to CSS',
    easySummary: 'CSS controls presentation, layout, spacing, color, and visual behavior on top of HTML structure.',
    theory: [
      'CSS stands for Cascading Style Sheets. It is the language used to style HTML. If HTML gives the page its structure, CSS gives it personality, spacing, readability, and visual layout. Without CSS, a page may still work, but it usually looks raw and difficult to scan professionally.',
      'CSS does much more than change colors. It controls typography, alignment, spacing, responsiveness, animations, layout systems, hover behavior, and component consistency. This is why strong CSS knowledge is important even when working with React, Next.js, or design systems.',
      'Students often underestimate CSS because the syntax looks simple. In reality, CSS has deep concepts such as cascade, inheritance, specificity, layout algorithms, stacking, responsiveness, and browser differences. This is why companies still ask CSS questions in interviews, especially for frontend roles.',
      'A professional engineer does not treat CSS as decoration only. CSS directly affects usability, readability, perceived performance, accessibility, and product quality. Bad CSS can make a correct application feel broken, while clean CSS can make a complex interface feel intuitive.',
      'A strong learning path in CSS starts with syntax and selectors, then moves to the box model, layout systems, responsive design, and advanced topics like animations, variables, and maintainable architecture. That is why the CSS tree is now split into focused topics instead of broad combined labels.',
    ],
    practicalTips: [
      'Always understand the HTML structure before styling it.',
      'Write small, readable rules while learning instead of huge blocks.',
      'Study how browser defaults change after your CSS is applied.',
      'Treat CSS as engineering, not as last-minute visual patching.',
    ],
    examples: [
      {
        title: 'First CSS example',
        description: 'A small page with CSS inside a style block.',
        code: '<!DOCTYPE html>\n<html lang="en">\n  <head>\n    <style>\n      h1 {\n        color: #2563eb;\n      }\n      p {\n        font-size: 18px;\n      }\n    </style>\n  </head>\n  <body>\n    <h1>Learning CSS</h1>\n    <p>This paragraph is styled using CSS.</p>\n  </body>\n</html>',
        outputHtml: '<h1 style="color:#2563eb;">Learning CSS</h1><p style="font-size:18px;">This paragraph is styled using CSS.</p>',
      },
    ],
  },
  'css-syntax': {
    heading: 'CSS Syntax',
    easySummary: 'CSS syntax is built from selectors, properties, and values inside rule blocks.',
    theory: [
      'A CSS rule usually contains a selector and a declaration block. Inside the declaration block, you write property-value pairs. For example, color: blue means the property is color and the value is blue. This basic format is small, but everything in CSS grows from it.',
      'Understanding syntax properly matters because small mistakes can silently fail. A missing semicolon, bracket, or wrong property name can stop a rule from working. This can confuse beginners because the page does not always show a clear error message the way JavaScript often does.',
      'CSS syntax also teaches you how browsers interpret style instructions. You are not writing random text. You are describing how selected elements should be rendered. That description must follow valid grammar so the browser can apply it correctly.',
      'As projects grow, clean syntax becomes more important because stylesheets get larger and more interconnected. Proper indentation, consistent formatting, and one responsibility per rule make CSS easier to review and debug.',
      'In interviews, syntax alone is usually not the goal, but weak syntax understanding causes errors in selectors, layout rules, and animation definitions. Solid syntax is the foundation for every advanced CSS topic.',
    ],
    practicalTips: [
      'Close every declaration block carefully.',
      'Use one property per line for readability while learning.',
      'Keep formatting consistent so mistakes are easier to spot.',
    ],
    examples: [
      {
        title: 'Selector with declarations',
        description: 'A minimal valid CSS rule.',
        code: '<style>\n  .card {\n    background: #eff6ff;\n    padding: 16px;\n    border-radius: 12px;\n  }\n</style>\n<div class="card">CSS syntax example</div>',
        outputHtml: '<div style="background:#eff6ff;padding:16px;border-radius:12px;">CSS syntax example</div>',
      },
    ],
  },
  'css-selectors': {
    heading: 'CSS Selectors',
    easySummary: 'Selectors decide which HTML elements a CSS rule will style.',
    theory: [
      'Selectors are one of the most important parts of CSS because they determine where styles apply. If your selector is wrong, your rule may not apply anywhere or may apply to too many elements. This is why selector clarity matters as much as visual design.',
      'Common selectors include element selectors like p, class selectors like .card, id selectors like #header, descendant selectors, child selectors, and attribute selectors. Each one expresses a different relationship between the rule and the HTML structure.',
      'A good selector should be readable and intentional. Overly complex selectors may work today but become fragile when the HTML structure changes. Strong engineers aim for selectors that are specific enough to be safe, but not so tightly coupled that small markup changes break the whole UI.',
      'Selectors are also where CSS starts to feel architectural. How you name classes, how you scope components, and how you avoid conflicts all begin with selector decisions. This becomes very important in larger apps and interview discussions about maintainable CSS.',
      'When students struggle with CSS not applying, the selector is one of the first things to inspect. That habit is worth building early.',
    ],
    practicalTips: [
      'Prefer classes for reusable styling patterns.',
      'Avoid deep selectors unless they are truly needed.',
      'Read the HTML first, then decide the selector.',
    ],
    examples: [
      {
        title: 'Class and element selectors',
        description: 'Different selectors target different parts of the markup.',
        code: '<style>\n  h2 { color: #1d4ed8; }\n  .note { background: #fef3c7; padding: 10px; }\n</style>\n<h2>Lesson Title</h2>\n<p class="note">This note uses a class selector.</p>',
        outputHtml: '<h2 style="color:#1d4ed8;">Lesson Title</h2><p style="background:#fef3c7;padding:10px;">This note uses a class selector.</p>',
      },
    ],
  },
  'css-specificity': {
    heading: 'CSS Specificity',
    easySummary: 'Specificity decides which rule wins when multiple CSS rules target the same element.',
    theory: [
      'Specificity is one of the most important CSS concepts because it explains why a style sometimes does not apply even when the selector appears correct. When multiple rules target the same element, the browser compares selector weight and then decides which rule should win.',
      'In simple terms, id selectors are stronger than class selectors, and class selectors are stronger than element selectors. But the full story also includes source order, inline styles, and !important. This is why CSS can feel confusing until specificity becomes clear.',
      'Strong frontend engineers try not to fight specificity constantly. If every new rule needs stronger selectors or !important, the stylesheet becomes harder to maintain. Clean architecture usually means predictable class-based styling and good component boundaries.',
      'Specificity is a common interview topic because it tests whether someone can debug real UI behavior instead of only writing basic syntax. A good answer should mention selector weight, cascade order, and why !important is usually not the first fix.',
      'If you understand specificity well, debugging CSS becomes much faster and less frustrating.',
    ],
    practicalTips: [
      'Do not use !important as your default solution.',
      'Keep selectors simple and class-driven when possible.',
      'Check source order after checking selector weight.',
    ],
    examples: [
      {
        title: 'Rule winner example',
        description: 'The class selector beats the element selector here.',
        code: '<style>\n  p { color: green; }\n  .warning { color: red; }\n</style>\n<p class="warning">This text becomes red.</p>',
        outputHtml: '<p style="color:red;">This text becomes red.</p>',
      },
    ],
  },
  'css-colors': {
    heading: 'Colors in CSS',
    easySummary: 'CSS colors shape readability, hierarchy, mood, and brand identity.',
    theory: [
      'Color in CSS is not only about decoration. It affects contrast, readability, focus, emotional tone, and interface hierarchy. Good color decisions help users understand what is important, what is interactive, and what state a component is in.',
      'CSS supports many color formats such as named colors, hex, rgb, rgba, hsl, and hsla. Each format has practical use cases. Hex is common in product work, rgba helps with transparency, and hsl can be useful when adjusting hue or lightness more systematically.',
      'Students often choose random colors while learning. That is fine for experimentation, but professional CSS should use consistent palettes. Repetition and structure in color usage make interfaces feel intentional instead of noisy.',
      'Accessibility matters here too. Low contrast text may look stylish in isolation but can be unreadable in real usage. Strong CSS engineers always think about contrast and legibility, not only aesthetics.',
      'In interviews, color is often discussed indirectly through theming, dark mode, state styles, and accessibility. A strong answer connects visual design to user experience quality.',
    ],
    practicalTips: [
      'Choose colors with contrast in mind.',
      'Reuse a consistent small palette instead of many random values.',
      'Use transparency carefully so text stays readable.',
    ],
    examples: [
      {
        title: 'Text and background color',
        description: 'Basic readable color styling.',
        code: '<style>\n  .badge {\n    background: #dbeafe;\n    color: #1e3a8a;\n    padding: 8px 12px;\n  }\n</style>\n<span class="badge">CSS Color Example</span>',
        outputHtml: '<span style="background:#dbeafe;color:#1e3a8a;padding:8px 12px;display:inline-block;">CSS Color Example</span>',
      },
    ],
  },
  'css-backgrounds': {
    heading: 'Backgrounds',
    easySummary: 'Background properties control surface color, images, gradients, and layering.',
    theory: [
      'Background styling helps define surfaces in a UI. Cards, hero sections, callouts, sidebars, and buttons all use background decisions to communicate grouping and emphasis. This is why background is more than just decorative filling.',
      'CSS allows backgrounds to use solid colors, images, gradients, size control, repeat behavior, and position settings. These options are powerful, but the goal should still be clarity. A background should support content instead of making the UI harder to read.',
      'Beginners often use strong gradients or large images everywhere. In professional interfaces, backgrounds are usually chosen more deliberately. The question is not just what looks attractive, but what supports the content and the product purpose.',
      'Backgrounds also interact with performance. Large images or poorly optimized assets can slow the page. Overly bright or busy surfaces can also reduce contrast for text and controls.',
      'In frontend interviews, backgrounds rarely appear as isolated syntax questions, but they appear in real design implementation tasks and responsive layout discussions.',
    ],
    practicalTips: [
      'Test text readability on every background you choose.',
      'Use gradients or images intentionally, not by default.',
      'Keep heavy background assets optimized.',
    ],
    examples: [
      {
        title: 'Gradient card surface',
        description: 'A card using a clean gradient background.',
        code: '<style>\n  .panel {\n    background: linear-gradient(135deg, #eff6ff, #dbeafe);\n    padding: 18px;\n    border-radius: 14px;\n  }\n</style>\n<div class="panel">Background styling demo</div>',
        outputHtml: '<div style="background:linear-gradient(135deg,#eff6ff,#dbeafe);padding:18px;border-radius:14px;">Background styling demo</div>',
      },
    ],
  },
  'css-box-model': {
    heading: 'Box Model',
    easySummary: 'Every element is treated like a box with content, padding, border, and margin.',
    theory: [
      'The CSS box model explains how elements take up space. Every element has content space, optional padding around that content, optional borders, and outer margin. If this concept is weak, spacing bugs become very difficult to reason about.',
      'Many layout issues are actually box model issues. Developers sometimes change width or height without realizing padding and border affect total visual size depending on box-sizing behavior. This creates confusion when elements do not align the way you expect.',
      'Understanding the box model is essential because almost every interface component is a box. Cards, inputs, buttons, modals, banners, and menus all depend on these spacing layers. Once you see that clearly, layout becomes more predictable.',
      'Interviewers ask the box model often because it is one of the best ways to test whether someone truly understands CSS rendering rather than only memorizing property names.',
      'Strong CSS engineers can look at a spacing problem and quickly identify whether content size, padding, border, or margin is responsible. That skill starts here.',
    ],
    practicalTips: [
      'Inspect elements in dev tools to see real box dimensions.',
      'Remember that padding adds internal space and margin adds outer space.',
      'Learn box-sizing early because it changes mental models in useful ways.',
    ],
    examples: [
      {
        title: 'Visible box layers',
        description: 'Padding and border shape the card surface.',
        code: '<style>\n  .box {\n    padding: 20px;\n    border: 2px solid #2563eb;\n    background: #eff6ff;\n  }\n</style>\n<div class="box">Box model example</div>',
        outputHtml: '<div style="padding:20px;border:2px solid #2563eb;background:#eff6ff;">Box model example</div>',
      },
    ],
  },
  'css-margin-padding': {
    heading: 'Margin and Padding',
    easySummary: 'Padding creates space inside an element; margin creates space outside it.',
    theory: [
      'Margin and padding are some of the most used CSS properties, but many students mix them up. Padding creates space between the content and the border of the element. Margin creates space outside the element, pushing other elements away.',
      'This difference matters because visual spacing is not only about making things look nice. It affects grouping, readability, and layout rhythm. Good spacing makes interfaces feel calm and professional. Poor spacing makes even correct content feel crowded or disconnected.',
      'When debugging layouts, it is important to know whether the space you see belongs to the element itself or is being created between neighboring elements. That answer changes how you should fix the problem.',
      'Margin collapsing in normal document flow is another concept developers encounter later. Even before that, just understanding inside-space versus outside-space solves many beginner layout problems.',
      'Interviewers often use margin and padding questions to test practical CSS understanding because these properties appear everywhere in real work.',
    ],
    practicalTips: [
      'Use padding to make content breathe inside a component.',
      'Use margin to create distance between sibling elements.',
      'Keep spacing values consistent across similar components.',
    ],
    examples: [
      {
        title: 'Padding inside, margin outside',
        description: 'The box has inner breathing room and outer separation.',
        code: '<style>\n  .card {\n    margin-top: 16px;\n    padding: 16px;\n    background: #f8fafc;\n    border: 1px solid #cbd5e1;\n  }\n</style>\n<div class="card">Spacing example</div>',
        outputHtml: '<div style="margin-top:16px;padding:16px;background:#f8fafc;border:1px solid #cbd5e1;">Spacing example</div>',
      },
    ],
  },
  'css-display': {
    heading: 'Display',
    easySummary: 'Display controls how an element participates in layout and flow.',
    theory: [
      'The display property is fundamental because it influences whether an element behaves like a block, inline item, inline-block, flex container, grid container, or something else. Understanding display helps you predict how elements stack, wrap, and size themselves.',
      'Block elements usually start on a new line and stretch across available width. Inline elements flow within text content and do not normally accept width and height in the same way. Inline-block gives a middle ground. Flex and grid introduce full layout systems.',
      'Students often try to solve layout bugs without checking display first. That usually slows debugging down. If the display mode is wrong, spacing and sizing tweaks may never produce the expected result.',
      'Display is also an interview topic because it reveals whether someone understands document flow and the difference between default element behavior and layout overrides.',
      'A strong CSS engineer thinks about display early because it decides the basic behavior of the element before more advanced layout rules are layered on top.',
    ],
    practicalTips: [
      'Check the default display behavior of common HTML tags.',
      'Use flex or grid only when layout actually needs it.',
      'Do not fight an element’s flow until you understand its display mode.',
    ],
    examples: [
      {
        title: 'Inline-block example',
        description: 'Two boxes can sit side by side.',
        code: '<style>\n  .chip {\n    display: inline-block;\n    padding: 8px 12px;\n    background: #e0f2fe;\n    margin-right: 8px;\n  }\n</style>\n<span class="chip">HTML</span><span class="chip">CSS</span>',
        outputHtml: '<span style="display:inline-block;padding:8px 12px;background:#e0f2fe;margin-right:8px;">HTML</span><span style="display:inline-block;padding:8px 12px;background:#e0f2fe;">CSS</span>',
      },
    ],
  },
  'css-position': {
    heading: 'Position',
    easySummary: 'Position controls how an element is placed relative to normal flow or a containing block.',
    theory: [
      'The position property changes how elements are placed on the page. Common values include static, relative, absolute, fixed, and sticky. Each one changes layout behavior in a different way, so using position without understanding it often causes confusing results.',
      'Relative positioning keeps the element in normal flow but allows offset adjustment. Absolute positioning removes the element from normal flow and positions it relative to a containing block. Fixed pins content to the viewport, and sticky mixes flow behavior with viewport-based sticking.',
      'Many UI patterns depend on position: tooltips, badges, floating buttons, sticky headers, overlays, and dropdowns. This makes position one of the most practical CSS topics in real product work.',
      'In interviews, position is frequently asked because it tests layout understanding. A strong answer explains not just the keywords, but the effect on normal flow and containing contexts.',
      'Position becomes much easier when you think about what reference point the browser is using and whether the element still participates in normal document flow.',
    ],
    practicalTips: [
      'Set a clear containing block when using absolute positioning.',
      'Use sticky for practical scroll-aware headers or side labels.',
      'Debug position with browser dev tools rather than guessing offsets repeatedly.',
    ],
    examples: [
      {
        title: 'Relative parent with absolute badge',
        description: 'A small status badge placed in a card corner.',
        code: '<style>\n  .wrap {\n    position: relative;\n    width: 220px;\n    padding: 18px;\n    background: #f8fafc;\n    border: 1px solid #cbd5e1;\n  }\n  .badge {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    background: #2563eb;\n    color: white;\n    padding: 4px 8px;\n  }\n</style>\n<div class="wrap">Card content<div class="badge">New</div></div>',
        outputHtml: '<div style="position:relative;width:220px;padding:18px;background:#f8fafc;border:1px solid #cbd5e1;">Card content<div style="position:absolute;top:8px;right:8px;background:#2563eb;color:white;padding:4px 8px;">New</div></div>',
      },
    ],
  },
  'css-flexbox': {
    heading: 'Flexbox',
    easySummary: 'Flexbox is a one-dimensional layout system for aligning items in rows or columns.',
    theory: [
      'Flexbox is designed to make alignment and distribution easier in one dimension at a time. That means you usually think in a row or a column. It is excellent for navbars, toolbars, button groups, cards in a row, and many everyday UI alignment problems.',
      'Once an element becomes a flex container, its children become flex items. Properties like justify-content, align-items, gap, flex-wrap, and flex grow or shrink rules start to matter. These control spacing, alignment, distribution, and responsiveness inside the container.',
      'Students often reach for flexbox very early because it solves many alignment frustrations from normal flow. That is useful, but it is important to understand what problem flex is actually solving so you do not misuse it everywhere.',
      'Flexbox is extremely common in frontend interviews because it tests practical layout knowledge. A strong answer should explain axis thinking clearly: main axis, cross axis, and how alignment properties map to those axes.',
      'Once flexbox clicks, many interface layouts that used to feel hard suddenly become much easier to build and debug.',
    ],
    practicalTips: [
      'Identify the main axis before choosing alignment properties.',
      'Use gap for spacing between items when possible.',
      'Remember that flex is ideal for one-dimensional layout problems.',
    ],
    examples: [
      {
        title: 'Simple flex row',
        description: 'Three items aligned in a row with spacing.',
        code: '<style>\n  .row {\n    display: flex;\n    gap: 12px;\n  }\n  .item {\n    padding: 12px;\n    background: #dbeafe;\n  }\n</style>\n<div class="row">\n  <div class="item">One</div>\n  <div class="item">Two</div>\n  <div class="item">Three</div>\n</div>',
        outputHtml: '<div style="display:flex;gap:12px;"><div style="padding:12px;background:#dbeafe;">One</div><div style="padding:12px;background:#dbeafe;">Two</div><div style="padding:12px;background:#dbeafe;">Three</div></div>',
      },
    ],
  },
  'css-grid': {
    heading: 'Grid',
    easySummary: 'Grid is a two-dimensional layout system for rows and columns together.',
    theory: [
      'CSS Grid is best when your layout needs row and column control at the same time. Unlike flexbox, which is mainly one-dimensional, grid helps with overall page sections, dashboards, cards, gallery layouts, and other structured UI regions.',
      'Grid lets you define columns, rows, gaps, and item placement in a very explicit way. This makes it powerful for layouts that would become awkward if built only with flexbox or manual widths.',
      'Students should not think of grid as a replacement for flexbox. Both are useful. Flexbox is often better for linear alignment, while grid is better for broader two-dimensional layout patterns. Knowing when to choose each is a sign of maturity.',
      'Grid appears in frontend interviews because it tests whether you understand layout beyond simple centering tricks. A strong answer compares flexbox and grid with practical examples rather than treating them as competing buzzwords.',
      'Once you understand columns, gaps, and responsive templates, grid becomes one of the most expressive layout tools in CSS.',
    ],
    practicalTips: [
      'Use grid for structured page or card layouts.',
      'Start with repeat and gap for easier readable templates.',
      'Do not force grid when flexbox solves the problem more simply.',
    ],
    examples: [
      {
        title: 'Three-column grid',
        description: 'A simple grid for cards.',
        code: '<style>\n  .grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n  }\n  .card {\n    background: #ede9fe;\n    padding: 14px;\n  }\n</style>\n<div class="grid">\n  <div class="card">Card 1</div>\n  <div class="card">Card 2</div>\n  <div class="card">Card 3</div>\n</div>',
        outputHtml: '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:12px;"><div style="background:#ede9fe;padding:14px;">Card 1</div><div style="background:#ede9fe;padding:14px;">Card 2</div><div style="background:#ede9fe;padding:14px;">Card 3</div></div>',
      },
    ],
  },
  'css-typography': {
    heading: 'Typography',
    easySummary: 'Typography controls how text feels, reads, and scales across the interface.',
    theory: [
      'Typography is one of the highest-impact parts of CSS because almost every interface contains text. Font size, line height, font weight, letter spacing, alignment, and readable content width all change how easy or difficult the interface feels to use.',
      'Good typography is not only about choosing a nice font. It is about hierarchy and readability. Headings should feel distinct from body text. Supporting text should be lighter but still readable. Line length should not become exhausting. The goal is clarity before decoration.',
      'Students sometimes focus heavily on layout and color while ignoring typography. In real products, poor typography can make even a technically correct UI feel weak. Good typography makes content feel calm, trustworthy, and easier to understand.',
      'In interviews and real tasks, typography often appears in dashboard design, content pages, responsive implementation, and design system consistency. Strong CSS engineers know how to make text readable across devices instead of only large desktop screens.',
      'Typography is where visual polish becomes very noticeable. Small improvements here can elevate the whole product.',
    ],
    practicalTips: [
      'Use line height generously for body text.',
      'Create clear visual difference between heading and paragraph scales.',
      'Avoid too many font sizes in the same screen.',
    ],
    examples: [
      {
        title: 'Headings and text styles showcase',
        description: 'This example shows heading hierarchy from h1 to h6, paragraph styling, and common inline text types.',
        code: '<!DOCTYPE html>\n<html lang="en">\n  <head>\n    <style>\n      body {\n        font-family: Georgia, serif;\n        color: #1f2937;\n        padding: 20px;\n        line-height: 1.7;\n      }\n\n      h1 { font-size: 2.2rem; margin-bottom: 0.6rem; color: #0f172a; }\n      h2 { font-size: 1.85rem; margin-bottom: 0.55rem; color: #1e3a8a; }\n      h3 { font-size: 1.55rem; margin-bottom: 0.5rem; color: #1d4ed8; }\n      h4 { font-size: 1.3rem; margin-bottom: 0.45rem; color: #2563eb; }\n      h5 { font-size: 1.1rem; margin-bottom: 0.4rem; color: #334155; }\n      h6 { font-size: 0.95rem; margin-bottom: 0.35rem; color: #475569; text-transform: uppercase; letter-spacing: 0.06em; }\n\n      p {\n        font-size: 1rem;\n        max-width: 60ch;\n        margin-bottom: 1rem;\n      }\n\n      .text-demo {\n        background: #f8fafc;\n        border: 1px solid #dbeafe;\n        border-radius: 12px;\n        padding: 16px;\n      }\n\n      .text-demo span {\n        display: inline-block;\n        margin: 0.2rem 0.4rem 0.2rem 0;\n      }\n\n      mark {\n        background: #fde68a;\n        padding: 0.1rem 0.2rem;\n      }\n\n      small {\n        color: #64748b;\n      }\n    </style>\n  </head>\n  <body>\n    <h1>H1 Main Page Heading</h1>\n    <h2>H2 Section Heading</h2>\n    <h3>H3 Sub-section Heading</h3>\n    <h4>H4 Smaller Heading</h4>\n    <h5>H5 Minor Heading</h5>\n    <h6>H6 Label Style Heading</h6>\n\n    <p>Paragraph text is used for normal reading content. It should be clear, readable, and comfortable across different screen sizes.</p>\n\n    <div class="text-demo">\n      <span><strong>Strong text</strong></span>\n      <span><em>Emphasized text</em></span>\n      <span><u>Underlined text</u></span>\n      <span><s>Strikethrough text</s></span>\n      <span><mark>Highlighted text</mark></span>\n      <span><small>Small helper text</small></span>\n    </div>\n  </body>\n</html>',
        outputHtml: '<div><h1>H1 Main Page Heading</h1><h2>H2 Section Heading</h2><h3>H3 Sub-section Heading</h3><h4>H4 Smaller Heading</h4><h5>H5 Minor Heading</h5><h6>H6 Label Style Heading</h6><p>Paragraph text is used for normal reading content. It should be clear, readable, and comfortable across different screen sizes.</p><div><strong>Strong text</strong> <em>Emphasized text</em> <u>Underlined text</u> <s>Strikethrough text</s> <mark>Highlighted text</mark> <small>Small helper text</small></div></div>',
      },
    ],
  },
  'css-units': {
    heading: 'Units',
    easySummary: 'CSS units define measurement for spacing, size, typography, and responsive behavior.',
    theory: [
      'CSS units are the measurement system of styling. Common units include px, %, em, rem, vw, and vh. Each has strengths, and understanding when to use which one helps build more predictable and scalable interfaces.',
      'Pixels are direct and easy for beginners, but relative units become more valuable as the interface grows. rem is often used for scalable typography and spacing systems because it stays tied to the root font size. Percentages help with relative sizing inside containers.',
      'Viewport units can be useful for certain hero or screen-based designs, but they should be used carefully because they can behave differently across devices and browser UI states.',
      'Interviews may ask about px vs rem, or when relative units are better than fixed units. A strong answer usually includes accessibility, scalability, and responsive design considerations.',
      'Good unit choices help your CSS feel stable now and easier to maintain later.',
    ],
    practicalTips: [
      'Use rem often for scalable text and spacing systems.',
      'Use percentages when element sizing depends on its container.',
      'Avoid mixing too many unit types without a clear reason.',
    ],
    examples: [
      {
        title: 'Relative spacing example',
        description: 'A card using rem values.',
        code: '<style>\n  .unit-card {\n    padding: 1rem;\n    font-size: 1rem;\n    border-radius: 0.75rem;\n    background: #f1f5f9;\n  }\n</style>\n<div class="unit-card">Using rem units</div>',
        outputHtml: '<div style="padding:1rem;font-size:1rem;border-radius:0.75rem;background:#f1f5f9;">Using rem units</div>',
      },
    ],
  },
  'css-responsive': {
    heading: 'Responsive Design',
    easySummary: 'Responsive design helps interfaces adapt cleanly across desktop, tablet, and mobile screens.',
    theory: [
      'Responsive design means the interface should adjust gracefully across screen sizes instead of being optimized for only one width. This affects layout, spacing, typography, image behavior, and interaction density.',
      'Media queries are a key part of responsive CSS. They allow different style rules based on screen conditions such as width. But responsive design is not only about writing breakpoints. It starts with flexible layouts, sensible content hierarchy, and components that can shrink or stack without breaking.',
      'Students sometimes think responsive work comes at the end. In strong frontend work, responsiveness is part of the design and implementation process from the beginning. A layout that only works on one screen size is incomplete.',
      'Interviewers often ask how you make components responsive. A strong answer includes layout systems, media queries, typography scaling, flexible spacing, and testing on real devices or emulated sizes.',
      'Responsive design is one of the clearest places where CSS directly affects product quality in a visible way.',
    ],
    practicalTips: [
      'Design content flow for smaller screens early.',
      'Prefer fluid layouts before adding many breakpoint patches.',
      'Test both readability and interaction spacing on mobile.',
    ],
    examples: [
      {
        title: 'Responsive stacking',
        description: 'Cards switch to one column on smaller screens.',
        code: '<style>\n  .layout {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 12px;\n  }\n  @media (max-width: 600px) {\n    .layout {\n      grid-template-columns: 1fr;\n    }\n  }\n  .panel {\n    padding: 14px;\n    background: #dbeafe;\n  }\n</style>\n<div class="layout">\n  <div class="panel">Panel 1</div>\n  <div class="panel">Panel 2</div>\n</div>',
        outputHtml: '<div style="display:grid;grid-template-columns:repeat(2,1fr);gap:12px;"><div style="padding:14px;background:#dbeafe;">Panel 1</div><div style="padding:14px;background:#dbeafe;">Panel 2</div></div>',
      },
    ],
  },
  'css-transitions': {
    heading: 'Transitions',
    easySummary: 'Transitions smooth changes between one visual state and another.',
    theory: [
      'Transitions help state changes feel smoother and more intentional. Instead of a button instantly snapping between colors or sizes, a transition lets that change happen over a short duration. This often makes the interface feel more polished.',
      'A transition is not the same as a full animation sequence. It usually responds to a state change such as hover, focus, or class change. Because of that, transitions are often used for buttons, cards, modals, links, and interactive controls.',
      'Good transitions are subtle. They support usability rather than demanding attention. If motion is too aggressive, it can make the product feel noisy or tiring. Strong frontend engineers use motion with discipline.',
      'In interviews, transitions may appear in implementation tasks or be discussed alongside performance and accessibility. It is useful to know how timing, easing, and property choice affect the quality of motion.',
      'A small transition can make a UI feel much more professional when used correctly.',
    ],
    practicalTips: [
      'Animate opacity, transform, and similar properties carefully for smoother feel.',
      'Keep durations short for common interface interactions.',
      'Use transitions to support meaning, not to create distraction.',
    ],
    examples: [
      {
        title: 'Hover transition',
        description: 'A button changes smoothly on hover.',
        code: '<style>\n  .cta {\n    background: #2563eb;\n    color: white;\n    padding: 12px 16px;\n    border: none;\n    transition: background 0.25s ease;\n  }\n  .cta:hover {\n    background: #1d4ed8;\n  }\n</style>\n<button class="cta">Hover Me</button>',
        outputHtml: '<button style="background:#2563eb;color:white;padding:12px 16px;border:none;transition:background .25s ease;">Hover Me</button>',
      },
    ],
  },
  'css-animations': {
    heading: 'Animations',
    easySummary: 'Animations create multi-step motion sequences over time using keyframes.',
    theory: [
      'Animations are more expressive than transitions because they can define multiple keyframes and run automatically or repeatedly. This makes them useful for loaders, entrances, attention cues, and guided motion in product interfaces.',
      'CSS animations should be used carefully. Motion can improve feedback and polish, but too much animation makes the interface harder to focus on. Strong product motion supports the user task instead of pulling attention away from it.',
      'When animations are used, properties such as opacity and transform are often preferred because they are generally more performance-friendly than animating layout-heavy properties. Understanding this makes your CSS not only more attractive but also more practical.',
      'Animations appear in frontend interviews through design tasks, microinteraction questions, and performance discussions. A strong answer connects the animation to user purpose, not only syntax.',
      'Motion is best when it feels intentional, restrained, and aligned with the product experience.',
    ],
    practicalTips: [
      'Use animations for meaning, not constant decoration.',
      'Keep keyframes simple while learning.',
      'Prefer transform and opacity for smoother visual performance.',
    ],
    examples: [
      {
        title: 'Floating badge animation',
        description: 'A small repeating motion using keyframes.',
        code: '<style>\n  @keyframes floatUpDown {\n    0% { transform: translateY(0); }\n    50% { transform: translateY(-6px); }\n    100% { transform: translateY(0); }\n  }\n  .tag {\n    display: inline-block;\n    padding: 10px 14px;\n    background: #e0e7ff;\n    animation: floatUpDown 1.8s ease-in-out infinite;\n  }\n</style>\n<div class="tag">Animated Tag</div>',
        outputHtml: '<div style="display:inline-block;padding:10px 14px;background:#e0e7ff;animation:floatUpDown 1.8s ease-in-out infinite;">Animated Tag</div>',
      },
    ],
  },
  'css-variables': {
    heading: 'CSS Variables',
    easySummary: 'CSS variables help reuse design values and make themes easier to manage.',
    theory: [
      'CSS variables, also called custom properties, let you store reusable values such as colors, spacing, border radius, or shadows. Instead of repeating the same literal values everywhere, you define them once and reference them where needed.',
      'This becomes very useful in larger applications. Theme changes, light and dark modes, design system consistency, and maintainability all improve when important visual values are centralized.',
      'Variables also help reduce mistakes. If a brand color changes, updating one root variable is much easier than searching many scattered rules. This is why variables are common in modern frontend systems.',
      'In interviews, CSS variables may be discussed in relation to theming, design systems, and maintainable architecture. A strong answer should connect them to scaling and consistency rather than just syntax.',
      'Variables show how CSS can support long-term engineering quality, not only one-page styling.',
    ],
    practicalTips: [
      'Store commonly reused colors and spacing values as variables.',
      'Use root-level variables for global theme tokens.',
      'Name variables by purpose, not only by appearance, when possible.',
    ],
    examples: [
      {
        title: 'Theme variables starter',
        description: 'Reuse a primary color through variables.',
        code: '<style>\n  :root {\n    --primary: #2563eb;\n    --surface: #eff6ff;\n  }\n  .token-card {\n    background: var(--surface);\n    color: var(--primary);\n    padding: 16px;\n  }\n</style>\n<div class="token-card">Styled with CSS variables</div>',
        outputHtml: '<div style="background:#eff6ff;color:#2563eb;padding:16px;">Styled with CSS variables</div>',
      },
    ],
  },
  'css-pseudo-classes': {
    heading: 'Pseudo-classes',
    easySummary: 'Pseudo-classes style elements based on state, position, or interaction.',
    theory: [
      'Pseudo-classes allow CSS to react to element state without JavaScript in many cases. Examples include :hover, :focus, :active, :first-child, and :nth-child. These selectors are very useful for making interfaces interactive and expressive.',
      'The key idea is that pseudo-classes describe a condition. You are not selecting a new element type. You are selecting an existing element when it is in a certain state or relationship. This makes pseudo-classes powerful for links, buttons, lists, forms, and navigation patterns.',
      'A professional frontend engineer thinks carefully about states, not just static appearance. Hover, focus, disabled, visited, and active styles all affect usability and perceived polish. Keyboard users especially benefit from clear focus states.',
      'Pseudo-classes appear often in interviews because they connect CSS syntax with user interaction and accessibility behavior. A strong answer should show both conceptual understanding and practical examples.',
      'Once you use pseudo-classes well, your interface starts feeling more alive and responsive without needing much extra code.',
    ],
    practicalTips: [
      'Always style focus states, not only hover states.',
      'Use pseudo-classes to improve feedback, not only decoration.',
      'Test interaction states with both mouse and keyboard.',
    ],
    examples: [
      {
        title: 'Hover and focus states',
        description: 'Interactive styling without JavaScript.',
        code: '<style>\n  .link-btn {\n    color: #1d4ed8;\n    text-decoration: none;\n  }\n  .link-btn:hover,\n  .link-btn:focus {\n    text-decoration: underline;\n  }\n</style>\n<a class="link-btn" href="#">Open Lesson</a>',
        outputHtml: '<a style="color:#1d4ed8;text-decoration:none;" href="#">Open Lesson</a>',
      },
    ],
  },
  'css-pseudo-elements': {
    heading: 'Pseudo-elements',
    easySummary: 'Pseudo-elements style a specific part of an element or insert generated content.',
    theory: [
      'Pseudo-elements let you target part of an element or create generated content. Common examples include ::before, ::after, ::first-letter, and ::selection. These are useful when you want visual enhancement without adding extra HTML elements.',
      'Generated content can help with icons, decorative accents, badges, or instructional markers, but it should be used thoughtfully. If the content is essential meaning, it usually belongs in HTML instead of only being generated by CSS.',
      'Pseudo-elements are a strong example of CSS power because they let you enrich the interface while keeping markup lighter. At the same time, overusing them can make styles harder to understand if they are doing too much structural work.',
      'In interviews, pseudo-elements may appear in implementation challenges or styling discussions about reusable patterns. A strong answer explains both usefulness and limitations.',
      'Knowing when to keep content in HTML and when to use pseudo-elements for decoration is an important design judgment skill.',
    ],
    practicalTips: [
      'Use pseudo-elements mainly for decoration or non-essential helpers.',
      'Avoid hiding critical information only in generated content.',
      'Keep pseudo-element usage readable and intentional.',
    ],
    examples: [
      {
        title: 'Decorative before label',
        description: 'A label gains a decorative marker with CSS.',
        code: '<style>\n  .title::before {\n    content: "• ";\n    color: #2563eb;\n  }\n</style>\n<h3 class="title">Pseudo-element Demo</h3>',
        outputHtml: '<h3><span style="color:#2563eb;">• </span>Pseudo-element Demo</h3>',
      },
    ],
  },
};

export const JS_LESSONS = {
  'js-introduction': {
    heading: 'JavaScript Introduction and Setup',
    easySummary: 'JavaScript makes web pages interactive, dynamic, and programmable in the browser and on servers.',
    theory: [
      'JavaScript started as a browser scripting language, but today it powers frontend applications, backend APIs, automation scripts, desktop apps, and cloud functions. A strong foundation starts with understanding where JavaScript runs and what environment APIs are available in each place.',
      'In browsers, JavaScript runs inside a JavaScript engine such as V8, SpiderMonkey, or JavaScriptCore. Your code can access Web APIs like DOM, fetch, localStorage, and timers through the browser environment, not through the language itself.',
      'A practical beginner roadmap is: learn language basics first, then learn browser interaction, then asynchronous patterns, then architecture and debugging. Many learners jump to frameworks too early and later struggle with core logic and debugging.'
    ],
    practicalTips: [
      'Use strict mode and clear naming from day one.',
      'Keep examples small, run them in browser console, then move to larger files.',
      'Build mini projects early to connect syntax with real behavior.',
    ],
    examples: [
      {
        title: 'First runnable JavaScript snippet',
        description: 'A simple script that updates text and logs output.',
        code: '<h3 id="msg">Loading...</h3>\n<script>\n  const student = "Aman";\n  document.getElementById("msg").textContent = `Welcome, ${student}!`;\n  console.log("JS is running");\n</script>',
        outputHtml: '<h3>Welcome, Aman!</h3>',
      },
    ],
  },
  'js-variables-datatypes': {
    heading: 'Variables and Data Types',
    easySummary: 'Variables store values, and JavaScript data types define how those values behave.',
    theory: [
      'Use let for reassignable variables and const for fixed references. var is function-scoped and usually avoided in modern code because it increases confusion around hoisting and accidental re-declaration.',
      'Primitive types are string, number, bigint, boolean, undefined, symbol, and null. Objects, arrays, functions, and dates are reference types. Knowing this distinction is essential for equality checks, copying, and mutation behavior.',
      'JavaScript is dynamically typed, so values can change type at runtime. That flexibility is useful, but careless conversions can create bugs. Professional code uses explicit conversions and validation where needed.'
    ],
    practicalTips: [
      'Prefer const by default and switch to let only when reassignment is required.',
      'Use Number(), String(), and Boolean() for explicit conversion.',
      'Use Array.isArray() and typeof checks before operations.',
    ],
    examples: [
      {
        title: 'Type checks and explicit conversion',
        description: 'Demonstrates primitive types and explicit conversion.',
        code: '<script>\n  const ageText = "21";\n  const age = Number(ageText);\n  const active = Boolean(1);\n  document.body.innerHTML = `<p>age: ${age} (${typeof age})</p><p>active: ${active}</p>`;\n</script>',
        outputHtml: '<p>age: 21 (number)</p><p>active: true</p>',
      },
    ],
  },
  'js-operators-conditions': {
    heading: 'Operators and Conditions',
    easySummary: 'Operators transform values and conditions control code flow based on logic.',
    theory: [
      'JavaScript operators include arithmetic, assignment, comparison, logical, nullish coalescing, optional chaining, and ternary expressions. Correct operator choice makes code predictable and readable.',
      'Comparison operators can be tricky because of type coercion. Strict equality (===) checks value and type, while loose equality (==) performs coercion. Interview and production code usually expects strict equality unless coercion is intentional.',
      'Conditions with if/else, switch, and ternary should prioritize clarity. Write conditions so that future readers can quickly understand edge cases and fallback behavior.'
    ],
    practicalTips: [
      'Prefer === and !== in almost all cases.',
      'Use nullish coalescing (??) for null/undefined fallbacks.',
      'Keep nested conditions shallow by using guard clauses.',
    ],
    examples: [
      {
        title: 'Guarded rendering with strict checks',
        description: 'Shows strict comparison and fallback values.',
        code: '<script>\n  const score = 78;\n  const grade = score >= 90 ? "A" : score >= 75 ? "B" : "C";\n  const nickname = null ?? "Guest";\n  document.body.innerHTML = `<p>Grade: ${grade}</p><p>User: ${nickname}</p>`;\n</script>',
        outputHtml: '<p>Grade: B</p><p>User: Guest</p>',
      },
    ],
  },
  'js-loops-functions': {
    heading: 'Loops and Functions',
    easySummary: 'Loops repeat logic and functions encapsulate reusable behavior.',
    theory: [
      'JavaScript loops include for, while, do...while, for...of, and for...in. Each loop has a specific best-fit scenario. A strong developer knows which one to select instead of forcing one loop everywhere.',
      'for loop works best when you need index control: start, stop, step size, reverse traversal, or skipping values. while loop fits cases where the number of iterations is not known upfront and continues while a condition stays true.',
      'do...while always runs the block at least once before checking the condition. This is useful in prompt/retry style flows and sentinel loops where one first attempt is mandatory.',
      'for...of iterates values from arrays, strings, maps, sets, and other iterables. for...in iterates enumerable keys, usually for plain object property traversal. For arrays, for...in is usually avoided because it iterates keys as strings and can include inherited enumerable keys.',
      'Array iteration helpers like forEach also represent looping behavior. They are callback-based and very common in UI rendering logic, but they are not ideal when you need break/continue control.',
      'Functions are first-class values: they can be assigned, passed, returned, and stored. This capability powers callbacks, higher-order functions, and event-driven programming patterns across modern JavaScript.',
      'Clean function design means one clear responsibility, predictable inputs, and explicit return values. Small functions are easier to test and debug than large functions with mixed responsibilities.'
    ],
    practicalTips: [
      'Use for when index math or break/continue control is required.',
      'Use while for condition-driven repetition where iteration count is dynamic.',
      'Use do...while when one execution is always required.',
      'Use for...of for arrays when readability matters.',
      'Use for...in for plain object keys and combine with Object.hasOwn when needed.',
      'Use forEach for callback style iteration when break/continue is not needed.',
      'Prefer pure functions for business logic where possible.',
      'Avoid deeply nested loops; break work into helper functions.',
    ],
    examples: [
      {
        title: 'for loop with index progression',
        description: 'Shows controlled index traversal with start, condition, and increment.',
        code: '<script>\n  const nums = [10, 20, 30, 40];\n  const lines = [];\n  for (let i = 0; i < nums.length; i += 1) {\n    lines.push(`i=${i}, value=${nums[i]}`);\n  }\n  document.body.innerHTML = `<pre>${lines.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>i=0, value=10\ni=1, value=20\ni=2, value=30\ni=3, value=40</pre>',
      },
      {
        title: 'for loop with break and continue',
        description: 'Skips specific values and stops when a condition is met.',
        code: '<script>\n  const output = [];\n  for (let i = 1; i <= 8; i += 1) {\n    if (i === 3) continue;\n    if (i === 7) break;\n    output.push(i);\n  }\n  document.body.innerHTML = `<pre>${output.join(", ")}</pre>`;\n</script>',
        outputHtml: '<pre>1, 2, 4, 5, 6</pre>',
      },
      {
        title: 'while loop with dynamic condition',
        description: 'Runs until a changing condition becomes false.',
        code: '<script>\n  let count = 1;\n  const lines = [];\n  while (count <= 5) {\n    lines.push(`count=${count}`);\n    count += 1;\n  }\n  document.body.innerHTML = `<pre>${lines.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>count=1\ncount=2\ncount=3\ncount=4\ncount=5</pre>',
      },
      {
        title: 'do while loop executes at least once',
        description: 'Condition is checked after the first execution.',
        code: '<script>\n  let tries = 0;\n  const log = [];\n  do {\n    tries += 1;\n    log.push(`attempt=${tries}`);\n  } while (tries < 1);\n  document.body.innerHTML = `<pre>${log.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>attempt=1</pre>',
      },
      {
        title: 'for of loop for array values',
        description: 'Iterates direct values from iterable collections.',
        code: '<script>\n  const skills = ["HTML", "CSS", "JS"];\n  const lines = [];\n  for (const skill of skills) {\n    lines.push(`skill=${skill}`);\n  }\n  document.body.innerHTML = `<pre>${lines.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>skill=HTML\nskill=CSS\nskill=JS</pre>',
      },
      {
        title: 'for in loop for object keys',
        description: 'Traverses object keys and reads values with bracket access.',
        code: '<script>\n  const profile = { name: "Asha", track: "Frontend", batch: "B12" };\n  const lines = [];\n  for (const key in profile) {\n    if (Object.hasOwn(profile, key)) {\n      lines.push(`${key}: ${profile[key]}`);\n    }\n  }\n  document.body.innerHTML = `<pre>${lines.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>name: Asha\ntrack: Frontend\nbatch: B12</pre>',
      },
      {
        title: 'forEach callback loop with index',
        description: 'Callback-based loop useful in rendering and formatting pipelines.',
        code: '<script>\n  const prices = [120, 80, 150];\n  const lines = [];\n  prices.forEach((price, index) => {\n    lines.push(`row-${index}: INR ${price}`);\n  });\n  document.body.innerHTML = `<pre>${lines.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>row-0: INR 120\nrow-1: INR 80\nrow-2: INR 150</pre>',
      },
      {
        title: 'Nested loops for grid output',
        description: 'Demonstrates two-level iteration clearly in visible output.',
        code: '<script>\n  const lines = [];\n  for (let r = 1; r <= 3; r += 1) {\n    for (let c = 1; c <= 3; c += 1) {\n      lines.push(`cell(${r},${c})`);\n    }\n  }\n  document.body.innerHTML = `<pre>${lines.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>cell(1,1)\ncell(1,2)\ncell(1,3)\ncell(2,1)\ncell(2,2)\ncell(2,3)\ncell(3,1)\ncell(3,2)\ncell(3,3)</pre>',
      },
      {
        title: 'Function plus loop reusable utility',
        description: 'Combines loop logic inside a reusable pure function.',
        code: '<script>\n  function buildSquares(limit) {\n    const out = [];\n    for (let n = 1; n <= limit; n += 1) {\n      out.push(`${n}^2=${n * n}`);\n    }\n    return out;\n  }\n  document.body.innerHTML = `<pre>${buildSquares(5).join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>1^2=1\n2^2=4\n3^2=9\n4^2=16\n5^2=25</pre>',
      },
    ],
  },
  'js-arrays-objects': {
    heading: 'Arrays and Objects',
    easySummary: 'Arrays manage ordered lists and objects model structured data with keys and values.',
    theory: [
      'Arrays support methods such as map, filter, reduce, find, some, and every. These functional methods often produce cleaner logic than manual index loops, especially in UI data transformation.',
      'Objects represent entities and configs. Understanding shallow copy vs deep copy is important because nested references can unintentionally mutate shared state.',
      'In modern app code, arrays and objects are constantly transformed for rendering, API mapping, state updates, and sorting. Mastery here has direct impact on coding speed and bug prevention.',
      'For interview and production confidence, you should know each method separately: its parameters, whether it mutates original data, what it returns, and how before/after state changes.'
    ],
    practicalTips: [
      'Use spread syntax for immutable updates.',
      'Use map/filter over manual mutation when possible.',
      'Be careful with nested objects; clone intentionally.',
      'For each method, rehearse before-array/object, method call, and after-state in your own words.',
    ],
    referenceSections: [
      {
        title: 'Array methods and properties detailed map',
        intro: 'Every method listed separately with parameter shape, mutation behavior, and return kind.',
        columns: [
          { key: 'method', label: 'Method / Property' },
          { key: 'params', label: 'Parameters' },
          { key: 'mutates', label: 'Mutates original' },
          { key: 'returns', label: 'Return kind' },
          { key: 'useCase', label: 'Best use case' },
        ],
        rows: [
          { method: 'map', params: '(callback, thisArg?)', mutates: 'No', returns: 'New array', useCase: 'Transform each item to new shape' },
          { method: 'filter', params: '(callback, thisArg?)', mutates: 'No', returns: 'New array', useCase: 'Keep matching items only' },
          { method: 'reduce', params: '(callback, initialValue)', mutates: 'No', returns: 'Any type', useCase: 'Accumulate to one value or object' },
          { method: 'find', params: '(callback, thisArg?)', mutates: 'No', returns: 'Item or undefined', useCase: 'Pick first matching item' },
          { method: 'some', params: '(callback, thisArg?)', mutates: 'No', returns: 'Boolean', useCase: 'Check if at least one matches' },
          { method: 'every', params: '(callback, thisArg?)', mutates: 'No', returns: 'Boolean', useCase: 'Check if all items match' },
          { method: 'includes', params: '(valueToFind, fromIndex?)', mutates: 'No', returns: 'Boolean', useCase: 'Simple existence check' },
          { method: 'push', params: '(...items)', mutates: 'Yes', returns: 'New length number', useCase: 'Add items at end' },
          { method: 'pop', params: '()', mutates: 'Yes', returns: 'Removed item', useCase: 'Remove last item' },
          { method: 'shift', params: '()', mutates: 'Yes', returns: 'Removed first item', useCase: 'Remove first item' },
          { method: 'unshift', params: '(...items)', mutates: 'Yes', returns: 'New length number', useCase: 'Add items at start' },
          { method: 'splice', params: '(start, deleteCount, ...items)', mutates: 'Yes', returns: 'Array of removed items', useCase: 'Insert/delete in middle' },
          { method: 'slice', params: '(start?, end?)', mutates: 'No', returns: 'New array', useCase: 'Copy part of array' },
          { method: 'concat', params: '(...arraysOrValues)', mutates: 'No', returns: 'New array', useCase: 'Merge arrays immutably' },
          { method: 'flat', params: '(depth = 1)', mutates: 'No', returns: 'New array', useCase: 'Flatten nested arrays' },
          { method: 'flatMap', params: '(callback, thisArg?)', mutates: 'No', returns: 'New array', useCase: 'Map then flatten depth 1' },
          { method: 'length', params: 'Property', mutates: 'Can mutate if set manually', returns: 'Number', useCase: 'Count items / truncate when reassigned' },
        ],
      },
      {
        title: 'Object methods and properties detailed map',
        intro: 'Object utilities with parameter form, mutation behavior, and practical purpose.',
        columns: [
          { key: 'method', label: 'Method / Property' },
          { key: 'params', label: 'Parameters' },
          { key: 'mutates', label: 'Mutates target' },
          { key: 'returns', label: 'Return kind' },
          { key: 'useCase', label: 'Best use case' },
        ],
        rows: [
          { method: 'Object.keys', params: '(obj)', mutates: 'No', returns: 'Array<string>', useCase: 'Iterate own enumerable keys' },
          { method: 'Object.values', params: '(obj)', mutates: 'No', returns: 'Array<any>', useCase: 'Iterate own values only' },
          { method: 'Object.entries', params: '(obj)', mutates: 'No', returns: 'Array<[key, value]>', useCase: 'Key/value iteration and conversion' },
          { method: 'Object.assign', params: '(target, ...sources)', mutates: 'Yes (target)', returns: 'Target object', useCase: 'Shallow copy or merge objects' },
          { method: 'Object.freeze', params: '(obj)', mutates: 'Locks object', returns: 'Same object', useCase: 'Prevent add/remove/write at top level' },
          { method: 'Object.hasOwn', params: '(obj, prop)', mutates: 'No', returns: 'Boolean', useCase: 'Safe own-property check' },
          { method: 'hasOwnProperty', params: '(prop)', mutates: 'No', returns: 'Boolean', useCase: 'Legacy own-property check' },
        ],
      },
    ],
    examples: [
      {
        title: 'map and filter with before/after state',
        description: 'Separate transformations using callback parameters and immutable output arrays.',
        code: '<script>\n  const nums = [1, 2, 3, 4, 5];\n  const doubled = nums.map((value, index) => value * 2 + index);\n  const evenOnly = nums.filter((value) => value % 2 === 0);\n  document.body.innerHTML = `<pre>nums before: ${JSON.stringify(nums)}\nmap(callback): ${JSON.stringify(doubled)}\nfilter(callback): ${JSON.stringify(evenOnly)}\nnums after: ${JSON.stringify(nums)}</pre>`;\n</script>',
        outputHtml: '<pre>nums before: [1,2,3,4,5]\nmap(callback): [2,5,8,11,14]\nfilter(callback): [2,4]\nnums after: [1,2,3,4,5]</pre>',
      },
      {
        title: 'reduce and find with explicit parameters',
        description: 'Shows accumulator flow and first-match search behavior.',
        code: '<script>\n  const prices = [120, 80, 240, 60];\n  const total = prices.reduce((acc, current, idx) => acc + current + idx, 0);\n  const firstHigh = prices.find((price) => price > 100);\n  document.body.innerHTML = `<pre>prices before: ${JSON.stringify(prices)}\nreduce((acc,current,idx),0): ${total}\nfind((price)=>price>100): ${firstHigh}\nprices after: ${JSON.stringify(prices)}</pre>`;\n</script>',
        outputHtml: '<pre>prices before: [120,80,240,60]\nreduce((acc,current,idx),0): 506\nfind((price)=>price>100): 120\nprices after: [120,80,240,60]</pre>',
      },
      {
        title: 'some every includes checks',
        description: 'Boolean checks for partial match, full match, and direct membership.',
        code: '<script>\n  const marks = [72, 81, 69, 94];\n  const hasDistinction = marks.some((m) => m >= 90);\n  const allPassed = marks.every((m) => m >= 35);\n  const hasSixtyNine = marks.includes(69);\n  document.body.innerHTML = `<pre>marks before: ${JSON.stringify(marks)}\nsome(m>=90): ${hasDistinction}\nevery(m>=35): ${allPassed}\nincludes(69): ${hasSixtyNine}\nmarks after: ${JSON.stringify(marks)}</pre>`;\n</script>',
        outputHtml: '<pre>marks before: [72,81,69,94]\nsome(m>=90): true\nevery(m>=35): true\nincludes(69): true\nmarks after: [72,81,69,94]</pre>',
      },
      {
        title: 'push pop shift unshift mutation flow',
        description: 'Demonstrates list mutation methods and how original array changes step by step.',
        code: '<script>\n  const queue = ["A", "B", "C"];\n  const lenAfterPush = queue.push("D", "E");\n  const popped = queue.pop();\n  const shifted = queue.shift();\n  const lenAfterUnshift = queue.unshift("START");\n  document.body.innerHTML = `<pre>after push(\"D\",\"E\") length: ${lenAfterPush}\nafter pop() removed: ${popped}\nafter shift() removed: ${shifted}\nafter unshift(\"START\") length: ${lenAfterUnshift}\nqueue final: ${JSON.stringify(queue)}</pre>`;\n</script>',
        outputHtml: '<pre>after push("D","E") length: 5\nafter pop() removed: E\nafter shift() removed: A\nafter unshift("START") length: 4\nqueue final: ["START","B","C","D"]</pre>',
      },
      {
        title: 'splice insertion and removal',
        description: 'Shows in-place updates with start index, delete count, and inserted items.',
        code: '<script>\n  const list = ["html", "css", "react", "node"];\n  const removed = list.splice(2, 1, "javascript", "typescript");\n  document.body.innerHTML = `<pre>before: [\"html\",\"css\",\"react\",\"node\"]\nsplice(2,1,\"javascript\",\"typescript\") removed: ${JSON.stringify(removed)}\nafter: ${JSON.stringify(list)}</pre>`;\n</script>',
        outputHtml: '<pre>before: ["html","css","react","node"]\nsplice(2,1,"javascript","typescript") removed: ["react"]\nafter: ["html","css","javascript","typescript","node"]</pre>',
      },
      {
        title: 'slice concat flat flatMap immutable flow',
        description: 'Creates derived arrays without mutating source array.',
        code: '<script>\n  const nested = [[1, 2], [3, 4], [5]];\n  const part = nested.slice(0, 2);\n  const merged = part.concat([[6, 7]]);\n  const flattened = merged.flat(2);\n  const expanded = [1, 2, 3].flatMap((n) => [n, n * 10]);\n  document.body.innerHTML = `<pre>nested before: ${JSON.stringify(nested)}\nslice(0,2): ${JSON.stringify(part)}\nconcat([[6,7]]): ${JSON.stringify(merged)}\nflat(2): ${JSON.stringify(flattened)}\nflatMap(n=>[n,n*10]): ${JSON.stringify(expanded)}\nnested after: ${JSON.stringify(nested)}</pre>`;\n</script>',
        outputHtml: '<pre>nested before: [[1,2],[3,4],[5]]\nslice(0,2): [[1,2],[3,4]]\nconcat([[6,7]]): [[1,2],[3,4],[6,7]]\nflat(2): [1,2,3,4,6,7]\nflatMap(n=>[n,n*10]): [1,10,2,20,3,30]\nnested after: [[1,2],[3,4],[5]]</pre>',
      },
      {
        title: 'Object.keys values entries traversal',
        description: 'Covers object iteration forms with key list, value list, and entry tuples.',
        code: '<script>\n  const student = { id: 101, name: "Asha", track: "Frontend" };\n  const keys = Object.keys(student);\n  const values = Object.values(student);\n  const entries = Object.entries(student);\n  document.body.innerHTML = `<pre>object before: ${JSON.stringify(student)}\nObject.keys(obj): ${JSON.stringify(keys)}\nObject.values(obj): ${JSON.stringify(values)}\nObject.entries(obj): ${JSON.stringify(entries)}\nobject after: ${JSON.stringify(student)}</pre>`;\n</script>',
        outputHtml: '<pre>object before: {"id":101,"name":"Asha","track":"Frontend"}\nObject.keys(obj): ["id","name","track"]\nObject.values(obj): [101,"Asha","Frontend"]\nObject.entries(obj): [["id",101],["name","Asha"],["track","Frontend"]]\nobject after: {"id":101,"name":"Asha","track":"Frontend"}</pre>',
      },
      {
        title: 'Object.assign freeze hasOwn utilities',
        description: 'Demonstrates shallow merge, lock behavior, and own-property checks.',
        code: '<script>\n  const base = { role: "student", active: true };\n  const extra = { city: "Bhopal", active: false };\n  const merged = Object.assign({}, base, extra);\n  const config = Object.freeze({ mode: "strict", version: 1 });\n  const hasRole = Object.hasOwn(merged, "role");\n  const hasToString = Object.hasOwn(merged, "toString");\n  document.body.innerHTML = `<pre>base before: ${JSON.stringify(base)}\nextra before: ${JSON.stringify(extra)}\nObject.assign({}, base, extra): ${JSON.stringify(merged)}\nObject.freeze({mode,version}): ${JSON.stringify(config)}\nObject.hasOwn(merged,\"role\"): ${hasRole}\nObject.hasOwn(merged,\"toString\"): ${hasToString}</pre>`;\n</script>',
        outputHtml: '<pre>base before: {"role":"student","active":true}\nextra before: {"city":"Bhopal","active":false}\nObject.assign({}, base, extra): {"role":"student","active":false,"city":"Bhopal"}\nObject.freeze({mode,version}): {"mode":"strict","version":1}\nObject.hasOwn(merged,"role"): true\nObject.hasOwn(merged,"toString"): false</pre>',
      },
    ],
  },
  'js-dom': {
    heading: 'DOM Basics',
    easySummary: 'The DOM is a tree representation of the page that JavaScript can query and update at runtime.',
    theory: [
      'When the browser parses HTML, it creates the Document Object Model. JavaScript reads and manipulates this tree to update text, attributes, classes, and structure. This is the foundation of dynamic frontend behavior.',
      'DOM operations are expensive compared to plain in-memory operations. Frequent layout-affecting updates can cause reflow and repaint costs, so batching updates and minimizing unnecessary manipulation improves performance.',
      'Good DOM code separates selection, state logic, and rendering. Even when using frameworks, understanding raw DOM behavior helps debug rendering and event issues.'
    ],
    practicalTips: [
      'Cache repeated selectors instead of querying repeatedly.',
      'Prefer class toggles over manual inline style mutation.',
      'Use document fragments for larger list updates.',
    ],
    examples: [
      {
        title: 'DOM query and class toggle',
        description: 'Updates content and toggles style via class.',
        code: '<style>.ok{color:#15803d;font-weight:700;}</style>\n<p id="status">Pending...</p>\n<script>\n  const el = document.getElementById("status");\n  el.textContent = "Loaded successfully";\n  el.classList.add("ok");\n</script>',
        outputHtml: '<p style="color:#15803d;font-weight:700;">Loaded successfully</p>',
      },
      {
        title: 'querySelector and querySelectorAll usage',
        description: 'Select single and multiple nodes and show count with values.',
        code: '<ul>\n  <li class="topic">HTML</li>\n  <li class="topic">CSS</li>\n  <li class="topic">JS</li>\n</ul>\n<p id="dom-out"></p>\n<script>\n  const first = document.querySelector(".topic");\n  const all = document.querySelectorAll(".topic");\n  document.getElementById("dom-out").textContent = `first=${first.textContent}, total=${all.length}`;\n</script>',
        outputHtml: '<p>first=HTML, total=3</p>',
      },
      {
        title: 'classList add remove toggle',
        description: 'Apply, remove, and toggle CSS classes in sequence.',
        code: '<style>.chip{padding:6px 10px;border-radius:8px}.on{background:#dcfce7;color:#166534}.off{background:#fee2e2;color:#991b1b}</style>\n<div id="chip" class="chip off">status</div>\n<pre id="class-log"></pre>\n<script>\n  const chip = document.getElementById("chip");\n  const log = [];\n  chip.classList.add("on");\n  chip.classList.remove("off");\n  log.push(`after add/remove: ${chip.className}`);\n  chip.classList.toggle("on");\n  log.push(`after toggle once: ${chip.className}`);\n  chip.classList.toggle("on");\n  log.push(`after toggle twice: ${chip.className}`);\n  document.getElementById("class-log").textContent = log.join("\\n");\n</script>',
        outputHtml: '<pre>after add/remove: chip on\nafter toggle once: chip\nafter toggle twice: chip on</pre>',
      },
      {
        title: 'textContent vs innerHTML',
        description: 'Demonstrates plain text assignment and HTML markup insertion.',
        code: '<div id="t"></div>\n<div id="h"></div>\n<script>\n  const t = document.getElementById("t");\n  const h = document.getElementById("h");\n  t.textContent = "<b>safe text</b>";\n  h.innerHTML = "<b>bold html</b>";\n</script>',
        outputHtml: '<p>&lt;b&gt;safe text&lt;/b&gt;</p><p><strong>bold html</strong></p>',
      },
      {
        title: 'setAttribute and getAttribute',
        description: 'Set attributes dynamically and read them back for verification.',
        code: '<a id="docs" href="#">Docs</a>\n<pre id="attr-log"></pre>\n<script>\n  const a = document.getElementById("docs");\n  a.setAttribute("target", "_blank");\n  a.setAttribute("rel", "noopener");\n  a.setAttribute("data-track", "learn-dom");\n  const lines = [\n    `target=${a.getAttribute("target")}`,\n    `rel=${a.getAttribute("rel")}`,\n    `data-track=${a.getAttribute("data-track")}`\n  ];\n  document.getElementById("attr-log").textContent = lines.join("\\n");\n</script>',
        outputHtml: '<pre>target=_blank\nrel=noopener\ndata-track=learn-dom</pre>',
      },
    ],
  },
  'js-events': {
    heading: 'Event Handling',
    easySummary: 'Events connect user actions to JavaScript behavior through listeners and propagation phases.',
    theory: [
      'Browser events include click, input, change, submit, keydown, scroll, and many more. addEventListener is the standard way to subscribe to events and keep behavior modular.',
      'Events propagate through capture, target, and bubble phases. Understanding bubbling is critical for delegation, modal handling, and preventing unintended parent handlers from firing.',
      'Event bubbling means a click on child first runs child listener, then parent listener, then grandparent listener (unless propagation is stopped). This makes parent-level handling possible without binding a listener on every child element.',
      'Event delegation attaches one listener to a parent and handles child interactions using target matching. This improves performance and simplifies dynamic list handling, especially when children are created later.',
      'You can trigger events programmatically using dispatchEvent, which is useful for testing propagation flow and verifying UI logic paths without manual clicking every time.'
    ],
    practicalTips: [
      'For nested click UIs, log target and currentTarget while debugging propagation.',
      'Use event delegation for dynamic lists and tables.',
      'Use closest() with data attributes to detect intended child action reliably.',
      'Use stopPropagation() only when parent behavior must not run.',
      'Use capture listeners intentionally; do not mix phases without a clear reason.',
      'Call preventDefault only when needed.',
      'Always clean listeners in long-living components to avoid leaks.',
    ],
    examples: [
      {
        title: 'Bubbling flow visual child to parent to grandparent',
        description: 'Animated cursor auto-clicks child box and highlights bubbling path with visible logs.',
        code: '<style>\n  .ev-wrap{font-family:Arial,sans-serif;max-width:880px;}\n  .ev-stage{position:relative;height:260px;border:1px solid #cbd5e1;border-radius:14px;background:linear-gradient(180deg,#f8fafc,#eef6ff);padding:16px;overflow:hidden;}\n  .ev-box{display:flex;align-items:center;justify-content:center;border-radius:12px;font-weight:700;letter-spacing:.2px;transition:all .25s ease;}\n  .ev-grand{height:210px;border:2px solid #3b82f6;background:rgba(59,130,246,.08);color:#0f172a;padding:12px;}\n  .ev-parent{height:140px;width:78%;border:2px solid #10b981;background:rgba(16,185,129,.1);}\n  .ev-child{height:76px;width:52%;border:2px solid #f97316;background:rgba(249,115,22,.16);cursor:pointer;}\n  .ev-active-child{box-shadow:0 0 0 6px rgba(249,115,22,.22);transform:scale(1.02);}\n  .ev-active-parent{box-shadow:0 0 0 6px rgba(16,185,129,.2);}\n  .ev-active-grand{box-shadow:0 0 0 6px rgba(59,130,246,.2);}\n  .ev-cursor{position:absolute;left:34px;top:24px;font-size:24px;animation:evMove 2.2s ease-in-out forwards;color:#111827;}\n  @keyframes evMove{0%{transform:translate(0,0) scale(1)}60%{transform:translate(410px,122px) scale(1)}66%{transform:translate(410px,122px) scale(.85)}72%{transform:translate(410px,122px) scale(1.05)}100%{transform:translate(410px,122px) scale(1)}}\n  .ev-log{margin-top:10px;padding:10px 12px;border:1px solid #cbd5e1;border-radius:10px;background:#0f172a;color:#e2e8f0;min-height:110px;white-space:pre-line;font-size:13px;line-height:1.5;}\n  .ev-note{margin-top:8px;color:#334155;font-size:13px;}\n</style>\n<div class="ev-wrap">\n  <div class="ev-stage">\n    <div id="ev-grand" class="ev-box ev-grand">\n      grandparent\n      <div id="ev-parent" class="ev-box ev-parent">\n        parent\n        <button id="ev-child" class="ev-box ev-child" type="button">child</button>\n      </div>\n    </div>\n    <div class="ev-cursor">🖱</div>\n  </div>\n  <div id="ev-log" class="ev-log">Waiting for click...</div>\n  <p class="ev-note">Flow shown here uses bubbling phase: child -> parent -> grandparent.</p>\n</div>\n<script>\n  const child = document.getElementById("ev-child");\n  const parent = document.getElementById("ev-parent");\n  const grand = document.getElementById("ev-grand");\n  const log = document.getElementById("ev-log");\n  const lines = [];\n\n  function mark(el, cls){\n    el.classList.add(cls);\n    setTimeout(() => el.classList.remove(cls), 520);\n  }\n\n  function push(message){\n    lines.push(message);\n    log.textContent = lines.join("\\n");\n  }\n\n  child.addEventListener("click", (event) => {\n    mark(child, "ev-active-child");\n    push(`1) child listener | target=${event.target.id} | currentTarget=${event.currentTarget.id}`);\n  });\n\n  parent.addEventListener("click", (event) => {\n    mark(parent, "ev-active-parent");\n    push(`2) parent listener | target=${event.target.id} | currentTarget=${event.currentTarget.id}`);\n  });\n\n  grand.addEventListener("click", (event) => {\n    mark(grand, "ev-active-grand");\n    push(`3) grandparent listener | target=${event.target.id} | currentTarget=${event.currentTarget.id}`);\n  });\n\n  setTimeout(() => {\n    child.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));\n  }, 900);\n</script>',
        outputHtml: '<p>Animated bubbling path: child -> parent -> grandparent with highlighted boxes and event log.</p>',
      },
      {
        title: 'Event delegation with dynamic children',
        description: 'Single parent listener handles existing and newly added child buttons.',
        code: '<style>\n  .dg-wrap{font-family:Arial,sans-serif;max-width:760px;}\n  .dg-list{display:flex;gap:8px;flex-wrap:wrap;margin-top:8px;}\n  .dg-btn{padding:7px 10px;border:1px solid #93c5fd;border-radius:8px;background:#eff6ff;cursor:pointer;}\n  .dg-log{margin-top:10px;padding:10px;border:1px solid #cbd5e1;border-radius:8px;background:#0f172a;color:#e2e8f0;white-space:pre-line;min-height:84px;}\n</style>\n<div class="dg-wrap">\n  <button id="dg-add" type="button">Add child item</button>\n  <div id="dg-list" class="dg-list">\n    <button class="dg-btn" data-id="1" type="button">item-1</button>\n    <button class="dg-btn" data-id="2" type="button">item-2</button>\n  </div>\n  <div id="dg-log" class="dg-log">Delegation log:</div>\n</div>\n<script>\n  const list = document.getElementById("dg-list");\n  const add = document.getElementById("dg-add");\n  const log = document.getElementById("dg-log");\n  let id = 2;\n\n  function write(text){\n    log.textContent += `\\n${text}`;\n  }\n\n  list.addEventListener("click", (event) => {\n    const btn = event.target.closest("[data-id]");\n    if (!btn || !list.contains(btn)) return;\n    write(`clicked child data-id=${btn.dataset.id} | handled at parent list`);\n  });\n\n  add.addEventListener("click", () => {\n    id += 1;\n    const btn = document.createElement("button");\n    btn.type = "button";\n    btn.className = "dg-btn";\n    btn.dataset.id = String(id);\n    btn.textContent = `item-${id}`;\n    list.appendChild(btn);\n    write(`added new child item-${id} (works without new listener)`);\n  });\n</script>',
        outputHtml: '<p>Parent-level delegation catches clicks from current and future child buttons.</p>',
      },
      {
        title: 'Bubbling stopped with stopPropagation',
        description: 'Child click runs child handler but prevents parent/grandparent bubble handlers.',
        code: '<style>\n  .sp-box{font-family:Arial,sans-serif;border-radius:10px;padding:10px;text-align:center;font-weight:700;}\n  .sp-grand{border:2px solid #2563eb;background:#dbeafe;}\n  .sp-parent{border:2px solid #16a34a;background:#dcfce7;margin:12px auto;width:80%;}\n  .sp-child{border:2px solid #f97316;background:#ffedd5;padding:8px 12px;border-radius:8px;cursor:pointer;}\n  .sp-log{margin-top:10px;padding:10px;border:1px solid #cbd5e1;border-radius:8px;background:#111827;color:#e5e7eb;white-space:pre-line;}\n</style>\n<div id="sp-grand" class="sp-box sp-grand">grandparent\n  <div id="sp-parent" class="sp-box sp-parent">parent\n    <button id="sp-child" class="sp-child" type="button">child (click me)</button>\n  </div>\n</div>\n<div id="sp-log" class="sp-log">Click child to test.</div>\n<script>\n  const glog = document.getElementById("sp-log");\n  const write = (m) => { glog.textContent += `\\n${m}`; };\n  document.getElementById("sp-child").addEventListener("click", (e) => {\n    write("child handler executed");\n    e.stopPropagation();\n    write("stopPropagation called");\n  });\n  document.getElementById("sp-parent").addEventListener("click", () => write("parent handler executed"));\n  document.getElementById("sp-grand").addEventListener("click", () => write("grandparent handler executed"));\n</script>',
        outputHtml: '<p>With stopPropagation on child, parent and grandparent bubble handlers do not execute.</p>',
      },
      {
        title: 'Capture vs bubble order logger',
        description: 'Shows listener order when both capture and bubble handlers are attached.',
        code: '<div id="cb-grand" style="font-family:Arial,sans-serif;border:2px solid #2563eb;background:#dbeafe;border-radius:10px;padding:10px;">grandparent\n  <div id="cb-parent" style="border:2px solid #16a34a;background:#dcfce7;border-radius:10px;padding:10px;margin:10px auto;width:80%;">parent\n    <button id="cb-child" type="button" style="border:2px solid #f97316;background:#ffedd5;border-radius:8px;padding:8px 12px;cursor:pointer;">child</button>\n  </div>\n</div>\n<pre id="cb-log" style="margin-top:10px;background:#0f172a;color:#e2e8f0;border-radius:8px;padding:10px;min-height:100px;">click child to inspect order</pre>\n<script>\n  const out = document.getElementById("cb-log");\n  const seq = [];\n  const add = (msg) => { seq.push(msg); out.textContent = seq.join("\\n"); };\n  const g = document.getElementById("cb-grand");\n  const p = document.getElementById("cb-parent");\n  const c = document.getElementById("cb-child");\n\n  g.addEventListener("click", () => add("capture: grandparent"), true);\n  p.addEventListener("click", () => add("capture: parent"), true);\n  c.addEventListener("click", () => add("target: child"));\n  p.addEventListener("click", () => add("bubble: parent"));\n  g.addEventListener("click", () => add("bubble: grandparent"));\n</script>',
        outputHtml: '<p>Click child to see order: capture grandparent -> capture parent -> target child -> bubble parent -> bubble grandparent.</p>',
      },
      {
        title: 'removeEventListener and once lifecycle',
        description: 'Attaches and removes listeners with explicit lifecycle logs.',
        code: '<button id="rm-btn" type="button">Trigger</button>\n<pre id="rm-log"></pre>\n<script>\n  const btn = document.getElementById("rm-btn");\n  const log = document.getElementById("rm-log");\n  const lines = [];\n\n  function permanent(){ lines.push("permanent fired"); log.textContent = lines.join("\\n"); }\n  function removable(){ lines.push("removable fired"); log.textContent = lines.join("\\n"); btn.removeEventListener("click", removable); lines.push("removable removed"); log.textContent = lines.join("\\n"); }\n\n  btn.addEventListener("click", permanent);\n  btn.addEventListener("click", removable);\n  btn.addEventListener("click", () => { lines.push("once listener fired"); log.textContent = lines.join("\\n"); }, { once: true });\n\n  btn.dispatchEvent(new MouseEvent("click", { bubbles: true }));\n  btn.dispatchEvent(new MouseEvent("click", { bubbles: true }));\n</script>',
        outputHtml: '<pre>permanent fired\nremovable fired\nremovable removed\nonce listener fired\npermanent fired</pre>',
      },
      {
        title: 'preventDefault on form submit',
        description: 'Prevents navigation and prints controlled submit output.',
        code: '<form id="ev-form" action="https://example.com">\n  <input id="ev-name" value="Asha" />\n  <button type="submit">Submit</button>\n</form>\n<pre id="ev-form-log"></pre>\n<script>\n  const form = document.getElementById("ev-form");\n  const out = document.getElementById("ev-form-log");\n  form.addEventListener("submit", (event) => {\n    event.preventDefault();\n    out.textContent = `defaultPrevented=${event.defaultPrevented}\\nname=${document.getElementById("ev-name").value}`;\n  });\n  form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));\n</script>',
        outputHtml: '<pre>defaultPrevented=true\nname=Asha</pre>',
      },
      {
        title: 'stopImmediatePropagation on same node listeners',
        description: 'Stops later listeners on same element and also prevents ancestor propagation.',
        code: '<button id="sip" type="button">Run listeners</button>\n<pre id="sip-log"></pre>\n<script>\n  const btn = document.getElementById("sip");\n  const log = document.getElementById("sip-log");\n  const lines = [];\n  const push = (m) => { lines.push(m); log.textContent = lines.join("\\n"); };\n\n  btn.addEventListener("click", (event) => { push("listener-1"); event.stopImmediatePropagation(); });\n  btn.addEventListener("click", () => push("listener-2 should not run"));\n  document.body.addEventListener("click", () => push("body listener should not run"), { once: true });\n\n  btn.dispatchEvent(new MouseEvent("click", { bubbles: true }));\n</script>',
        outputHtml: '<pre>listener-1</pre>',
      },
      {
        title: 'event.key and event.code keyboard demo',
        description: 'Shows key value and physical key code mapping on keydown.',
        code: '<input id="key-input" placeholder="Press a key" />\n<pre id="key-log">Waiting...</pre>\n<script>\n  const input = document.getElementById("key-input");\n  const out = document.getElementById("key-log");\n  input.addEventListener("keydown", (event) => {\n    out.textContent = `key=${event.key}\\ncode=${event.code}\\nphase=${event.eventPhase}\\nbubbles=${event.bubbles}`;\n  });\n  input.focus();\n</script>',
        outputHtml: '<pre>Focus input and press a key to view key/code/phase/bubbles values.</pre>',
      },
    ],
  },
  'js-es6': {
    heading: 'ES6+ Features',
    easySummary: 'Modern JavaScript features improve readability, modularity, and maintainability.',
    theory: [
      'ES6 and later versions introduced let/const, arrow functions, template literals, destructuring, default params, rest/spread, classes, modules, and more. These are standard in modern frontend and backend JavaScript.',
      'Destructuring and spread syntax reduce boilerplate in object and array transformations. Template literals improve string composition and make dynamic UI rendering easier to read.',
      'Modern syntax should not be used only because it is new. The right feature should improve clarity and reduce error-prone code patterns.'
    ],
    practicalTips: [
      'Use destructuring for clear parameter extraction.',
      'Use rest/spread for immutable updates.',
      'Avoid over-compacting code when readability suffers.',
    ],
    examples: [
      {
        title: 'Destructuring and spread',
        description: 'Modern syntax for clean updates.',
        code: '<script>\n  const user = { name: "Riya", city: "Bhopal", role: "student" };\n  const { name, ...rest } = user;\n  const next = { ...rest, active: true };\n  document.body.innerHTML = `<p>${name}</p><pre>${JSON.stringify(next)}</pre>`;\n</script>',
        outputHtml: '<p>Riya</p><pre>{"city":"Bhopal","role":"student","active":true}</pre>',
      },
      {
        title: 'Template literals and object shorthand',
        description: 'Creates readable strings and concise objects.',
        code: '<script>\n  const course = "JavaScript";\n  const level = "Advanced";\n  const message = `${course} - ${level} track`;\n  const id = 101;\n  const trainer = "Aman";\n  const card = { id, trainer, message };\n  document.body.innerHTML = `<pre>${message}\\n${JSON.stringify(card)}</pre>`;\n</script>',
        outputHtml: '<pre>JavaScript - Advanced track\n{"id":101,"trainer":"Aman","message":"JavaScript - Advanced track"}</pre>',
      },
      {
        title: 'Default params and rest params',
        description: 'Uses default fallback values and variable argument collection.',
        code: '<script>\n  function greet(name = "Guest") { return `Hello ${name}`; }\n  function sumAll(...nums) { return nums.reduce((a, b) => a + b, 0); }\n  const out = [greet(), greet("Neha"), `sum=${sumAll(5, 10, 15, 20)}`];\n  document.body.innerHTML = `<pre>${out.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>Hello Guest\nHello Neha\nsum=50</pre>',
      },
      {
        title: 'Array and object destructuring together',
        description: 'Extracts from arrays and nested objects in one flow.',
        code: '<script>\n  const arr = ["HTML", "CSS", "JS"];\n  const [first, second] = arr;\n  const profile = { user: { city: "Indore", batch: "B12" } };\n  const { user: { city, batch } } = profile;\n  document.body.innerHTML = `<pre>first=${first}\\nsecond=${second}\\ncity=${city}\\nbatch=${batch}</pre>`;\n</script>',
        outputHtml: '<pre>first=HTML\nsecond=CSS\ncity=Indore\nbatch=B12</pre>',
      },
    ],
  },
  'js-execution-context-call-stack': {
    heading: 'Execution Context and Call Stack',
    easySummary: 'JavaScript runs by creating execution contexts and pushing function calls onto a stack.',
    theory: [
      'Every JavaScript program begins with a global execution context. Function calls create new execution contexts. The call stack tracks currently running contexts, last-in first-out.',
      'A stack overflow occurs when function calls recurse without a stopping condition. Understanding stack behavior helps debug recursion issues, async misunderstandings, and execution order bugs.',
      'Behind the scenes, JavaScript engines parse code, create scopes, and execute statements while managing stack frames and memory references. This engine-level model is central to advanced debugging.'
    ],
    practicalTips: [
      'Trace function order manually when debugging.',
      'Use breakpoints to observe stack frames in DevTools.',
      'Always define a base case in recursion.',
    ],
    examples: [
      {
        title: 'Stack order demo',
        description: 'Nested calls show execution order clearly.',
        code: '<script>\n  function one(){ two(); }\n  function two(){ three(); }\n  function three(){ document.body.innerHTML = "Check console for call order"; }\n  console.log("start");\n  one();\n  console.log("end");\n</script>',
        outputHtml: '<p>Check console for call order</p>',
      },
      {
        title: 'Global and function execution context logs',
        description: 'Shows top-level context values and nested function context values.',
        code: '<script>\n  const appName = "LearnJS";\n  function runModule(moduleName) {\n    const local = `${moduleName}-context`;\n    return `global=${appName}, function=${local}`;\n  }\n  document.body.innerHTML = `<pre>${runModule("events")}</pre>`;\n</script>',
        outputHtml: '<pre>global=LearnJS, function=events-context</pre>',
      },
      {
        title: 'Call stack trace capture',
        description: 'Throws and catches an error to show stack path text.',
        code: '<pre id="stack-log"></pre>\n<script>\n  function a(){ b(); }\n  function b(){ c(); }\n  function c(){ throw new Error("trace"); }\n  try {\n    a();\n  } catch (err) {\n    const firstLines = String(err.stack || "no stack").split("\\n").slice(0, 4).join("\\n");\n    document.getElementById("stack-log").textContent = firstLines;\n  }\n</script>',
        outputHtml: '<pre>Error stack preview with call order a -> b -> c is shown.</pre>',
      },
      {
        title: 'Heap reference behavior',
        description: 'Shows object mutation through shared reference and cloned copy.',
        code: '<script>\n  const original = { score: 10 };\n  const refCopy = original;\n  const shallowClone = { ...original };\n  refCopy.score = 20;\n  shallowClone.score = 30;\n  document.body.innerHTML = `<pre>original=${original.score}\\nrefCopy=${refCopy.score}\\nshallowClone=${shallowClone.score}</pre>`;\n</script>',
        outputHtml: '<pre>original=20\nrefCopy=20\nshallowClone=30</pre>',
      },
      {
        title: 'Scope chain and safe recursion base case',
        description: 'Resolves outer variable through scope chain and avoids stack overflow with base case.',
        code: '<script>\n  const tax = 0.1;\n  function finalPrice(price){ return price + price * tax; }\n  function factorial(n){ if (n <= 1) return 1; return n * factorial(n - 1); }\n  document.body.innerHTML = `<pre>scope chain price=${finalPrice(100)}\\nfactorial(5)=${factorial(5)}</pre>`;\n</script>',
        outputHtml: '<pre>scope chain price=110\nfactorial(5)=120</pre>',
      },
    ],
  },
  'js-hoisting-tdz': {
    heading: 'Hoisting and Temporal Dead Zone',
    easySummary: 'Hoisting moves declarations in setup phase, but let/const stay inaccessible in their temporal dead zone.',
    theory: [
      'JavaScript hoists declarations during compilation-like setup before execution. Function declarations are fully hoisted, while var is hoisted as undefined. let and const are hoisted but uninitialized.',
      'The temporal dead zone is the region between scope start and variable initialization for let/const. Accessing variables there throws ReferenceError, which prevents many silent bugs seen with var.',
      'Interview questions often mix hoisting, scope, and function expressions. The safest mental model is: declaration exists early, initialization happens where assignment is written.'
    ],
    practicalTips: [
      'Declare variables near first use for readability.',
      'Prefer function declarations for reusable top-level utilities.',
      'Avoid var in modern codebases.',
    ],
    examples: [
      {
        title: 'var vs let behavior',
        description: 'Shows why let is safer for modern code.',
        code: '<script>\n  console.log(a);\n  var a = 10;\n  // console.log(b); // ReferenceError if uncommented\n  let b = 20;\n  document.body.innerHTML = `<p>a=${a}, b=${b}</p>`;\n</script>',
        outputHtml: '<p>a=10, b=20</p>',
      },
      {
        title: 'const initialization rules',
        description: 'Shows const initialization and reassignment guard behavior.',
        code: '<script>\n  const user = "Asha";\n  let note = "const created";\n  try {\n    // user = "Neha"; // would throw TypeError if uncommented\n    note += " and reassignment is blocked";\n  } catch (e) {\n    note = e.message;\n  }\n  document.body.innerHTML = `<pre>${user}\\n${note}</pre>`;\n</script>',
        outputHtml: '<pre>Asha\nconst created and reassignment is blocked</pre>',
      },
      {
        title: 'Function declaration hoisting',
        description: 'Function declaration can be called before its textual definition.',
        code: '<script>\n  const msg = welcome("Riya");\n  function welcome(name){ return `Welcome ${name}`; }\n  document.body.innerHTML = `<pre>${msg}</pre>`;\n</script>',
        outputHtml: '<pre>Welcome Riya</pre>',
      },
      {
        title: 'Function expression hoisting behavior',
        description: 'Variable exists before assignment but callable function comes after assignment.',
        code: '<script>\n  let beforeType = typeof greetExp;\n  var greetExp = function(name){ return `Hi ${name}`; };\n  let afterValue = greetExp("Aman");\n  document.body.innerHTML = `<pre>before assignment type=${beforeType}\\nafter assignment call=${afterValue}</pre>`;\n</script>',
        outputHtml: '<pre>before assignment type=undefined\nafter assignment call=Hi Aman</pre>',
      },
      {
        title: 'Class declaration TDZ demonstration',
        description: 'Class declarations are not usable before declaration point.',
        code: '<script>\n  let before;\n  try {\n    before = StudentProfile;\n  } catch (error) {\n    before = "ReferenceError before class declaration";\n  }\n  class StudentProfile {\n    constructor(name){ this.name = name; }\n  }\n  const p = new StudentProfile("Kiran");\n  document.body.innerHTML = `<pre>${before}\\nafter declaration name=${p.name}</pre>`;\n</script>',
        outputHtml: '<pre>ReferenceError before class declaration\nafter declaration name=Kiran</pre>',
      },
    ],
  },
  'js-scope-closures': {
    heading: 'Scope and Closures',
    easySummary: 'Scope controls variable visibility, and closures let functions remember variables from outer scopes.',
    theory: [
      'JavaScript has lexical scope, meaning scope is determined by code position, not call location. Functions can access variables from their own scope and parent scopes.',
      'A closure is created when a function retains access to outer variables even after outer function execution completes. Closures power private state, factories, memoization, and many framework patterns.',
      'Closures are powerful but can also retain memory unexpectedly if references are kept too long. This matters in long-running single-page applications.'
    ],
    practicalTips: [
      'Use closures intentionally for state encapsulation.',
      'Avoid capturing large objects unnecessarily.',
      'Name factory functions clearly to improve readability.',
    ],
    examples: [
      {
        title: 'Closure counter',
        description: 'Private count persists between calls.',
        code: '<script>\n  function createCounter(){\n    let count = 0;\n    return () => ++count;\n  }\n  const next = createCounter();\n  document.body.innerHTML = `<p>${next()}, ${next()}, ${next()}</p>`;\n</script>',
        outputHtml: '<p>1, 2, 3</p>',
      },
      {
        title: 'Global scope visibility',
        description: 'Top-level constant is readable inside inner functions.',
        code: '<script>\n  const academy = "Algodoor";\n  function show(){ return `academy=${academy}`; }\n  document.body.innerHTML = `<pre>${show()}</pre>`;\n</script>',
        outputHtml: '<pre>academy=Algodoor</pre>',
      },
      {
        title: 'Function scope isolation',
        description: 'Function-local variable is available only inside function body.',
        code: '<script>\n  function build(){\n    const localId = "FN-42";\n    return `inside=${localId}`;\n  }\n  const line = build();\n  document.body.innerHTML = `<pre>${line}</pre>`;\n</script>',
        outputHtml: '<pre>inside=FN-42</pre>',
      },
      {
        title: 'Block scope with let and const',
        description: 'Variables declared in block are isolated from outer scope.',
        code: '<script>\n  let outer = "outside";\n  let summary = "";\n  {\n    const inner = "inside";\n    summary = `${outer} -> ${inner}`;\n  }\n  document.body.innerHTML = `<pre>${summary}</pre>`;\n</script>',
        outputHtml: '<pre>outside -> inside</pre>',
      },
      {
        title: 'IIFE isolated scope',
        description: 'Immediately invoked function creates private isolated variables.',
        code: '<script>\n  const result = (function(){\n    const secret = "IIFE-private";\n    return `value=${secret}`;\n  })();\n  document.body.innerHTML = `<pre>${result}</pre>`;\n</script>',
        outputHtml: '<pre>value=IIFE-private</pre>',
      },
      {
        title: 'Closure retains outer memory',
        description: 'Returned function keeps parent variable alive between calls.',
        code: '<script>\n  function makeTag(prefix){\n    return function(id){ return `${prefix}-${id}`; };\n  }\n  const mk = makeTag("JS");\n  document.body.innerHTML = `<pre>${mk(1)}\\n${mk(2)}\\n${mk(3)}</pre>`;\n</script>',
        outputHtml: '<pre>JS-1\nJS-2\nJS-3</pre>',
      },
      {
        title: 'Reference release and memory hygiene',
        description: 'Shows practical cleanup pattern for long-running apps.',
        code: '<script>\n  let cache = { big: new Array(1000).fill("data") };\n  const before = cache.big.length;\n  cache = null;\n  const after = String(cache);\n  document.body.innerHTML = `<pre>before release length=${before}\\nafter release ref=${after}</pre>`;\n</script>',
        outputHtml: '<pre>before release length=1000\nafter release ref=null</pre>',
      },
    ],
  },
  'js-this-keyword': {
    heading: 'this Keyword and Binding Rules',
    easySummary: 'The value of this depends on how a function is called, not where it is written.',
    theory: [
      'In object method calls, this points to the calling object. In plain function calls (strict mode), this is undefined. Arrow functions do not bind their own this; they inherit from lexical parent scope.',
      'call, apply, and bind allow explicit control over this. bind returns a new function with fixed this, useful in callbacks and event handler setup.',
      'Most this-related bugs come from passing methods as callbacks without preserving context. Understanding binding rules avoids subtle runtime failures.'
    ],
    practicalTips: [
      'Use arrow functions inside classes/components for lexical this when appropriate.',
      'Use bind for method callbacks when context must be preserved.',
      'Prefer explicit parameters over heavy this usage in utility functions.',
    ],
    examples: [
      {
        title: 'Binding example',
        description: 'Shows explicit this binding with bind.',
        code: '<script>\n  const user = { name: "Neha" };\n  function greet(){ return `Hi ${this.name}`; }\n  const bound = greet.bind(user);\n  document.body.innerHTML = `<p>${bound()}</p>`;\n</script>',
        outputHtml: '<p>Hi Neha</p>',
      },
    ],
  },
  'js-prototypes-inheritance': {
    heading: 'Prototypes and Inheritance',
    easySummary: 'JavaScript uses prototype-based inheritance where objects can delegate property lookup to prototype chains.',
    theory: [
      'Every object has an internal prototype link. When a property is not found on the object itself, JavaScript looks up the prototype chain. This delegation model is core to JavaScript object behavior.',
      'Class syntax is syntactic sugar over prototypes. Understanding prototypes helps when debugging methods, inheritance behavior, and memory usage from shared methods.',
      'Prototype pollution and accidental extension of global prototypes can introduce security and stability risks. In production code, avoid modifying built-in prototypes.'
    ],
    practicalTips: [
      'Put shared methods on prototypes instead of duplicating per object.',
      'Use class syntax for readability, but learn underlying prototype model.',
      'Avoid mutating Object.prototype or Array.prototype.',
      'Practice prototype questions by predicting hasOwnProperty and instanceof outcomes first, then run code.',
    ],
    examples: [
      {
        title: 'Prototype method sharing',
        description: 'Instances share one prototype method.',
        code: '<script>\n  function Student(name){ this.name = name; }\n  Student.prototype.say = function(){ return `I am ${this.name}`; };\n  const s = new Student("Kiran");\n  document.body.innerHTML = `<p>${s.say()}</p>`;\n</script>',
        outputHtml: '<p>I am Kiran</p>',
      },
      {
        title: 'Object.getPrototypeOf and __proto__ inspection',
        description: 'Reads prototype via standard API and legacy debug property.',
        code: '<script>\n  const user = { role: "student" };\n  const protoA = Object.getPrototypeOf(user);\n  const protoB = user.__proto__;\n  document.body.innerHTML = `<pre>Object.getPrototypeOf(user) === Object.prototype : ${protoA === Object.prototype}\\nuser.__proto__ === Object.prototype : ${protoB === Object.prototype}</pre>`;\n</script>',
        outputHtml: '<pre>Object.getPrototypeOf(user) === Object.prototype : true\nuser.__proto__ === Object.prototype : true</pre>',
      },
      {
        title: 'Object.setPrototypeOf and inherited method access',
        description: 'Assigns custom prototype and accesses inherited method on object.',
        code: '<script>\n  const proto = { greet(){ return "hello from proto"; } };\n  const target = { id: 10 };\n  Object.setPrototypeOf(target, proto);\n  document.body.innerHTML = `<pre>${target.greet()}\\nprototype linked=${Object.getPrototypeOf(target) === proto}</pre>`;\n</script>',
        outputHtml: '<pre>hello from proto\nprototype linked=true</pre>',
      },
      {
        title: 'hasOwnProperty vs inherited property',
        description: 'Differentiates own keys from prototype keys.',
        code: '<script>\n  const base = { campus: "Bangalore" };\n  const student = Object.create(base);\n  student.name = "Asha";\n  const ownName = student.hasOwnProperty("name");\n  const ownCampus = student.hasOwnProperty("campus");\n  const readCampus = student.campus;\n  document.body.innerHTML = `<pre>hasOwn(name)=${ownName}\\nhasOwn(campus)=${ownCampus}\\nread inherited campus=${readCampus}</pre>`;\n</script>',
        outputHtml: '<pre>hasOwn(name)=true\nhasOwn(campus)=false\nread inherited campus=Bangalore</pre>',
      },
      {
        title: 'instanceof and class extends behavior',
        description: 'Checks prototype chain through class inheritance.',
        code: '<script>\n  class Animal {}\n  class Dog extends Animal {}\n  const d = new Dog();\n  document.body.innerHTML = `<pre>d instanceof Dog = ${d instanceof Dog}\\nd instanceof Animal = ${d instanceof Animal}\\nd instanceof Object = ${d instanceof Object}</pre>`;\n</script>',
        outputHtml: '<pre>d instanceof Dog = true\nd instanceof Animal = true\nd instanceof Object = true</pre>',
      },
      {
        title: 'Tricky output question prototype chain lookup',
        description: 'Question: why value changes without direct property update? Explanation: assignment on child creates own property after inherited read.',
        code: '<script>\n  const parent = { score: 10 };\n  const child = Object.create(parent);\n  const before = child.score;\n  child.score = 25;\n  const afterChild = child.score;\n  const afterParent = parent.score;\n  document.body.innerHTML = `<pre>before child.score=${before}\\nafter child.score=${afterChild}\\nparent.score stays=${afterParent}</pre>`;\n</script>',
        outputHtml: '<pre>before child.score=10\nafter child.score=25\nparent.score stays=10</pre>',
      },
    ],
  },
  'js-event-loop': {
    heading: 'Event Loop Microtasks and Macrotasks',
    easySummary: 'The event loop schedules async work by coordinating call stack, microtask queue, and task queue.',
    theory: [
      'JavaScript execution is single-threaded in one context, but async behavior is enabled by host APIs and queues. The event loop checks call stack emptiness and then processes queued callbacks.',
      'Promise callbacks run in microtask queue, while setTimeout callbacks run in macrotask queue. Microtasks are processed before the next macrotask, which explains many ordering surprises.',
      'Understanding this model is required for reliable async reasoning, performance tuning, and debugging race conditions.'
    ],
    practicalTips: [
      'Use Promise.resolve().then() to test microtask behavior.',
      'Do not assume setTimeout(..., 0) runs immediately.',
      'Break heavy tasks to keep UI responsive.',
      'When output seems confusing, log sequence numbers to verify actual queue order.',
    ],
    examples: [
      {
        title: 'Microtask vs timer order',
        description: 'Shows event loop scheduling order.',
        code: '<script>\n  const out = [];\n  out.push("sync-1");\n  setTimeout(() => out.push("timer"), 0);\n  Promise.resolve().then(() => out.push("microtask"));\n  out.push("sync-2");\n  setTimeout(() => { document.body.innerHTML = `<p>${out.join(" -> ")}</p>`; }, 10);\n</script>',
        outputHtml: '<p>sync-1 -> sync-2 -> microtask -> timer</p>',
      },
      {
        title: 'Promise then catch finally order',
        description: 'Demonstrates microtask ordering between then, catch, and finally.',
        code: '<script>\n  const out = [];\n  Promise.resolve("ok")\n    .then((v) => { out.push(`then:${v}`); throw new Error("x"); })\n    .catch(() => out.push("catch"))\n    .finally(() => out.push("finally"))\n    .then(() => { document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`; });\n</script>',
        outputHtml: '<pre>then:ok -> catch -> finally</pre>',
      },
      {
        title: 'queueMicrotask vs setTimeout and setInterval',
        description: 'Compares explicit microtask and timer-based macrotasks.',
        code: '<script>\n  const out = [];\n  let tick = 0;\n  const intervalId = setInterval(() => {\n    tick += 1;\n    out.push(`interval-${tick}`);\n    if (tick === 1) {\n      clearInterval(intervalId);\n      document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`;\n    }\n  }, 0);\n  out.push("sync");\n  queueMicrotask(() => out.push("microtask"));\n  setTimeout(() => out.push("timeout"), 0);\n</script>',
        outputHtml: '<pre>sync -> microtask -> timeout -> interval-1</pre>',
      },
      {
        title: 'requestAnimationFrame timing',
        description: 'Shows animation frame callback order relative to synchronous code.',
        code: '<script>\n  const out = ["sync-start"];\n  requestAnimationFrame(() => {\n    out.push("raf");\n    document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`;\n  });\n  out.push("sync-end");\n</script>',
        outputHtml: '<pre>sync-start -> sync-end -> raf</pre>',
      },
      {
        title: 'MutationObserver callback order',
        description: 'Shows observer callback sequencing after DOM mutation in microtask timing.',
        code: '<div id="mo">A</div>\n<pre id="mo-log"></pre>\n<script>\n  const node = document.getElementById("mo");\n  const out = [];\n  const observer = new MutationObserver(() => out.push("mutation-observer"));\n  observer.observe(node, { childList: true });\n  out.push("sync-before");\n  node.textContent = "B";\n  Promise.resolve().then(() => out.push("promise-microtask"));\n  setTimeout(() => {\n    out.push("timeout");\n    document.getElementById("mo-log").textContent = out.join(" -> ");\n    observer.disconnect();\n  }, 0);\n</script>',
        outputHtml: '<pre>sync-before -> mutation-observer -> promise-microtask -> timeout</pre>',
      },
      {
        title: 'Tricky output question nested queues',
        description: 'Question: predict log order before run. Explanation: microtasks flush before next macrotask and nested microtasks flush in same turn.',
        code: '<script>\n  const out = [];\n  out.push("A");\n  setTimeout(() => {\n    out.push("B");\n    Promise.resolve().then(() => out.push("C"));\n  }, 0);\n  Promise.resolve().then(() => {\n    out.push("D");\n    queueMicrotask(() => out.push("E"));\n  });\n  out.push("F");\n  setTimeout(() => {\n    document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`;\n  }, 20);\n</script>',
        outputHtml: '<pre>A -> F -> D -> E -> B -> C</pre>',
      },
    ],
  },
  'js-promises': {
    heading: 'Promises Deep Dive',
    easySummary: 'Promises model future completion or failure of asynchronous operations.',
    theory: [
      'A Promise has states: pending, fulfilled, and rejected. You never manually read state from normal Promise APIs, but you observe outcomes through then, catch, and finally handlers.',
      'Instance methods are then(onFulfilled, onRejected), catch(onRejected), and finally(onFinally). then transforms success values and can also recover errors using the second parameter. catch is syntax sugar for then(undefined, onRejected). finally runs cleanup and usually passes through original value or error.',
      'Static Promise methods are resolve(value), reject(reason), all(iterable), allSettled(iterable), race(iterable), and any(iterable). resolve wraps non-promise values. reject creates an immediately rejected promise. all fails fast if any input rejects. allSettled always returns per-task status results. race returns first settled result (resolve or reject). any returns first fulfilled result and rejects only when all fail using AggregateError.',
      'Behind the scenes, promise reactions run in microtask queue, not macrotask queue. This is why promise callbacks run before setTimeout callbacks in common event-loop ordering examples.'
    ],
    practicalTips: [
      'Always return from then in promise chains.',
      'Use all when all tasks are mandatory, any when one success is enough, race for first-settled behavior, and allSettled for partial success reporting.',
      'Use allSettled when partial failures are acceptable.',
      'Handle rejected promises to avoid unhandled rejection issues.',
    ],
    referenceSections: [
      {
        title: 'Promise instance methods',
        intro: 'These methods are called on a promise object returned by async operations.',
        columns: [
          { key: 'method', label: 'Method' },
          { key: 'whatItDoes', label: 'What it does' },
          { key: 'whenToUse', label: 'When to use' },
        ],
        rows: [
          { method: 'then(onFulfilled, onRejected)', whatItDoes: 'Handles success and optionally failure, returns a new promise', whenToUse: 'Transform values and continue chain' },
          { method: 'catch(onRejected)', whatItDoes: 'Handles rejection from current or previous chain step', whenToUse: 'Centralized error handling in chain' },
          { method: 'finally(onFinally)', whatItDoes: 'Runs cleanup regardless of success/failure, passes through original outcome', whenToUse: 'Stop loaders, release resources, UI cleanup' },
        ],
      },
      {
        title: 'Promise static methods and combinators',
        intro: 'These methods are called on Promise itself for creation and orchestration.',
        columns: [
          { key: 'method', label: 'Method' },
          { key: 'returns', label: 'Return behavior' },
          { key: 'notes', label: 'Important notes' },
        ],
        rows: [
          { method: 'Promise.resolve(value)', returns: 'Fulfilled promise', notes: 'If value is already a promise-like, it is adopted' },
          { method: 'Promise.reject(reason)', returns: 'Rejected promise', notes: 'Useful for early failures in async flows' },
          { method: 'Promise.all(iterable)', returns: 'Fulfilled array or first rejection', notes: 'Fail-fast; preserves input order in output' },
          { method: 'Promise.allSettled(iterable)', returns: 'Array of {status, value|reason}', notes: 'Never rejects due to item failure' },
          { method: 'Promise.race(iterable)', returns: 'First settled promise', notes: 'Can resolve or reject; often used with timeout pattern' },
          { method: 'Promise.any(iterable)', returns: 'First fulfilled promise or AggregateError', notes: 'Ignores rejections until all reject' },
        ],
      },
      {
        title: 'all vs allSettled vs race vs any',
        intro: 'Use the right combinator based on business requirement.',
        columns: [
          { key: 'combinator', label: 'Combinator' },
          { key: 'successCondition', label: 'Success condition' },
          { key: 'failureCondition', label: 'Failure condition' },
        ],
        rows: [
          { combinator: 'all', successCondition: 'All inputs fulfilled', failureCondition: 'Any one input rejects' },
          { combinator: 'allSettled', successCondition: 'Always returns result statuses', failureCondition: 'Does not fail due to item errors' },
          { combinator: 'race', successCondition: 'First settled is fulfilled', failureCondition: 'First settled is rejected' },
          { combinator: 'any', successCondition: 'At least one input fulfills', failureCondition: 'All inputs reject (AggregateError)' },
        ],
      },
    ],
    examples: [
      {
        title: 'Promise chain with recovery',
        description: 'Shows success flow and fallback handling.',
        code: '<script>\n  Promise.resolve(5)\n    .then((n) => n * 2)\n    .then((n) => { if (n > 5) throw new Error("too high"); return n; })\n    .catch(() => 8)\n    .then((finalValue) => { document.body.innerHTML = `<p>${finalValue}</p>`; });\n</script>',
        outputHtml: '<p>8</p>',
      },
      {
        title: 'Promise.all for required parallel tasks',
        description: 'All endpoints must succeed, or the whole flow fails.',
        code: '<script>\n  const p1 = Promise.resolve("profile");\n  const p2 = Promise.resolve("settings");\n  Promise.all([p1, p2])\n    .then(([a, b]) => { document.body.innerHTML = `<p>${a} + ${b}</p>`; })\n    .catch(() => { document.body.innerHTML = "<p>One required call failed</p>"; });\n</script>',
        outputHtml: '<p>profile + settings</p>',
      },
      {
        title: 'Promise.allSettled for partial results',
        description: 'Collect both successes and failures without aborting the entire process.',
        code: '<script>\n  const jobs = [Promise.resolve("ok"), Promise.reject("fail")];\n  Promise.allSettled(jobs).then((r) => {\n    const text = r.map((x) => x.status).join(", ");\n    document.body.innerHTML = `<p>${text}</p>`;\n  });\n</script>',
        outputHtml: '<p>fulfilled, rejected</p>',
      },
      {
        title: 'Promise.race for timeout control',
        description: 'Race request against timeout rejection.',
        code: '<script>\n  const api = new Promise((res) => setTimeout(() => res("API OK"), 40));\n  const timeout = new Promise((_, rej) => setTimeout(() => rej(new Error("timeout")), 20));\n  Promise.race([api, timeout])\n    .then((v) => { document.body.innerHTML = `<p>${v}</p>`; })\n    .catch((e) => { document.body.innerHTML = `<p>${e.message}</p>`; });\n</script>',
        outputHtml: '<p>timeout</p>',
      },
      {
        title: 'Promise.any for first successful source',
        description: 'Useful for fallback mirrors/CDN endpoints.',
        code: '<script>\n  const bad = Promise.reject("cdn-1 down");\n  const good = new Promise((res) => setTimeout(() => res("cdn-2 ok"), 10));\n  Promise.any([bad, good]).then((v) => { document.body.innerHTML = `<p>${v}</p>`; });\n</script>',
        outputHtml: '<p>cdn-2 ok</p>',
      },
      {
        title: 'Promise.resolve and Promise.reject basics',
        description: 'Shows immediate fulfilled and rejected promise handling.',
        code: '<script>\n  const out = [];\n  Promise.resolve(42).then((v) => out.push(`resolve:${v}`));\n  Promise.reject("bad-input").catch((e) => out.push(`reject:${e}`));\n  Promise.resolve().then(() => { document.body.innerHTML = `<pre>${out.join(" | ")}</pre>`; });\n</script>',
        outputHtml: '<pre>resolve:42 | reject:bad-input</pre>',
      },
      {
        title: 'then second argument vs catch',
        description: 'Explains two ways to handle rejection in a chain.',
        code: '<script>\n  const out = [];\n  Promise.reject("X")\n    .then(\n      () => out.push("then-success"),\n      (err) => { out.push(`then-reject:${err}`); return "recovered"; }\n    )\n    .then((v) => out.push(`after:${v}`));\n  Promise.resolve().then(() => { document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`; });\n</script>',
        outputHtml: '<pre>then-reject:X -> after:recovered</pre>',
      },
      {
        title: 'finally pass-through behavior',
        description: 'finally runs cleanup but does not replace value unless it throws.',
        code: '<script>\n  Promise.resolve("data")\n    .finally(() => {})\n    .then((v) => { document.body.innerHTML = `<pre>value after finally=${v}</pre>`; });\n</script>',
        outputHtml: '<pre>value after finally=data</pre>',
      },
      {
        title: 'Tricky output question promise chaining',
        description: 'Question: predict final output before run. Explanation: returned promise from then delays next then, and throw jumps to catch.',
        code: '<script>\n  const out = [];\n  Promise.resolve(1)\n    .then((n) => { out.push(`a:${n}`); return Promise.resolve(n + 1); })\n    .then((n) => { out.push(`b:${n}`); throw new Error("oops"); })\n    .catch(() => out.push("c:catch"))\n    .then(() => out.push("d:end"));\n  Promise.resolve().then(() => Promise.resolve()).then(() => {\n    document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`;\n  });\n</script>',
        outputHtml: '<pre>a:1 -> b:2 -> c:catch -> d:end</pre>',
      },
    ],
  },
  'js-async': {
    heading: 'Asynchronous JavaScript with async/await',
    easySummary: 'async/await makes Promise-based asynchronous code read more like synchronous logic.',
    theory: [
      'An async function always returns a Promise. await pauses function execution until a promise settles, but does not block the entire JavaScript thread; it yields control to the event loop.',
      'async/await is mostly syntax over promises, so error handling still relies on try/catch and understanding promise behavior. Misplaced await in loops can create accidental sequential delays.',
      'For performance, run independent async tasks concurrently with Promise.all instead of awaiting each task one by one.'
    ],
    practicalTips: [
      'Wrap awaited operations in try/catch for reliable error flow.',
      'Use Promise.all for independent network calls.',
      'Avoid await inside Array.forEach; use for...of or Promise.all + map.',
    ],
    referenceSections: [
      {
        title: 'async/await method-level rules',
        intro: 'These are high-frequency interview and production rules.',
        columns: [
          { key: 'rule', label: 'Rule' },
          { key: 'meaning', label: 'Meaning' },
          { key: 'impact', label: 'Impact' },
        ],
        rows: [
          { rule: 'async function', meaning: 'Always returns a Promise', impact: 'Callers must await or use then/catch' },
          { rule: 'await expr', meaning: 'Pauses only current async function', impact: 'Does not block whole JS thread' },
          { rule: 'try/catch with await', meaning: 'Catches awaited rejection as exception', impact: 'Cleaner centralized error handling' },
          { rule: 'Promise.all + await', meaning: 'Concurrent wait for independent tasks', impact: 'Significant latency reduction' },
        ],
      },
    ],
    examples: [
      {
        title: 'Concurrent await pattern',
        description: 'Runs async tasks together and combines results.',
        code: '<script>\n  const wait = (value, ms) => new Promise((r) => setTimeout(() => r(value), ms));\n  async function run(){\n    const [a, b] = await Promise.all([wait("A", 20), wait("B", 10)]);\n    document.body.innerHTML = `<p>${a}-${b}</p>`;\n  }\n  run();\n</script>',
        outputHtml: '<p>A-B</p>',
      },
      {
        title: 'async function always returns Promise',
        description: 'Shows returned value wrapped in resolved promise.',
        code: '<script>\n  async function score(){ return 99; }\n  const isPromise = score() instanceof Promise;\n  score().then((v) => {\n    document.body.innerHTML = `<pre>returnsPromise=${isPromise}\\nvalue=${v}</pre>`;\n  });\n</script>',
        outputHtml: '<pre>returnsPromise=true\nvalue=99</pre>',
      },
      {
        title: 'try catch with awaited rejection',
        description: 'Catches async error from rejected promise inside async function.',
        code: '<script>\n  const waitReject = () => Promise.reject(new Error("network down"));\n  async function load(){\n    try {\n      await waitReject();\n      return "ok";\n    } catch (e) {\n      return `handled:${e.message}`;\n    }\n  }\n  load().then((msg) => { document.body.innerHTML = `<pre>${msg}</pre>`; });\n</script>',
        outputHtml: '<pre>handled:network down</pre>',
      },
      {
        title: 'Promise.allSettled with await',
        description: 'Collects mixed success/failure without throwing.',
        code: '<script>\n  async function run(){\n    const jobs = [Promise.resolve("A"), Promise.reject("B"), Promise.resolve("C")];\n    const settled = await Promise.allSettled(jobs);\n    const line = settled.map((x) => x.status).join(" | ");\n    document.body.innerHTML = `<pre>${line}</pre>`;\n  }\n  run();\n</script>',
        outputHtml: '<pre>fulfilled | rejected | fulfilled</pre>',
      },
      {
        title: 'for of await sequential behavior',
        description: 'Processes async tasks one by one in strict sequence.',
        code: '<script>\n  const wait = (v, ms) => new Promise((r) => setTimeout(() => r(v), ms));\n  async function run(){\n    const out = [];\n    for (const item of ["X", "Y", "Z"]) {\n      out.push(await wait(item, 10));\n    }\n    document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`;\n  }\n  run();\n</script>',
        outputHtml: '<pre>X -> Y -> Z</pre>',
      },
      {
        title: 'await Promise.race and Promise.any',
        description: 'Shows first settled vs first fulfilled behavior with await.',
        code: '<script>\n  const fastReject = new Promise((_, rej) => setTimeout(() => rej(new Error("fast fail")), 8));\n  const slowResolve = new Promise((res) => setTimeout(() => res("slow ok"), 20));\n  const fastResolve = new Promise((res) => setTimeout(() => res("fast ok"), 10));\n\n  async function run(){\n    const out = [];\n    try {\n      await Promise.race([fastReject, slowResolve]);\n    } catch (e) {\n      out.push(`race:${e.message}`);\n    }\n    const anyValue = await Promise.any([fastReject.catch(() => { throw new Error("r1"); }), fastResolve]);\n    out.push(`any:${anyValue}`);\n    document.body.innerHTML = `<pre>${out.join(" | ")}</pre>`;\n  }\n  run();\n</script>',
        outputHtml: '<pre>race:fast fail | any:fast ok</pre>',
      },
      {
        title: 'Tricky output question await scheduling',
        description: 'Question: why does line after await run later? Explanation: await yields control and continuation runs in microtask after current sync frame.',
        code: '<script>\n  const out = [];\n  async function demo(){\n    out.push("inside-1");\n    await Promise.resolve();\n    out.push("inside-2");\n  }\n  out.push("start");\n  demo();\n  out.push("end");\n  Promise.resolve().then(() => {\n    document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`;\n  });\n</script>',
        outputHtml: '<pre>start -> inside-1 -> end -> inside-2</pre>',
      },
    ],
  },
  'js-fetch-api': {
    heading: 'Fetch API and Network Calls',
    easySummary: 'Fetch sends HTTP requests and returns promises for response handling.',
    theory: [
      'fetch is the native browser API for HTTP communication. It returns a Promise that resolves on network completion, even for many non-2xx status codes, so you should manually validate response.ok.',
      'A robust fetch flow includes request config, loading state, timeout or abort handling, response parsing, and graceful error UI. This pattern appears in almost every frontend product.',
      'Network debugging requires understanding request methods, headers, payloads, CORS behavior, and caching headers visible in browser DevTools network panel.'
    ],
    practicalTips: [
      'Check response.ok before parsing body.',
      'Use AbortController for cancellation on route changes.',
      'Log status and endpoint details for easier debugging.',
    ],
    referenceSections: [
      {
        title: 'fetch request options and response properties',
        intro: 'These are the most-used fetch methods/properties in real applications.',
        columns: [
          { key: 'item', label: 'Item' },
          { key: 'type', label: 'Type' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { item: 'fetch(url, options)', type: 'Method', purpose: 'Sends HTTP request and returns Promise<Response>' },
          { item: 'options.method', type: 'Property', purpose: 'HTTP method like GET POST PUT DELETE PATCH' },
          { item: 'options.headers', type: 'Property', purpose: 'Custom headers such as Content-Type and Authorization' },
          { item: 'options.body', type: 'Property', purpose: 'Request payload for non-GET requests' },
          { item: 'options.signal', type: 'Property', purpose: 'AbortController signal for cancellation' },
          { item: 'response.ok', type: 'Property', purpose: 'True for 2xx responses' },
          { item: 'response.status', type: 'Property', purpose: 'Numeric HTTP status code' },
          { item: 'response.statusText', type: 'Property', purpose: 'Status message text' },
          { item: 'response.headers', type: 'Property', purpose: 'Response headers interface' },
          { item: 'response.url', type: 'Property', purpose: 'Final URL after redirects' },
          { item: 'response.type', type: 'Property', purpose: 'Response type: basic, cors, opaque' },
          { item: 'response.json()', type: 'Method', purpose: 'Parse body as JSON' },
          { item: 'response.text()', type: 'Method', purpose: 'Parse body as text' },
          { item: 'response.blob()', type: 'Method', purpose: 'Parse body as Blob for files/media' },
          { item: 'response.arrayBuffer()', type: 'Method', purpose: 'Parse binary payloads' },
          { item: 'response.formData()', type: 'Method', purpose: 'Parse multipart form payloads' },
          { item: 'response.clone()', type: 'Method', purpose: 'Clone response stream for multiple reads' },
        ],
      },
      {
        title: 'AbortController API essentials',
        intro: 'Cancellation avoids stale updates and improves UX.',
        columns: [
          { key: 'item', label: 'Item' },
          { key: 'kind', label: 'Kind' },
          { key: 'usage', label: 'Usage' },
        ],
        rows: [
          { item: 'new AbortController()', kind: 'Constructor', usage: 'Create cancellation controller' },
          { item: 'controller.signal', kind: 'Property', usage: 'Pass signal to fetch options' },
          { item: 'controller.abort(reason?)', kind: 'Method', usage: 'Cancel active request and reject promise' },
          { item: 'signal.aborted', kind: 'Property', usage: 'Check if signal already aborted' },
          { item: 'signal.reason', kind: 'Property', usage: 'Read abort reason if provided' },
          { item: 'signal.addEventListener("abort")', kind: 'Method', usage: 'Attach custom cancellation handling' },
        ],
      },
    ],
    examples: [
      {
        title: 'Fetch with status guard',
        description: 'Pattern for safe parsing and fallback.',
        code: '<script>\n  async function load(){\n    try {\n      const res = await fetch("https://jsonplaceholder.typicode.com/todos/1");\n      if (!res.ok) throw new Error(`HTTP ${res.status}`);\n      const data = await res.json();\n      document.body.innerHTML = `<p>${data.title}</p>`;\n    } catch (e) {\n      document.body.innerHTML = `<p>Failed to load data</p>`;\n    }\n  }\n  load();\n</script>',
        outputHtml: '<p>Loaded sample todo title from API</p>',
      },
      {
        title: 'Request options object methods and properties',
        description: 'Builds method, headers, body, and signal options in one request config.',
        code: '<script>\n  const controller = new AbortController();\n  const options = {\n    method: "POST",\n    headers: { "Content-Type": "application/json", "X-App": "learn" },\n    body: JSON.stringify({ topic: "fetch" }),\n    signal: controller.signal,\n  };\n  document.body.innerHTML = `<pre>method=${options.method}\\ncontentType=${options.headers["Content-Type"]}\\nbody=${options.body}\\nsignalAborted=${options.signal.aborted}</pre>`;\n</script>',
        outputHtml: '<pre>method=POST\ncontentType=application/json\nbody={"topic":"fetch"}\nsignalAborted=false</pre>',
      },
      {
        title: 'Response core properties and headers',
        description: 'Demonstrates ok, status, statusText, headers, url, and type from a Response object.',
        code: '<script>\n  const res = new Response("ok-body", {\n    status: 201,\n    statusText: "Created",\n    headers: { "X-Trace": "abc123", "Content-Type": "text/plain" }\n  });\n  const lines = [\n    `ok=${res.ok}`,\n    `status=${res.status}`,\n    `statusText=${res.statusText}`,\n    `header-x-trace=${res.headers.get("X-Trace")}`,\n    `url=${res.url || "(empty in manual Response)"}`,\n    `type=${res.type}`\n  ];\n  document.body.innerHTML = `<pre>${lines.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>ok=true\nstatus=201\nstatusText=Created\nheader-x-trace=abc123\nurl=(empty in manual Response)\ntype=default</pre>',
      },
      {
        title: 'response.text json blob arrayBuffer clone',
        description: 'Parses different body formats and uses clone for multiple reads.',
        code: '<script>\n  async function run(){\n    const jsonRes = new Response(JSON.stringify({ name: "Asha" }), { headers: { "Content-Type": "application/json" } });\n    const jsonClone = jsonRes.clone();\n    const asJson = await jsonRes.json();\n    const asText = await jsonClone.text();\n\n    const txtRes = new Response("HELLO");\n    const blob = await txtRes.blob();\n    const abRes = new Response("AB");\n    const arr = await abRes.arrayBuffer();\n\n    document.body.innerHTML = `<pre>json.name=${asJson.name}\\ntext=${asText}\\nblob.size=${blob.size}\\narrayBuffer.bytes=${arr.byteLength}</pre>`;\n  }\n  run();\n</script>',
        outputHtml: '<pre>json.name=Asha\ntext={"name":"Asha"}\nblob.size=5\narrayBuffer.bytes=2</pre>',
      },
      {
        title: 'response.formData parsing',
        description: 'Parses urlencoded body as FormData and reads fields.',
        code: '<script>\n  async function run(){\n    const res = new Response("name=Asha&track=JS", { headers: { "Content-Type": "application/x-www-form-urlencoded" } });\n    const fd = await res.formData();\n    document.body.innerHTML = `<pre>name=${fd.get("name")}\\ntrack=${fd.get("track")}</pre>`;\n  }\n  run();\n</script>',
        outputHtml: '<pre>name=Asha\ntrack=JS</pre>',
      },
      {
        title: 'AbortController abort reason and abort event',
        description: 'Triggers abort, listens to abort event, and shows signal.aborted with reason.',
        code: '<script>\n  const controller = new AbortController();\n  const signal = controller.signal;\n  const out = [];\n  signal.addEventListener("abort", () => out.push("abort-event-fired"));\n  controller.abort("route-change");\n  out.push(`aborted=${signal.aborted}`);\n  out.push(`reason=${signal.reason}`);\n  document.body.innerHTML = `<pre>${out.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>abort-event-fired\naborted=true\nreason=route-change</pre>',
      },
      {
        title: 'Tricky output question fetch clone usage',
        description: 'Question: why second read fails without clone? Explanation: response body stream is consumed once unless cloned first.',
        code: '<script>\n  async function run(){\n    const res = new Response("one-time-stream");\n    const first = await res.text();\n    let second;\n    try {\n      second = await res.text();\n    } catch (e) {\n      second = "second read failed";\n    }\n    document.body.innerHTML = `<pre>first=${first}\\nsecond=${second}</pre>`;\n  }\n  run();\n</script>',
        outputHtml: '<pre>first=one-time-stream\nsecond=second read failed</pre>',
      },
    ],
  },
  'js-modules-tooling': {
    heading: 'Modules Bundling and Tooling',
    easySummary: 'Modules organize code, while bundlers and tooling optimize delivery and developer workflow.',
    theory: [
      'ES modules use import/export for explicit dependencies. Module boundaries improve maintainability, testability, and readability in medium and large codebases.',
      'Bundlers like Vite, Webpack, or Rollup process modules, optimize assets, split chunks, and support fast development reloads. Tooling also handles transpilation, linting, formatting, and testing integration.',
      'Production-quality JavaScript requires not only language knowledge but also build pipeline understanding, because performance and deploy reliability depend heavily on tooling decisions.'
    ],
    practicalTips: [
      'Keep modules focused and avoid circular imports.',
      'Use aliases and consistent folder conventions.',
      'Analyze bundle size regularly for regressions.',
    ],
    examples: [
      {
        title: 'Module structure idea',
        description: 'Simple export/import pattern to organize logic.',
        code: '<pre>// math.js\nexport const add = (a,b) => a + b;\n\n// app.js\nimport { add } from "./math.js";\nconsole.log(add(2,3));</pre>',
        outputHtml: '<pre>// math.js export const add = (a,b) =&gt; a + b; // app.js import { add } from "./math.js";</pre>',
      },
      {
        title: 'export and export default usage',
        description: 'Shows named export and default export together in module files.',
        code: '<pre>// user.js\nexport const role = "student";\nexport function greet(name){ return `Hi ${name}`; }\nexport default function id(){ return "U-101"; }\n\n// app.js\nimport getId, { role, greet } from "./user.js";\nconsole.log(role, greet("Asha"), getId());</pre>',
        outputHtml: '<pre>Named export: role, greet | Default export: getId</pre>',
      },
      {
        title: 'Dynamic import() pattern',
        description: 'Demonstrates lazy loading syntax and promise-based module access.',
        code: '<pre>// app.js\nasync function loadFeature(){\n  const mod = await import("./feature.js");\n  console.log(mod.run());\n}\nloadFeature();</pre>',
        outputHtml: '<pre>import() returns Promise and loads module on demand.</pre>',
      },
      {
        title: 'Bundling scripts and source maps sample config',
        description: 'Shows package scripts and source-map debug setup.',
        code: '<pre>{\n  "scripts": {\n    "dev": "vite",\n    "build": "vite build",\n    "build:analyze": "vite build --sourcemap"\n  }\n}\n\n// sourcemap helps map minified code back to source in DevTools</pre>',
        outputHtml: '<pre>Use build --sourcemap to debug production stack traces.</pre>',
      },
      {
        title: 'Tree shaking concept example',
        description: 'Illustrates unused export removal by bundlers.',
        code: '<pre>// math.js\nexport const used = () =&gt; 1;\nexport const unused = () =&gt; 999;\n\n// app.js\nimport { used } from "./math.js";\nconsole.log(used());\n\n// production bundler can drop unused export</pre>',
        outputHtml: '<pre>Only imported used() stays in production bundle in most bundlers.</pre>',
      },
      {
        title: 'Tricky output question module live bindings',
        description: 'Question: why imported value updates across files? Explanation: ES module imports are live bindings, not copied snapshots.',
        code: '<pre>// counter.js\nexport let count = 0;\nexport const inc = () =&gt; { count += 1; };\n\n// app.js\nimport { count, inc } from "./counter.js";\nconsole.log(count); // 0\ninc();\nconsole.log(count); // 1</pre>',
        outputHtml: '<pre>Imported bindings update when exporting module mutates them.</pre>',
      },
    ],
  },
  'js-browser-storage': {
    heading: 'Browser Storage and Caching',
    easySummary: 'Browser storage APIs keep data on client side with different lifetime, size, and security trade-offs.',
    theory: [
      'localStorage stores key-value strings with long persistence, sessionStorage lives per tab session, and cookies are sent with requests depending on scope settings. IndexedDB supports larger structured data.',
      'Storage decisions affect privacy, security, and UX. Sensitive tokens should be handled carefully. Storage can be cleared by users, blocked in private modes, or constrained by quota.',
      'Caching also involves HTTP cache headers, service workers, and runtime cache strategy. Strong frontend engineers understand both data persistence and network caching layers.'
    ],
    practicalTips: [
      'Store only necessary data and avoid secrets in plain storage.',
      'Serialize and validate stored values defensively.',
      'Version client cache keys to manage schema changes.',
    ],
    examples: [
      {
        title: 'Local storage save/read',
        description: 'Persist simple preferences across reloads.',
        code: '<script>\n  localStorage.setItem("theme", "light");\n  const theme = localStorage.getItem("theme") || "dark";\n  document.body.innerHTML = `<p>Theme: ${theme}</p>`;\n</script>',
        outputHtml: '<p>Theme: light</p>',
      },
      {
        title: 'Storage CRUD and length/key iteration',
        description: 'Uses setItem/getItem/removeItem/clear with key(index) and length.',
        code: '<script>\n  const out = [];\n  try {\n    // Real browser storage path\n    localStorage.clear();\n    localStorage.setItem("course", "js");\n    localStorage.setItem("level", "advanced");\n    out.push(`length=${localStorage.length}`);\n    out.push(`key0=${localStorage.key(0)}`);\n    out.push(`course=${localStorage.getItem("course")}`);\n    localStorage.removeItem("level");\n    out.push(`lengthAfterRemove=${localStorage.length}`);\n    localStorage.clear();\n    out.push(`lengthAfterClear=${localStorage.length}`);\n  } catch (e) {\n    // Fallback path so learners still see expected CRUD flow in restricted contexts\n    const mem = new Map();\n    mem.set("course", "js");\n    mem.set("level", "advanced");\n    out.push("mode=memory-fallback");\n    out.push(`length=${mem.size}`);\n    out.push(`key0=${Array.from(mem.keys())[0]}`);\n    out.push(`course=${mem.get("course")}`);\n    mem.delete("level");\n    out.push(`lengthAfterRemove=${mem.size}`);\n    mem.clear();\n    out.push(`lengthAfterClear=${mem.size}`);\n  }\n  document.body.innerHTML = `<pre>${out.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>length=2\nkey0=course\ncourse=js\nlengthAfterRemove=1\nlengthAfterClear=0</pre>',
      },
      {
        title: 'sessionStorage quick lifecycle demo',
        description: 'Stores per-tab data and reads it in same session.',
        code: '<script>\n  const out = [];\n  try {\n    // sessionStorage survives in current tab until tab close\n    sessionStorage.setItem("tabFlow", "onboarding");\n    out.push(`tabFlow=${sessionStorage.getItem("tabFlow")}`);\n    out.push(`mode=sessionStorage`);\n  } catch (e) {\n    // Fallback for strict sandbox/privacy contexts\n    const fallbackSession = { tabFlow: "onboarding" };\n    out.push(`tabFlow=${fallbackSession.tabFlow}`);\n    out.push("mode=memory-fallback");\n  }\n  document.body.innerHTML = `<pre>${out.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>tabFlow=onboarding</pre>',
      },
      {
        title: 'document.cookie write/read demo',
        description: 'Writes cookie and reads cookie string.',
        code: '<script>\n  document.cookie = "learnTopic=storage; path=/; max-age=300";\n  document.body.innerHTML = `<pre>${document.cookie || "cookie string may be empty in sandbox"}</pre>`;\n</script>',
        outputHtml: '<pre>learnTopic=storage</pre>',
      },
      {
        title: 'indexedDB.open basic flow',
        description: 'Creates/open database and reports open success event.',
        code: '<pre id="idb-out">opening...</pre>\n<script>\n  if (!window.indexedDB) {\n    document.getElementById("idb-out").textContent = "indexedDB not available";\n  } else {\n    const req = indexedDB.open("learn-db", 1);\n    req.onupgradeneeded = () => {\n      req.result.createObjectStore("notes", { keyPath: "id" });\n    };\n    req.onsuccess = () => {\n      document.getElementById("idb-out").textContent = `indexedDB opened: ${req.result.name}`;\n      req.result.close();\n    };\n    req.onerror = () => {\n      document.getElementById("idb-out").textContent = "indexedDB open failed";\n    };\n  }\n</script>',
        outputHtml: '<pre>indexedDB opened: learn-db</pre>',
      },
      {
        title: 'Cache Storage open put match demo',
        description: 'Uses caches.open, put, and match for runtime cache operations.',
        code: '<pre id="cache-out">working...</pre>\n<script>\n  async function run(){\n    const out = document.getElementById("cache-out");\n    try {\n      if (!("caches" in window)) {\n        throw new Error("Cache API missing");\n      }\n      const cache = await caches.open("learn-cache");\n      await cache.put("/virtual-topic", new Response("cached-topic"));\n      const hit = await cache.match("/virtual-topic");\n      const text = hit ? await hit.text() : "miss";\n      out.textContent = `cache match=${text} | mode=cache-storage`;\n    } catch (e) {\n      // Fallback in case CacheStorage is blocked by environment/security policy\n      const fallbackCache = new Map();\n      fallbackCache.set("/virtual-topic", "cached-topic");\n      out.textContent = `cache match=${fallbackCache.get("/virtual-topic")} | mode=memory-fallback`;\n    }\n  }\n  run();\n</script>',
        outputHtml: '<pre>cache match=cached-topic</pre>',
      },
      {
        title: 'storage event listener pattern',
        description: 'Shows cross-tab sync listener setup for localStorage changes.',
        code: '<pre>window.addEventListener("storage", (event) => {\n  console.log(event.key, event.oldValue, event.newValue);\n});\n\n// Open same site in second tab and update localStorage to trigger this event.</pre>',
        outputHtml: '<pre>storage event fires in other tabs when localStorage changes.</pre>',
      },
      {
        title: 'Tricky output question reference vs stored string',
        description: 'Question: why object methods disappear after storage read? Explanation: Storage stores strings, so JSON.parse is required to restore structure.',
        code: '<script>\n  const user = { id: 1, name: "Asha" };\n  let out = [];\n  try {\n    localStorage.setItem("user", JSON.stringify(user));\n    const raw = localStorage.getItem("user");\n    const parsed = JSON.parse(raw);\n    out = [`rawType=${typeof raw}`, `parsedName=${parsed.name}`, "mode=localStorage"];\n  } catch (e) {\n    const raw = JSON.stringify(user);\n    const parsed = JSON.parse(raw);\n    out = [`rawType=${typeof raw}`, `parsedName=${parsed.name}`, "mode=memory-fallback"];\n  }\n  document.body.innerHTML = `<pre>${out.join("\\n")}</pre>`;\n</script>',
        outputHtml: '<pre>rawType=string\nparsedName=Asha</pre>',
      },
    ],
  },
  'js-web-workers': {
    heading: 'Web Workers and Background Threads',
    easySummary: 'Web Workers run heavy JavaScript work on a background thread so the main UI thread stays responsive.',
    theory: [
      'JavaScript on the page normally runs on the main thread, which also handles rendering and user interactions. If a heavy loop runs there, the UI freezes until that work completes.',
      'Web Workers move CPU-heavy work to a separate thread. The main thread communicates with workers using message passing via postMessage and onmessage, so users can still click, type, and scroll while background work runs.',
      'Workers do not directly access the DOM. This is intentional for thread safety. They are best for expensive calculations, parsing, and transformation tasks, while the main thread handles UI updates.',
    ],
    practicalTips: [
      'Use workers for CPU-heavy tasks that take noticeable time on click or input.',
      'Keep worker payloads small and structured to reduce serialization cost.',
      'Terminate long-lived workers when done to avoid unnecessary memory and CPU use.',
    ],
    referenceSections: [
      {
        title: 'Web Worker core methods and properties',
        intro: 'Most-used APIs for dedicated workers in interviews and projects.',
        columns: [
          { key: 'item', label: 'Method/property' },
          { key: 'where', label: 'Where used' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { item: 'new Worker(url)', where: 'Main thread', purpose: 'Create a dedicated worker thread' },
          { item: 'worker.postMessage(data)', where: 'Main thread', purpose: 'Send data to worker' },
          { item: 'worker.onmessage', where: 'Main thread', purpose: 'Receive worker messages' },
          { item: 'worker.onerror', where: 'Main thread', purpose: 'Handle worker runtime errors' },
          { item: 'worker.terminate()', where: 'Main thread', purpose: 'Stop worker immediately' },
          { item: 'self.onmessage', where: 'Worker thread', purpose: 'Receive messages from main thread' },
          { item: 'self.postMessage(data)', where: 'Worker thread', purpose: 'Send results back to main thread' },
          { item: 'self.close()', where: 'Worker thread', purpose: 'Close current worker thread from inside' },
          { item: 'importScripts(url1, ...)', where: 'Worker thread', purpose: 'Load additional scripts in classic workers' },
        ],
      },
      {
        title: 'When to use worker vs main thread',
        intro: 'Quick decision guide for responsive UI.',
        columns: [
          { key: 'taskType', label: 'Task type' },
          { key: 'bestPlace', label: 'Best place' },
          { key: 'why', label: 'Why' },
        ],
        rows: [
          { taskType: 'DOM reads/writes', bestPlace: 'Main thread', why: 'Workers cannot directly access DOM' },
          { taskType: 'Heavy loops/calculations', bestPlace: 'Web Worker', why: 'Prevents UI freeze and lag' },
          { taskType: 'Small quick logic', bestPlace: 'Main thread', why: 'Worker startup/serialization overhead may be unnecessary' },
          { taskType: 'Background parsing/transform', bestPlace: 'Web Worker', why: 'Keeps interaction smooth' },
        ],
      },
    ],
    examples: [
      {
        title: 'Without worker: heavy loop blocks UI',
        description: 'Click Run Heavy Loop and notice ticker pauses until loop finishes.',
        code: '<div style="font-family:Arial,sans-serif">\n  <button id="run-main" type="button">Run Heavy Loop on Main Thread</button>\n  <p>UI ticker (updates every 100ms): <strong id="tick-main">0</strong></p>\n  <p id="result-main">Result: waiting...</p>\n</div>\n<script>\n  let tick = 0;\n  setInterval(() => {\n    tick += 1;\n    document.getElementById("tick-main").textContent = String(tick);\n  }, 100);\n\n  document.getElementById("run-main").addEventListener("click", () => {\n    const start = performance.now();\n    let sum = 0;\n    for (let i = 0; i < 220000000; i += 1) {\n      sum += i % 10;\n    }\n    const ms = Math.round(performance.now() - start);\n    document.getElementById("result-main").textContent = `Done in ${ms}ms, sum=${sum}`;\n  });\n</script>',
        outputHtml: '<p>When loop runs on main thread, UI ticker pauses and resumes after completion.</p>',
      },
      {
        title: 'With worker: heavy loop runs in background thread',
        description: 'Ticker keeps updating while worker computes in background.',
        code: '<div style="font-family:Arial,sans-serif">\n  <button id="run-worker" type="button">Run Heavy Loop in Worker</button>\n  <button id="stop-worker" type="button">Terminate Worker</button>\n  <p>UI ticker (updates every 100ms): <strong id="tick-worker">0</strong></p>\n  <p id="result-worker">Result: waiting...</p>\n</div>\n<script>\n  let tick = 0;\n  setInterval(() => {\n    tick += 1;\n    document.getElementById("tick-worker").textContent = String(tick);\n  }, 100);\n\n  const workerSource = `\n    self.onmessage = (event) => {\n      if (event.data?.type !== "start") return;\n      const start = Date.now();\n      let sum = 0;\n      for (let i = 0; i < event.data.iterations; i += 1) {\n        sum += i % 10;\n      }\n      const ms = Date.now() - start;\n      self.postMessage({ type: "done", sum, ms });\n    };\n  `;\n\n  const workerUrl = URL.createObjectURL(new Blob([workerSource], { type: "text/javascript" }));\n  let worker = new Worker(workerUrl);\n\n  worker.onmessage = (event) => {\n    if (event.data?.type === "done") {\n      document.getElementById("result-worker").textContent = `Done in ${event.data.ms}ms, sum=${event.data.sum}`;\n    }\n  };\n\n  worker.onerror = (event) => {\n    document.getElementById("result-worker").textContent = `Worker error: ${event.message}`;\n  };\n\n  document.getElementById("run-worker").addEventListener("click", () => {\n    document.getElementById("result-worker").textContent = "Working in background...";\n    worker.postMessage({ type: "start", iterations: 220000000 });\n  });\n\n  document.getElementById("stop-worker").addEventListener("click", () => {\n    worker.terminate();\n    document.getElementById("result-worker").textContent = "Worker terminated.";\n    worker = new Worker(workerUrl);\n    worker.onmessage = (event) => {\n      if (event.data?.type === "done") {\n        document.getElementById("result-worker").textContent = `Done in ${event.data.ms}ms, sum=${event.data.sum}`;\n      }\n    };\n    worker.onerror = (event) => {\n      document.getElementById("result-worker").textContent = `Worker error: ${event.message}`;\n    };\n  });\n</script>',
        outputHtml: '<p>Worker keeps UI responsive because heavy loop runs off the main thread.</p>',
      },
      {
        title: 'Worker messaging API quick example',
        description: 'Simple postMessage/onmessage handshake between main thread and worker.',
        code: '<div style="font-family:Arial,sans-serif">\n  <button id="ping-worker" type="button">Ping Worker</button>\n  <pre id="ping-out">waiting...</pre>\n</div>\n<script>\n  const code = `\n    self.onmessage = (event) => {\n      self.postMessage({ received: event.data, reply: "pong" });\n      self.close();\n    };\n  `;\n  const url = URL.createObjectURL(new Blob([code], { type: "text/javascript" }));\n\n  document.getElementById("ping-worker").addEventListener("click", () => {\n    const w = new Worker(url);\n    w.onmessage = (event) => {\n      document.getElementById("ping-out").textContent = JSON.stringify(event.data, null, 2);\n    };\n    w.postMessage({ msg: "ping", ts: Date.now() });\n  });\n</script>',
        outputHtml: '<pre>{"received":{"msg":"ping"},"reply":"pong"}</pre>',
      },
    ],
  },
  'js-devtools-debugging': {
    heading: 'DevTools Debugging and Profiling',
    easySummary: 'Browser DevTools help inspect DOM, network, performance, memory, and runtime errors at a deep level.',
    theory: [
      'The Elements panel helps inspect DOM and computed CSS. The Console helps evaluate runtime values and trace logs. The Sources panel supports breakpoints, call stack inspection, and step-by-step execution.',
      'The Network panel reveals request timing, payload, status, caching, and CORS behavior. The Performance panel records rendering and scripting costs. The Memory panel helps detect leaks and detached DOM references.',
      'Advanced debugging means combining these panels: reproduce issue, isolate failing flow, verify network state, inspect stack frames, and profile performance before patching code.'
    ],
    practicalTips: [
      'Use conditional breakpoints for noisy loops and event handlers.',
      'Capture performance traces while reproducing jank.',
      'Use Preserve log and Disable cache in Network panel when debugging APIs.',
    ],
    referenceSections: [
      {
        title: 'Chrome and Edge DevTools complete debugging workflow',
        intro: 'Use the same sequence in Chrome DevTools or Edge DevTools.',
        columns: [
          { key: 'step', label: 'Step' },
          { key: 'action', label: 'Action in DevTools' },
          { key: 'whatToObserve', label: 'What to observe' },
        ],
        rows: [
          { step: '1', action: 'Open DevTools (F12) and dock side-by-side', whatToObserve: 'UI state and code context together' },
          { step: '2', action: 'Console: reproduce issue and inspect errors', whatToObserve: 'Stack traces, line numbers, failing objects' },
          { step: '3', action: 'Sources: set breakpoints before failing line', whatToObserve: 'Call stack, scope values, closure variables' },
          { step: '4', action: 'Use Step Over / Step Into / Step Out controls', whatToObserve: 'Execution path and wrong branch transitions' },
          { step: '5', action: 'Network: filter XHR/Fetch, enable Preserve log', whatToObserve: 'Status codes, payloads, headers, timing' },
          { step: '6', action: 'Elements + Styles: inspect computed CSS and DOM', whatToObserve: 'Unexpected class toggles and layout issues' },
          { step: '7', action: 'Performance panel: record during lag interaction', whatToObserve: 'Long tasks, scripting hotspots, dropped frames' },
          { step: '8', action: 'Memory panel: heap snapshot before/after action', whatToObserve: 'Detached nodes, retained listeners, growing objects' },
          { step: '9', action: 'Application panel: inspect storage/cookies/cache', whatToObserve: 'Stale client data and wrong cache values' },
          { step: '10', action: 'Patch code, rerun same reproduction path', whatToObserve: 'Error removed and metrics improved' },
        ],
      },
      {
        title: 'Memory leak debugging checklist',
        intro: 'Use these steps when memory increases after repeated user actions.',
        columns: [
          { key: 'step', label: 'Step' },
          { key: 'operation', label: 'Operation' },
          { key: 'signal', label: 'Leak signal' },
        ],
        rows: [
          { step: 'A', operation: 'Take baseline heap snapshot', signal: 'Reference size baseline recorded' },
          { step: 'B', operation: 'Repeat action 5 to 10 times', signal: 'Heap should return close to baseline after GC' },
          { step: 'C', operation: 'Take second heap snapshot and compare', signal: 'Growing retained size indicates leak path' },
          { step: 'D', operation: 'Inspect Detached HTML elements and listeners', signal: 'Detached nodes retained by closures/listeners' },
          { step: 'E', operation: 'Verify cleanup (removeEventListener, timer clear)', signal: 'Retained objects reduce in next snapshot' },
        ],
      },
      {
        title: 'Performance profiling checklist',
        intro: 'Use Performance panel to diagnose jank and CPU-heavy code.',
        columns: [
          { key: 'step', label: 'Step' },
          { key: 'operation', label: 'Operation' },
          { key: 'signal', label: 'What indicates issue' },
        ],
        rows: [
          { step: 'A', operation: 'Record profile around slow interaction', signal: 'Long task bars > 50ms' },
          { step: 'B', operation: 'Open flame chart on largest scripting block', signal: 'Expensive function dominates timeline' },
          { step: 'C', operation: 'Check Layout and Recalculate Style events', signal: 'Frequent layout thrashing patterns' },
          { step: 'D', operation: 'Inspect FPS track and dropped frames', signal: 'Visible stutter under 60fps' },
          { step: 'E', operation: 'Apply optimization and re-record', signal: 'Reduced scripting/layout duration' },
        ],
      },
    ],
    examples: [
      {
        title: 'Console timing helper',
        description: 'Measure operation cost quickly in DevTools.',
        code: '<script>\n  console.time("calc");\n  let sum = 0;\n  for (let i = 0; i < 50000; i++) sum += i;\n  console.timeEnd("calc");\n  document.body.innerHTML = `<p>Open DevTools Console to see timing.</p>`;\n</script>',
        outputHtml: '<p>Open DevTools Console to see timing.</p>',
      },
      {
        title: 'Breakpoint and call stack practice snippet',
        description: 'Place breakpoint inside calculateTotal and inspect call stack + scope.',
        code: '<script>\n  function tax(v){ return v * 0.1; }\n  function calculateTotal(items){\n    let total = 0;\n    for (const n of items) total += n + tax(n);\n    return total;\n  }\n  const out = calculateTotal([100, 200, 300]);\n  document.body.innerHTML = `<pre>total=${out}</pre>`;\n</script>',
        outputHtml: '<pre>total=660</pre>',
      },
      {
        title: 'Memory leak simulation and cleanup',
        description: 'Creates listeners repeatedly, then cleans to compare heap snapshots.',
        code: '<button id="mk" type="button">Create listeners</button> <button id="cl" type="button">Cleanup</button>\n<pre id="dbg-log"></pre>\n<script>\n  const holders = [];\n  const mk = document.getElementById("mk");\n  const cl = document.getElementById("cl");\n  const log = document.getElementById("dbg-log");\n\n  mk.addEventListener("click", () => {\n    for (let i = 0; i < 100; i++) {\n      const div = document.createElement("div");\n      const handler = () => i;\n      div.addEventListener("click", handler);\n      holders.push({ div, handler });\n    }\n    log.textContent = `holders=${holders.length} (take heap snapshot now)`;\n  });\n\n  cl.addEventListener("click", () => {\n    for (const h of holders) h.div.removeEventListener("click", h.handler);\n    holders.length = 0;\n    log.textContent = "cleanup done (take next heap snapshot and compare)";\n  });\n</script>',
        outputHtml: '<pre>Use buttons then compare memory snapshots before and after cleanup.</pre>',
      },
      {
        title: 'Tricky output question microtask in debugger',
        description: 'Question: why promise callback logs before timeout in Console? Explanation: microtask queue drains before macrotask queue.',
        code: '<script>\n  const out = [];\n  out.push("sync");\n  setTimeout(() => out.push("timeout"), 0);\n  Promise.resolve().then(() => out.push("promise"));\n  setTimeout(() => { document.body.innerHTML = `<pre>${out.join(" -> ")}</pre>`; }, 20);\n</script>',
        outputHtml: '<pre>sync -> promise -> timeout</pre>',
      },
    ],
  },
  'js-performance-memory': {
    heading: 'Performance and Memory Optimization',
    easySummary: 'High-performance JavaScript minimizes main-thread work, avoids leaks, and reduces unnecessary re-rendering.',
    theory: [
      'Frontend performance depends on script execution cost, rendering cost, layout thrashing, asset loading, and event handler design. Efficient code focuses on critical path and user-perceived responsiveness.',
      'Memory leaks often come from unremoved listeners, stale closures, retained DOM references, and long-lived caches. Memory pressure causes slowdowns and crashes on low-end devices.',
      'Optimization is measurement-driven. Use profiling data first, then optimize hotspots. Premature optimization without metrics can waste effort and complicate code.'
    ],
    practicalTips: [
      'Debounce and throttle expensive handlers like scroll and resize.',
      'Batch DOM reads/writes to reduce layout thrashing.',
      'Remove listeners and timers during cleanup.',
    ],
    examples: [
      {
        title: 'Debounced input handler',
        description: 'Limits expensive work while typing.',
        code: '<input id="q" placeholder="Type here" />\n<p id="out"></p>\n<script>\n  const debounce = (fn, ms) => { let id; return (...args) => { clearTimeout(id); id = setTimeout(() => fn(...args), ms); }; };\n  const update = debounce((v) => { document.getElementById("out").textContent = `Searching: ${v}`; }, 250);\n  document.getElementById("q").addEventListener("input", (e) => update(e.target.value));\n</script>',
        outputHtml: '<p>Type in input to see debounced update.</p>',
      },
    ],
  },
  'js-security': {
    heading: 'JavaScript Security Basics',
    easySummary: 'Secure JavaScript prevents injection, data leaks, and unsafe trust assumptions in browser code.',
    theory: [
      'Common frontend risks include XSS, insecure token handling, clickjacking, unsafe third-party scripts, and accidental data exposure in logs. Security should be built into coding habits early.',
      'Never trust input from users or external APIs without validation or safe rendering. Prefer textContent over innerHTML for untrusted data. Use CSP and trusted libraries where applicable.',
      'Security is architecture-level, not just syntax-level. API design, auth flow, cookie strategy, and transport security all influence frontend safety.'
    ],
    practicalTips: [
      'Do not render unsanitized HTML from user content.',
      'Avoid storing sensitive secrets in localStorage.',
      'Audit dependencies and remove unused packages.',
    ],
    examples: [
      {
        title: 'Safe text rendering',
        description: 'Using textContent avoids HTML injection.',
        code: '<p id="safe"></p>\n<script>\n  const userInput = "<img src=x onerror=alert(1)>";\n  document.getElementById("safe").textContent = userInput;\n</script>',
        outputHtml: '<p>&lt;img src=x onerror=alert(1)&gt;</p>',
      },
    ],
  },
  'js-error-handling': {
    heading: 'Error Handling and Debugging',
    easySummary: 'Reliable JavaScript handles expected failures gracefully and captures unexpected issues with useful diagnostics.',
    theory: [
      'Use try/catch for synchronous and awaited async blocks where failure is expected. Throw clear Error objects with contextual messages so logs and monitoring are actionable.',
      'Operational errors (network failure, timeout, invalid input) should be handled and shown with user-friendly feedback. Programmer errors should be surfaced quickly in development and monitoring.',
      'A mature debugging flow combines logs, stack traces, DevTools breakpoints, network traces, and reproducible test cases. Debugging skill is often a stronger career differentiator than syntax speed.'
    ],
    practicalTips: [
      'Wrap boundary code (API, parsing, storage) with safe guards.',
      'Use structured logs with feature and request context.',
      'Fail loudly in development, fail gracefully in production UI.',
    ],
    examples: [
      {
        title: 'Try/catch with fallback UI',
        description: 'Shows controlled error flow and safe output.',
        code: '<script>\n  function parseProfile(json){\n    try {\n      const data = JSON.parse(json);\n      return data.name || "Unknown";\n    } catch (err) {\n      return "Invalid profile data";\n    }\n  }\n  document.body.innerHTML = `<p>${parseProfile("{bad json}")}</p>`;\n</script>',
        outputHtml: '<p>Invalid profile data</p>',
      },
    ],
  },
  'js-interview-qna': {
    heading: 'JavaScript Interview Preparation Strategy',
    easySummary: 'Focus on fundamentals, internals, asynchronous flow, browser behavior, and debugging depth for JavaScript interviews.',
    theory: [
      'Strong JavaScript interviews test understanding, not only syntax. You should explain how code runs, how scope and closures behave, how asynchronous queues work, and how browser APIs interact with JavaScript execution.',
      'Interviewers commonly ask for trade-offs and bug diagnosis. Be ready to explain why one approach is safer, faster, or more maintainable in real systems.',
      'Practice should include writing small functions, reading tricky snippets, debugging with DevTools, and explaining output order confidently. Theory plus hands-on debugging is the best preparation mix.'
    ],
    practicalTips: [
      'Prepare output-based questions on hoisting, closures, event loop, and this.',
      'Revise fetch, promises, and async error handling patterns.',
      'Use DevTools actively in practice sessions, not only coding platforms.',
    ],
    examples: [
      {
        title: 'Interview-style output question',
        description: 'Predict order first, then run and verify.',
        code: '<script>\n  console.log("A");\n  setTimeout(() => console.log("B"), 0);\n  Promise.resolve().then(() => console.log("C"));\n  console.log("D");\n  document.body.innerHTML = "<p>Expected order: A D C B</p>";\n</script>',
        outputHtml: '<p>Expected order: A D C B</p>',
      },
    ],
  },
};

const JS_METHOD_REFERENCE_SECTIONS = {
  'js-introduction': {
    title: 'JavaScript runtime and platform APIs',
    intro: 'Core objects and globals you should recognize from day one.',
    columns: [
      { key: 'item', label: 'API or object' },
      { key: 'type', label: 'Type' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'console.log()', type: 'Method', purpose: 'Debug and inspect values' },
      { item: 'setTimeout()', type: 'Method', purpose: 'Schedule delayed callback' },
      { item: 'setInterval()', type: 'Method', purpose: 'Schedule repeated callback' },
      { item: 'clearTimeout()', type: 'Method', purpose: 'Cancel timeout task' },
      { item: 'clearInterval()', type: 'Method', purpose: 'Cancel interval task' },
      { item: 'globalThis', type: 'Property', purpose: 'Unified global object reference' },
    ],
  },
  'js-variables-datatypes': {
    title: 'Data type helpers and inspectors',
    intro: 'Frequently used methods/properties for reliable type handling.',
    columns: [
      { key: 'item', label: 'Method or property' },
      { key: 'use', label: 'Use case' },
      { key: 'example', label: 'Example' },
    ],
    rows: [
      { item: 'typeof value', use: 'Primitive type inspection', example: 'typeof 10 -> number' },
      { item: 'Array.isArray(value)', use: 'Array check', example: 'Array.isArray([]) -> true' },
      { item: 'Number.isNaN(value)', use: 'Safe NaN check', example: 'Number.isNaN(NaN) -> true' },
      { item: 'Number.isFinite(value)', use: 'Finite number check', example: 'Number.isFinite(3) -> true' },
      { item: 'Object.prototype.toString.call(v)', use: 'Detailed type tag', example: '[object Date]' },
      { item: 'length', use: 'String/array length', example: '"abc".length -> 3' },
    ],
  },
  'js-operators-conditions': {
    title: 'Operator-related essentials',
    intro: 'These operators and property checks appear repeatedly in real code.',
    columns: [
      { key: 'item', label: 'Operator or check' },
      { key: 'role', label: 'Role' },
      { key: 'note', label: 'Note' },
    ],
    rows: [
      { item: '=== / !==', role: 'Strict comparison', note: 'Avoid coercion surprises' },
      { item: '??', role: 'Nullish fallback', note: 'Only null/undefined trigger fallback' },
      { item: '?.', role: 'Optional chaining', note: 'Safe nested access' },
      { item: 'in', role: 'Property existence', note: 'Checks own + inherited props' },
      { item: 'instanceof', role: 'Prototype chain check', note: 'Useful for class instances' },
      { item: 'Object.hasOwn(obj, key)', role: 'Own property check', note: 'Modern safer alternative' },
    ],
  },
  'js-loops-functions': {
    title: 'Loop and function methods',
    intro: 'Loop forms split separately with syntax shape and control behavior.',
    columns: [
      { key: 'item', label: 'Loop / Method' },
      { key: 'params', label: 'Syntax / params' },
      { key: 'control', label: 'Control features' },
      { key: 'bestFor', label: 'Best for' },
      { key: 'pitfall', label: 'Common pitfall' },
    ],
    rows: [
      { item: 'for', params: '(init; condition; step)', control: 'Supports break and continue', bestFor: 'Index-controlled iteration and reverse loops', pitfall: 'Off-by-one boundary bugs' },
      { item: 'while', params: '(condition)', control: 'Condition checked before each run', bestFor: 'Unknown iteration count scenarios', pitfall: 'Infinite loop if state not updated' },
      { item: 'do...while', params: 'do { ... } while (condition)', control: 'Runs body once before checking', bestFor: 'At-least-once workflows', pitfall: 'Unexpected first run when condition false' },
      { item: 'for...of', params: 'for (const value of iterable)', control: 'Supports break and continue', bestFor: 'Array/string/map/set value iteration', pitfall: 'Not for plain objects directly' },
      { item: 'for...in', params: 'for (const key in object)', control: 'Supports break and continue', bestFor: 'Object key traversal', pitfall: 'Includes inherited enumerable keys if not guarded' },
      { item: 'forEach', params: 'array.forEach((value, index, arr) => {})', control: 'No break/continue support', bestFor: 'Callback-style list processing', pitfall: 'Cannot short-circuit naturally' },
      { item: 'Function.prototype.call()', params: '(thisArg, ...args)', control: 'Immediate invocation', bestFor: 'Invoke function with explicit this', pitfall: 'Wrong args order' },
      { item: 'Function.prototype.apply()', params: '(thisArg, argsArray)', control: 'Immediate invocation', bestFor: 'Invoke function when args already in array', pitfall: 'Less used than spread now' },
      { item: 'Function.prototype.bind()', params: '(thisArg, ...presetArgs)', control: 'Returns bound function', bestFor: 'Preserve context for callbacks', pitfall: 'Can hide context bugs' },
      { item: 'arguments.length', params: 'Property', control: 'Read-only count of passed args', bestFor: 'Legacy function argument introspection', pitfall: 'Not available in arrow functions' },
    ],
  },
  'js-arrays-objects': {
    title: 'Arrays and objects method catalog',
    intro: 'Core methods split one-by-one with params and mutation behavior.',
    columns: [
      { key: 'item', label: 'Method/property' },
      { key: 'params', label: 'Parameters' },
      { key: 'mutates', label: 'Mutates original' },
      { key: 'returns', label: 'Return kind' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'map', params: '(callback, thisArg?)', mutates: 'No', returns: 'New array', purpose: 'Transform each array item' },
      { item: 'filter', params: '(callback, thisArg?)', mutates: 'No', returns: 'New array', purpose: 'Keep items matching condition' },
      { item: 'reduce', params: '(callback, initialValue)', mutates: 'No', returns: 'Any type', purpose: 'Accumulate into single value/object' },
      { item: 'find', params: '(callback, thisArg?)', mutates: 'No', returns: 'Item or undefined', purpose: 'Get first matching item' },
      { item: 'some', params: '(callback, thisArg?)', mutates: 'No', returns: 'Boolean', purpose: 'Check at least one match' },
      { item: 'every', params: '(callback, thisArg?)', mutates: 'No', returns: 'Boolean', purpose: 'Check all items match' },
      { item: 'includes', params: '(valueToFind, fromIndex?)', mutates: 'No', returns: 'Boolean', purpose: 'Membership check in array/string' },
      { item: 'push', params: '(...items)', mutates: 'Yes', returns: 'Number', purpose: 'Append items to array end' },
      { item: 'pop', params: '()', mutates: 'Yes', returns: 'Removed item', purpose: 'Remove last array item' },
      { item: 'shift', params: '()', mutates: 'Yes', returns: 'Removed item', purpose: 'Remove first array item' },
      { item: 'unshift', params: '(...items)', mutates: 'Yes', returns: 'Number', purpose: 'Insert items at array start' },
      { item: 'splice', params: '(start, deleteCount, ...items)', mutates: 'Yes', returns: 'Array', purpose: 'Insert/delete/replace at index' },
      { item: 'slice', params: '(start?, end?)', mutates: 'No', returns: 'New array', purpose: 'Copy selected array section' },
      { item: 'concat', params: '(...arraysOrValues)', mutates: 'No', returns: 'New array', purpose: 'Merge arrays immutably' },
      { item: 'flat', params: '(depth = 1)', mutates: 'No', returns: 'New array', purpose: 'Flatten nested arrays by depth' },
      { item: 'flatMap', params: '(callback, thisArg?)', mutates: 'No', returns: 'New array', purpose: 'Map and flatten one level' },
      { item: 'Object.keys', params: '(obj)', mutates: 'No', returns: 'Array<string>', purpose: 'Get own enumerable keys' },
      { item: 'Object.values', params: '(obj)', mutates: 'No', returns: 'Array<any>', purpose: 'Get own enumerable values' },
      { item: 'Object.entries', params: '(obj)', mutates: 'No', returns: 'Array<[key,value]>', purpose: 'Get key-value entry tuples' },
      { item: 'Object.assign', params: '(target, ...sources)', mutates: 'Target only', returns: 'Target object', purpose: 'Shallow merge/copy' },
      { item: 'Object.freeze', params: '(obj)', mutates: 'Freezes object', returns: 'Same object', purpose: 'Prevent top-level writes' },
      { item: 'Object.hasOwn', params: '(obj, prop)', mutates: 'No', returns: 'Boolean', purpose: 'Check own property safely' },
    ],
  },
  'js-dom': {
    title: 'DOM methods and properties',
    intro: 'Essential DOM APIs for querying and updating UI.',
    columns: [
      { key: 'item', label: 'Method/property' },
      { key: 'kind', label: 'Kind' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'document.querySelector()', kind: 'Method', purpose: 'Select first matching element' },
      { item: 'querySelectorAll()', kind: 'Method', purpose: 'Select node list of matches' },
      { item: 'getElementById()', kind: 'Method', purpose: 'Fast ID lookup' },
      { item: 'classList.add/remove/toggle', kind: 'Methods', purpose: 'Manage CSS classes' },
      { item: 'textContent / innerHTML', kind: 'Properties', purpose: 'Set element content' },
      { item: 'setAttribute/getAttribute', kind: 'Methods', purpose: 'Manage attributes' },
    ],
  },
  'js-events': {
    title: 'Event system methods/properties',
    intro: 'Core event APIs with parameter shape and propagation relevance.',
    columns: [
      { key: 'item', label: 'Method/property' },
      { key: 'params', label: 'Parameters' },
      { key: 'where', label: 'Where' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'addEventListener(type, handler, options)', params: '("click", fn, {capture?, once?, passive?})', where: 'Element/Window', purpose: 'Attach listener in capture or bubble phase' },
      { item: 'removeEventListener(type, handler, options)', params: '(same type + same handler + same capture flag)', where: 'Element/Window', purpose: 'Detach listener and prevent leaks' },
      { item: 'event.target', params: 'Property', where: 'Event object', purpose: 'Actual origin element of event' },
      { item: 'event.currentTarget', params: 'Property', where: 'Event object', purpose: 'Element whose listener is currently running' },
      { item: 'event.eventPhase', params: 'Property (1 capture, 2 target, 3 bubble)', where: 'Event object', purpose: 'Know current propagation phase' },
      { item: 'event.bubbles', params: 'Property', where: 'Event object', purpose: 'Check whether event supports bubbling' },
      { item: 'preventDefault()', params: '()', where: 'Event object', purpose: 'Prevent default browser action only' },
      { item: 'stopPropagation()', params: '()', where: 'Event object', purpose: 'Stop propagation to ancestors' },
      { item: 'stopImmediatePropagation()', params: '()', where: 'Event object', purpose: 'Stop propagation and sibling listeners on same node' },
      { item: 'closest(selector)', params: '("[data-id]")', where: 'Element method', purpose: 'Find intended delegated child action target' },
      { item: 'dispatchEvent(event)', params: '(new MouseEvent("click", {bubbles:true}))', where: 'Element method', purpose: 'Programmatically trigger event flow' },
      { item: 'event.key / event.code', params: 'Properties', where: 'Keyboard events', purpose: 'Key-specific handling' },
    ],
  },
  'js-es6': {
    title: 'Modern JavaScript method/property patterns',
    intro: 'ES6+ syntax and utilities that appear in production code.',
    columns: [
      { key: 'item', label: 'Feature' },
      { key: 'value', label: 'Value' },
      { key: 'example', label: 'Example use' },
    ],
    rows: [
      { item: 'Destructuring', value: 'Read specific fields quickly', example: 'const {id} = user' },
      { item: 'Spread (...)', value: 'Shallow copy/merge', example: '{...old, done:true}' },
      { item: 'Template literals', value: 'Readable string interpolation', example: '`Hi ${name}`' },
      { item: 'Default params', value: 'Safer function defaults', example: 'function f(x=0){}' },
      { item: 'Object shorthand', value: 'Cleaner object creation', example: '{id, name}' },
      { item: 'Rest params', value: 'Variable arg collection', example: '(...args) => {}' },
    ],
  },
  'js-execution-context-call-stack': {
    title: 'Engine-level execution terms',
    intro: 'Core behind-the-scenes model for execution.',
    columns: [
      { key: 'item', label: 'Term' },
      { key: 'meaning', label: 'Meaning' },
      { key: 'debugClue', label: 'Debug clue' },
    ],
    rows: [
      { item: 'Global Execution Context', meaning: 'Default top-level context', debugClue: 'Created once per script load' },
      { item: 'Function Execution Context', meaning: 'Context for each function call', debugClue: 'Push/pop stack frame' },
      { item: 'Call Stack', meaning: 'LIFO execution frame stack', debugClue: 'Use stack trace in errors' },
      { item: 'Memory/Heap', meaning: 'Object allocation area', debugClue: 'Watch for retained references' },
      { item: 'Scope chain', meaning: 'Lookup path for identifiers', debugClue: 'ReferenceError if not found' },
      { item: 'Stack overflow', meaning: 'Too many nested calls', debugClue: 'Missing recursion base case' },
    ],
  },
  'js-hoisting-tdz': {
    title: 'Hoisting rules and TDZ behavior',
    intro: 'Precise behavior interviewers expect you to know.',
    columns: [
      { key: 'item', label: 'Declaration type' },
      { key: 'hoistedAs', label: 'Hoisted as' },
      { key: 'preInitAccess', label: 'Access before init' },
    ],
    rows: [
      { item: 'var', hoistedAs: 'undefined', preInitAccess: 'Allowed, returns undefined' },
      { item: 'let', hoistedAs: 'uninitialized binding', preInitAccess: 'ReferenceError (TDZ)' },
      { item: 'const', hoistedAs: 'uninitialized binding', preInitAccess: 'ReferenceError (TDZ)' },
      { item: 'function declaration', hoistedAs: 'callable function', preInitAccess: 'Allowed' },
      { item: 'class declaration', hoistedAs: 'uninitialized binding', preInitAccess: 'ReferenceError' },
      { item: 'function expression', hoistedAs: 'var/let rules apply', preInitAccess: 'Depends on declaration kind' },
    ],
  },
  'js-scope-closures': {
    title: 'Scope and closure essentials',
    intro: 'Closure behavior and memory implications.',
    columns: [
      { key: 'item', label: 'Concept' },
      { key: 'behavior', label: 'Behavior' },
      { key: 'bestUse', label: 'Best use' },
    ],
    rows: [
      { item: 'Global scope', behavior: 'Accessible broadly', bestUse: 'Minimal shared constants' },
      { item: 'Function scope', behavior: 'Visible inside function', bestUse: 'Encapsulate internal state' },
      { item: 'Block scope', behavior: 'let/const limited to block', bestUse: 'Safer loops and conditions' },
      { item: 'Closure', behavior: 'Retains outer lexical bindings', bestUse: 'Factory/private state' },
      { item: 'IIFE', behavior: 'Immediate isolated scope', bestUse: 'Legacy encapsulation pattern' },
      { item: 'Garbage collection', behavior: 'Reclaims unreachable data', bestUse: 'Release references in long-lived apps' },
    ],
  },
  'js-this-keyword': {
    title: 'this binding methods and rules',
    intro: 'How this is decided and controlled.',
    columns: [
      { key: 'item', label: 'Mechanism' },
      { key: 'effect', label: 'Effect' },
      { key: 'note', label: 'Note' },
    ],
    rows: [
      { item: 'Method call obj.fn()', effect: 'this = obj', note: 'Depends on call-site' },
      { item: 'Function call fn()', effect: 'this = undefined (strict)', note: 'Global in non-strict legacy mode' },
      { item: 'new Fn()', effect: 'this = new instance', note: 'Constructor invocation context' },
      { item: 'fn.call(ctx, ...args)', effect: 'Immediate explicit this', note: 'Args passed one by one' },
      { item: 'fn.apply(ctx, argsArray)', effect: 'Immediate explicit this', note: 'Args passed as array' },
      { item: 'fn.bind(ctx)', effect: 'Returns bound function', note: 'Useful for callbacks' },
    ],
  },
  'js-prototypes-inheritance': {
    title: 'Prototype and inheritance methods/properties',
    intro: 'APIs to inspect and control prototype behavior.',
    columns: [
      { key: 'item', label: 'API' },
      { key: 'type', label: 'Type' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'Object.getPrototypeOf(obj)', type: 'Method', purpose: 'Read current prototype' },
      { item: 'Object.setPrototypeOf(obj, proto)', type: 'Method', purpose: 'Set prototype (careful with perf)' },
      { item: 'obj.__proto__', type: 'Property (legacy)', purpose: 'Prototype access in debugging' },
      { item: 'hasOwnProperty(key)', type: 'Method', purpose: 'Check own props only' },
      { item: 'instanceof', type: 'Operator', purpose: 'Check constructor prototype chain' },
      { item: 'class extends', type: 'Syntax', purpose: 'Prototype inheritance sugar' },
    ],
  },
  'js-event-loop': {
    title: 'Scheduling APIs and queue behavior',
    intro: 'APIs that place work into task queues.',
    columns: [
      { key: 'item', label: 'API' },
      { key: 'queue', label: 'Queue' },
      { key: 'note', label: 'Note' },
    ],
    rows: [
      { item: 'Promise.then/catch/finally', queue: 'Microtask', note: 'Runs before next macrotask' },
      { item: 'queueMicrotask()', queue: 'Microtask', note: 'Explicit microtask scheduling' },
      { item: 'MutationObserver callback', queue: 'Microtask-like', note: 'Runs after DOM mutations' },
      { item: 'setTimeout()', queue: 'Macrotask', note: 'Delay is minimum, not exact time' },
      { item: 'setInterval()', queue: 'Macrotask', note: 'Can drift if callback is heavy' },
      { item: 'requestAnimationFrame()', queue: 'Render frame', note: 'Best for animation updates' },
    ],
  },
  'js-promises': {
    title: 'Promise methods and properties quick map',
    intro: 'Complete map for day-to-day asynchronous orchestration.',
    columns: [
      { key: 'item', label: 'Method/property' },
      { key: 'scope', label: 'Scope' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'then()', scope: 'Instance', purpose: 'Handle success and transform output' },
      { item: 'catch()', scope: 'Instance', purpose: 'Handle rejection in chain' },
      { item: 'finally()', scope: 'Instance', purpose: 'Cleanup after settle' },
      { item: 'Promise.resolve()', scope: 'Static', purpose: 'Create fulfilled promise' },
      { item: 'Promise.reject()', scope: 'Static', purpose: 'Create rejected promise' },
      { item: 'Promise.all/allSettled/race/any', scope: 'Static', purpose: 'Concurrent orchestration patterns' },
    ],
  },
  'js-async': {
    title: 'async/await patterns and helpers',
    intro: 'Methods frequently combined with async/await.',
    columns: [
      { key: 'item', label: 'Pattern/API' },
      { key: 'why', label: 'Why use it' },
      { key: 'careful', label: 'Be careful about' },
    ],
    rows: [
      { item: 'await Promise.all([...])', why: 'Concurrent execution', careful: 'One rejection fails all' },
      { item: 'await Promise.allSettled([...])', why: 'Collect partial outcomes', careful: 'Need manual status checks' },
      { item: 'try/catch/finally', why: 'Structured error and cleanup', careful: 'Do not swallow errors silently' },
      { item: 'for...of + await', why: 'Sequential dependency flow', careful: 'Can be slower for independent tasks' },
      { item: 'Promise.race([...])', why: 'Timeout and fast-first behavior', careful: 'First reject can abort flow' },
      { item: 'Promise.any([...])', why: 'First-success behavior', careful: 'All failures throw AggregateError' },
    ],
  },
  'js-fetch-api': {
    title: 'Fetch methods and response properties',
    intro: 'HTTP request/response APIs to master for frontend apps.',
    columns: [
      { key: 'item', label: 'Method/property' },
      { key: 'object', label: 'Object' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'fetch()', object: 'Window', purpose: 'Send request and get Response promise' },
      { item: 'ok/status/statusText', object: 'Response', purpose: 'Evaluate HTTP result' },
      { item: 'json()/text()/blob()/arrayBuffer()', object: 'Response', purpose: 'Parse body in needed format' },
      { item: 'headers.get(name)', object: 'Headers', purpose: 'Read response header values' },
      { item: 'AbortController.abort()', object: 'AbortController', purpose: 'Cancel pending request' },
      { item: 'signal.aborted/reason', object: 'AbortSignal', purpose: 'Inspect cancellation state' },
    ],
  },
  'js-modules-tooling': {
    title: 'Module and tooling capabilities',
    intro: 'Methods/properties and settings used in module-based apps.',
    columns: [
      { key: 'item', label: 'Feature' },
      { key: 'type', label: 'Type' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'export / export default', type: 'Syntax', purpose: 'Expose module APIs' },
      { item: 'import {x} / import x', type: 'Syntax', purpose: 'Consume module exports' },
      { item: 'import()', type: 'Method-like syntax', purpose: 'Lazy load module dynamically' },
      { item: 'package.json scripts', type: 'Config', purpose: 'Standardized build/test commands' },
      { item: 'source maps', type: 'Build output feature', purpose: 'Map bundled code back to source' },
      { item: 'tree shaking', type: 'Bundler optimization', purpose: 'Remove unused exports' },
    ],
  },
  'js-browser-storage': {
    title: 'Storage APIs methods/properties',
    intro: 'Client-side persistence API capabilities and trade-offs.',
    columns: [
      { key: 'item', label: 'Method/property' },
      { key: 'api', label: 'API' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'setItem/getItem/removeItem/clear', api: 'localStorage/sessionStorage', purpose: 'CRUD for key-value strings' },
      { item: 'key(index)/length', api: 'Storage', purpose: 'Enumerate keys and count items' },
      { item: 'document.cookie', api: 'Cookies', purpose: 'Read/write cookie string' },
      { item: 'indexedDB.open()', api: 'IndexedDB', purpose: 'Open/create client database' },
      { item: 'caches.open()/match()/put()', api: 'Cache Storage', purpose: 'Service-worker cache management' },
      { item: 'storage event', api: 'Window event', purpose: 'Cross-tab storage change sync' },
    ],
  },
  'js-devtools-debugging': {
    title: 'DevTools methods and diagnostic capabilities',
    intro: 'Practical operations to debug faster in browser projects.',
    columns: [
      { key: 'item', label: 'Tool/API' },
      { key: 'panel', label: 'Panel' },
      { key: 'use', label: 'Use' },
    ],
    rows: [
      { item: 'console.log/table/dir', panel: 'Console', use: 'Inspect values and structures' },
      { item: 'console.time/timeEnd', panel: 'Console', use: 'Measure execution duration' },
      { item: 'Breakpoints/step over/in/out', panel: 'Sources', use: 'Runtime flow debugging' },
      { item: 'XHR/Fetch filter + timing', panel: 'Network', use: 'API debugging and latency analysis' },
      { item: 'Performance recording', panel: 'Performance', use: 'Detect long tasks and jank' },
      { item: 'Heap snapshot comparison', panel: 'Memory', use: 'Find leaks and retained objects' },
    ],
  },
  'js-performance-memory': {
    title: 'Performance and memory-focused APIs',
    intro: 'Methods/properties for optimization and leak prevention.',
    columns: [
      { key: 'item', label: 'API' },
      { key: 'category', label: 'Category' },
      { key: 'value', label: 'Why it matters' },
    ],
    rows: [
      { item: 'performance.now()', category: 'Timing', value: 'High-resolution performance timing' },
      { item: 'requestAnimationFrame()', category: 'Rendering', value: 'Smooth frame-synced UI updates' },
      { item: 'cancelAnimationFrame()', category: 'Rendering', value: 'Stop stale animation work' },
      { item: 'requestIdleCallback()', category: 'Scheduling', value: 'Background non-urgent tasks' },
      { item: 'PerformanceObserver', category: 'Metrics', value: 'Observe paint/layout/web-vitals entries' },
      { item: 'removeEventListener()', category: 'Memory hygiene', value: 'Prevent listener leaks' },
    ],
  },
  'js-security': {
    title: 'Security-relevant methods/properties',
    intro: 'APIs and patterns that directly affect frontend security posture.',
    columns: [
      { key: 'item', label: 'Item' },
      { key: 'riskArea', label: 'Risk area' },
      { key: 'safeUse', label: 'Safer use' },
    ],
    rows: [
      { item: 'innerHTML', riskArea: 'XSS injection', safeUse: 'Prefer textContent for untrusted input' },
      { item: 'textContent', riskArea: 'Low injection risk', safeUse: 'Default for user-provided text' },
      { item: 'setAttribute("href", ...)', riskArea: 'Unsafe URL protocols', safeUse: 'Validate protocol before set' },
      { item: 'postMessage()', riskArea: 'Cross-origin messaging', safeUse: 'Validate origin and payload schema' },
      { item: 'localStorage', riskArea: 'Token theft via XSS', safeUse: 'Avoid storing critical long-lived secrets' },
      { item: 'fetch credentials option', riskArea: 'Auth/session exposure', safeUse: 'Use same-site cookie strategy carefully' },
    ],
  },
  'js-error-handling': {
    title: 'Error handling methods and properties',
    intro: 'Error objects and async-safe patterns every developer should know.',
    columns: [
      { key: 'item', label: 'Method/property' },
      { key: 'belongsTo', label: 'Belongs to' },
      { key: 'purpose', label: 'Purpose' },
    ],
    rows: [
      { item: 'try/catch/finally', belongsTo: 'Language', purpose: 'Synchronous and awaited error flow' },
      { item: 'throw new Error(message)', belongsTo: 'Language', purpose: 'Raise explicit failures' },
      { item: 'error.name/message/stack', belongsTo: 'Error object', purpose: 'Classify and diagnose failure' },
      { item: 'Promise.catch()', belongsTo: 'Promise', purpose: 'Async rejection handling' },
      { item: 'window.onerror', belongsTo: 'Window', purpose: 'Global runtime error capture' },
      { item: 'window.onunhandledrejection', belongsTo: 'Window', purpose: 'Capture missed promise rejections' },
    ],
  },
  'js-interview-qna': {
    title: 'High-frequency JavaScript interview checklist',
    intro: 'Methods/properties and concepts commonly tested in interviews.',
    columns: [
      { key: 'topic', label: 'Topic' },
      { key: 'mustKnow', label: 'Must know details' },
      { key: 'practiceType', label: 'Practice type' },
    ],
    rows: [
      { topic: 'Promises', mustKnow: 'then/catch/finally + all/allSettled/race/any', practiceType: 'Output/order + API scenarios' },
      { topic: 'Event loop', mustKnow: 'Microtask vs macrotask ordering', practiceType: 'Predict log sequence' },
      { topic: 'Closures', mustKnow: 'State retention and memory behavior', practiceType: 'Factory/private data examples' },
      { topic: 'this binding', mustKnow: 'call/apply/bind + arrow behavior', practiceType: 'Refactor broken callback context' },
      { topic: 'Objects/arrays', mustKnow: 'map/filter/reduce + immutability', practiceType: 'Transform API payloads' },
      { topic: 'Debugging', mustKnow: 'Breakpoints/network/performance tools', practiceType: 'Bug reproduction and root-cause flow' },
    ],
  },
};

const JS_VISUAL_EXAMPLES = {
  'js-introduction': {
    title: 'Runtime architecture map',
    description: 'Visual map of JavaScript engine and browser APIs.',
    code: '<div style="font-family:Arial,sans-serif;border:1px solid #94a3b8;border-radius:12px;padding:12px;max-width:760px;">\n  <div style="font-weight:700;margin-bottom:8px;">Browser Runtime Overview</div>\n  <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">\n    <div style="border:1px dashed #2563eb;padding:8px;border-radius:8px;">JS Engine (V8)</div>\n    <div style="border:1px dashed #16a34a;padding:8px;border-radius:8px;">Web APIs (DOM, fetch, timers)</div>\n  </div>\n</div>',
    outputHtml: '<div style="font-family:Arial,sans-serif;border:1px solid #94a3b8;border-radius:12px;padding:12px;max-width:760px;"><div style="font-weight:700;margin-bottom:8px;">Browser Runtime Overview</div><div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;"><div style="border:1px dashed #2563eb;padding:8px;border-radius:8px;">JS Engine (V8)</div><div style="border:1px dashed #16a34a;padding:8px;border-radius:8px;">Web APIs (DOM, fetch, timers)</div></div></div>',
  },
  'js-event-loop': {
    title: 'Event loop motion view',
    description: 'Animated flow showing call stack and queue scheduling.',
    code: '<style>\n  .loop-wrap{font-family:Arial,sans-serif;display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;max-width:820px;}\n  .loop-box{border:1px solid #94a3b8;border-radius:10px;padding:10px;background:#f8fafc;}\n  .dot{width:10px;height:10px;background:#16a34a;border-radius:50%;animation:move 1.6s ease-in-out infinite;}\n  @keyframes move{0%{transform:translateX(0)}50%{transform:translateX(38px)}100%{transform:translateX(0)}}\n</style>\n<div class="loop-wrap">\n  <div class="loop-box"><b>Call Stack</b><div class="dot"></div></div>\n  <div class="loop-box"><b>Microtask Queue</b><p>Promise.then</p></div>\n  <div class="loop-box"><b>Task Queue</b><p>setTimeout</p></div>\n</div>',
    outputHtml: '<div style="font-family:Arial,sans-serif;max-width:820px;display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;"><div style="border:1px solid #94a3b8;border-radius:10px;padding:10px;background:#f8fafc;"><b>Call Stack</b><div style="width:10px;height:10px;background:#16a34a;border-radius:50%;"></div></div><div style="border:1px solid #94a3b8;border-radius:10px;padding:10px;background:#f8fafc;"><b>Microtask Queue</b><p>Promise.then</p></div><div style="border:1px solid #94a3b8;border-radius:10px;padding:10px;background:#f8fafc;"><b>Task Queue</b><p>setTimeout</p></div></div>',
  },
  'js-scope-closures': {
    title: 'Scope memory flow card',
    description: 'Animated card showing lexical lookup and closure memory retention.',
    code: '<style>\n  .scope-wrap{font-family:Arial,sans-serif;max-width:860px;display:grid;grid-template-columns:1.05fr 1fr;gap:10px;}\n  .scope-box{border:1px solid #94a3b8;border-radius:12px;padding:10px;background:#f8fafc;}\n  .scope-pill{display:inline-block;padding:5px 10px;border-radius:999px;border:1px solid #86efac;background:#dcfce7;color:#166534;font-weight:700;animation:glow 1.4s ease-in-out infinite;}\n  .scope-link{margin:8px 0;font-weight:700;color:#2563eb;animation:sway 1.4s ease-in-out infinite;}\n  @keyframes glow{0%,100%{box-shadow:0 0 0 rgba(22,163,74,0)}50%{box-shadow:0 0 0 6px rgba(22,163,74,.16)}}\n  @keyframes sway{0%,100%{transform:translateX(0)}50%{transform:translateX(8px)}}\n</style>\n<div class="scope-wrap">\n  <div class="scope-box">\n    <b>Lexical Scope Chain</b>\n    <p style="margin:8px 0 6px;">inner() reads <code>count</code> from outer scope.</p>\n    <div class="scope-link">outer() -> inner()</div>\n    <span class="scope-pill">Lookup succeeds in parent scope</span>\n  </div>\n  <div class="scope-box">\n    <b>Closure Memory</b>\n    <p style="margin:8px 0 6px;">Returned function keeps <code>count</code> alive.</p>\n    <span class="scope-pill">count persists: 1, 2, 3...</span>\n  </div>\n</div>',
    outputHtml: '<div style="font-family:Arial,sans-serif;max-width:860px;display:grid;grid-template-columns:1.05fr 1fr;gap:10px;"><div style="border:1px solid #94a3b8;border-radius:12px;padding:10px;background:#f8fafc;"><b>Lexical Scope Chain</b><p style="margin:8px 0 6px;">inner() reads count from outer scope.</p><div style="margin:8px 0;font-weight:700;color:#2563eb;">outer() -> inner()</div><span style="display:inline-block;padding:5px 10px;border-radius:999px;border:1px solid #86efac;background:#dcfce7;color:#166534;font-weight:700;">Lookup succeeds in parent scope</span></div><div style="border:1px solid #94a3b8;border-radius:12px;padding:10px;background:#f8fafc;"><b>Closure Memory</b><p style="margin:8px 0 6px;">Returned function keeps count alive.</p><span style="display:inline-block;padding:5px 10px;border-radius:999px;border:1px solid #86efac;background:#dcfce7;color:#166534;font-weight:700;">count persists: 1, 2, 3...</span></div></div>',
  },
  'js-promises': {
    title: 'Promise state flow view',
    description: 'Visualizes pending to fulfilled/rejected transitions.',
    code: '<style>\n  .p{font-family:Arial,sans-serif;display:flex;gap:8px;align-items:center;flex-wrap:wrap;}\n  .n{border:1px solid #94a3b8;border-radius:999px;padding:6px 10px;background:#fff;}\n  .a{font-weight:700;color:#16a34a;animation:pulse 1.1s ease-in-out infinite;}\n  @keyframes pulse{0%,100%{opacity:1}50%{opacity:.45}}\n</style>\n<div class="p"><span class="n">pending</span><span class="a">-></span><span class="n">fulfilled</span><span>or</span><span class="n">rejected</span></div>',
    outputHtml: '<div style="font-family:Arial,sans-serif;display:flex;gap:8px;align-items:center;flex-wrap:wrap;"><span style="border:1px solid #94a3b8;border-radius:999px;padding:6px 10px;background:#fff;">pending</span><span style="font-weight:700;color:#16a34a;">-></span><span style="border:1px solid #94a3b8;border-radius:999px;padding:6px 10px;background:#fff;">fulfilled</span><span>or</span><span style="border:1px solid #94a3b8;border-radius:999px;padding:6px 10px;background:#fff;">rejected</span></div>',
  },
  'js-fetch-api': {
    title: 'Request lifecycle animation',
    description: 'Shows request to response journey.',
    code: '<style>\n  .f{font-family:Arial,sans-serif;display:flex;align-items:center;gap:10px;flex-wrap:wrap;}\n  .b{border:1px solid #94a3b8;border-radius:8px;padding:8px 10px;background:#fff;}\n  .arrow{color:#2563eb;animation:blink 1s linear infinite;}\n  @keyframes blink{50%{opacity:.35}}\n</style>\n<div class="f"><span class="b">Client</span><span class="arrow">==></span><span class="b">Network</span><span class="arrow">==></span><span class="b">Response</span></div>',
    outputHtml: '<div style="font-family:Arial,sans-serif;display:flex;align-items:center;gap:10px;flex-wrap:wrap;"><span style="border:1px solid #94a3b8;border-radius:8px;padding:8px 10px;background:#fff;">Client</span><span style="color:#2563eb;">==></span><span style="border:1px solid #94a3b8;border-radius:8px;padding:8px 10px;background:#fff;">Network</span><span style="color:#2563eb;">==></span><span style="border:1px solid #94a3b8;border-radius:8px;padding:8px 10px;background:#fff;">Response</span></div>',
  },
  'js-devtools-debugging': {
    title: 'DevTools workflow map',
    description: 'Map of panels used during debugging.',
    code: '<div style="font-family:Arial,sans-serif;display:grid;grid-template-columns:repeat(4,minmax(110px,1fr));gap:8px;max-width:900px;">\n  <div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Elements</div>\n  <div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Console</div>\n  <div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Network</div>\n  <div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Performance</div>\n</div>',
    outputHtml: '<div style="font-family:Arial,sans-serif;display:grid;grid-template-columns:repeat(4,minmax(110px,1fr));gap:8px;max-width:900px;"><div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Elements</div><div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Console</div><div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Network</div><div style="border:1px solid #94a3b8;border-radius:8px;padding:8px;">Performance</div></div>',
  },
};

Object.entries(JS_METHOD_REFERENCE_SECTIONS).forEach(([topicId, section]) => {
  if (JS_LESSONS[topicId]) {
    JS_LESSONS[topicId].referenceSections = [
      ...(JS_LESSONS[topicId].referenceSections || []),
      section,
    ];
  }
});

Object.entries(JS_VISUAL_EXAMPLES).forEach(([topicId, example]) => {
  if (JS_LESSONS[topicId]) {
    JS_LESSONS[topicId].examples = [
      ...(JS_LESSONS[topicId].examples || []),
      example,
    ];
  }
});

Object.keys(JS_LESSONS).forEach((topicId) => {
  const hasVisual = (JS_LESSONS[topicId].examples || []).some((example) =>
    /visual|animation|workflow|map|flow|motion/i.test(`${example.title} ${example.description}`)
  );

  if (!hasVisual) {
    const lessonHeading = JS_LESSONS[topicId].heading || topicId;
    JS_LESSONS[topicId].examples = [
      ...(JS_LESSONS[topicId].examples || []),
      {
        title: `${lessonHeading} Visual Motion Card`,
        description: 'Quick animated card to reinforce this topic.',
        code: `<style>\n  .js-visual-card{font-family:Arial,sans-serif;border:1px solid #94a3b8;border-radius:12px;padding:12px;max-width:760px;background:#f8fafc;}\n  .js-visual-chip{display:inline-block;margin-top:8px;padding:5px 10px;border-radius:999px;border:1px solid #86efac;background:#dcfce7;color:#166534;font-weight:700;animation:pop 1.2s ease-in-out infinite;}\n  @keyframes pop{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}\n</style>\n<div class="js-visual-card">\n  <strong>${lessonHeading}</strong>\n  <p style="margin-top:6px;">Concept -> Practice -> Debug -> Optimization</p>\n  <span class="js-visual-chip">Core Flow</span>\n</div>`,
        outputHtml: `<div style="font-family:Arial,sans-serif;border:1px solid #94a3b8;border-radius:12px;padding:12px;max-width:760px;background:#f8fafc;"><strong>${lessonHeading}</strong><p style="margin-top:6px;">Concept -> Practice -> Debug -> Optimization</p><span style="display:inline-block;margin-top:8px;padding:5px 10px;border-radius:999px;border:1px solid #86efac;background:#dcfce7;color:#166534;font-weight:700;">Core Flow</span></div>`,
      },
    ];
  }
});

export const JS_INTERVIEW_QNA = [
  {
    section: 'Beginner Round',
    questions: [
      {
        id: 'qna-js-1',
        question: 'What is JavaScript and where does it run in modern applications?',
        resourceTopicId: 'js-introduction',
      },
      {
        id: 'qna-js-2',
        question: 'What is the difference between var, let, and const?',
        resourceTopicId: 'js-variables-datatypes',
      },
      {
        id: 'qna-js-3',
        question: 'What are primitive and reference data types in JavaScript?',
        resourceTopicId: 'js-variables-datatypes',
      },
      {
        id: 'qna-js-4',
        question: 'Explain == versus === with interview examples.',
        resourceTopicId: 'js-operators-conditions',
      },
      {
        id: 'qna-js-5',
        question: 'When should you use if/else, switch, and ternary operators?',
        resourceTopicId: 'js-operators-conditions',
      },
      {
        id: 'qna-js-6',
        question: 'What is the difference between function declaration and function expression?',
        resourceTopicId: 'js-loops-functions',
      },
      {
        id: 'qna-js-7',
        question: 'How do for, while, for...of, and forEach differ in behavior?',
        resourceTopicId: 'js-loops-functions',
      },
      {
        id: 'qna-js-8',
        question: 'How do map, filter, and reduce solve real transformation tasks?',
        resourceTopicId: 'js-arrays-objects',
      },
      {
        id: 'qna-js-9',
        question: 'How do you create, read, update, and delete object properties?',
        resourceTopicId: 'js-arrays-objects',
      },
      {
        id: 'qna-js-10',
        question: 'What is the DOM and how do querySelector and textContent work?',
        resourceTopicId: 'js-dom',
      },
      {
        id: 'qna-js-11',
        question: 'How do addEventListener and event.preventDefault work in forms?',
        resourceTopicId: 'js-events',
      },
      {
        id: 'qna-js-12',
        question: 'What are template literals, destructuring, and spread operator?',
        resourceTopicId: 'js-es6',
      },
    ],
  },
  {
    section: 'Intermediate Round',
    questions: [
      {
        id: 'qna-js-13',
        question: 'What is execution context and how does JavaScript execute a file line by line?',
        resourceTopicId: 'js-execution-context-call-stack',
      },
      {
        id: 'qna-js-14',
        question: 'Explain hoisting and Temporal Dead Zone with let/const.',
        resourceTopicId: 'js-hoisting-tdz',
      },
      {
        id: 'qna-js-15',
        question: 'What is lexical scope and why do closures remember parent variables?',
        resourceTopicId: 'js-scope-closures',
      },
      {
        id: 'qna-js-16',
        question: 'How does this binding change in method calls, arrow functions, and callbacks?',
        resourceTopicId: 'js-this-keyword',
      },
      {
        id: 'qna-js-17',
        question: 'What is prototype chain lookup and how does inheritance actually work?',
        resourceTopicId: 'js-prototypes-inheritance',
      },
      {
        id: 'qna-js-18',
        question: 'What is event delegation and why is it useful for dynamic lists?',
        resourceTopicId: 'js-events',
      },
      {
        id: 'qna-js-19',
        question: 'What is event bubbling and capturing? Explain propagation order.',
        resourceTopicId: 'js-events',
      },
      {
        id: 'qna-js-20',
        question: 'How does the event loop prioritize microtasks over macrotasks?',
        resourceTopicId: 'js-event-loop',
      },
      {
        id: 'qna-js-21',
        question: 'What are Promise states and how do then/catch/finally chain?',
        resourceTopicId: 'js-promises',
      },
      {
        id: 'qna-js-22',
        question: 'Compare Promise.all, allSettled, race, and any with practical use cases.',
        resourceTopicId: 'js-promises',
      },
      {
        id: 'qna-js-23',
        question: 'When do you use async/await versus direct Promise chains?',
        resourceTopicId: 'js-async',
      },
      {
        id: 'qna-js-24',
        question: 'How do fetch, Response.json, and AbortController improve API handling?',
        resourceTopicId: 'js-fetch-api',
      },
      {
        id: 'qna-js-25',
        question: 'What are ES modules and how is dynamic import used for code-splitting?',
        resourceTopicId: 'js-modules-tooling',
      },
      {
        id: 'qna-js-26',
        question: 'How do localStorage, sessionStorage, cookies, and IndexedDB differ?',
        resourceTopicId: 'js-browser-storage',
      },
    ],
  },
  {
    section: 'Advanced and Senior Round',
    questions: [
      {
        id: 'qna-js-27',
        question: 'Predict output: synchronous logs, Promise.then logs, and setTimeout logs mixed together.',
        resourceTopicId: 'js-event-loop',
      },
      {
        id: 'qna-js-28',
        question: 'How would you debug a closure-related memory leak in a long-lived page?',
        resourceTopicId: 'js-performance-memory',
      },
      {
        id: 'qna-js-29',
        question: 'Why can mutating shared objects create hidden bugs in reducers and state updates?',
        resourceTopicId: 'js-arrays-objects',
      },
      {
        id: 'qna-js-30',
        question: 'How would you design a retry with timeout and fallback for flaky APIs?',
        resourceTopicId: 'js-async',
      },
      {
        id: 'qna-js-31',
        question: 'How do you prevent unhandled promise rejections in production flows?',
        resourceTopicId: 'js-error-handling',
      },
      {
        id: 'qna-js-32',
        question: 'What is the safest way to render untrusted user input in the DOM?',
        resourceTopicId: 'js-security',
      },
      {
        id: 'qna-js-33',
        question: 'How do you measure and optimize slow interactions on a page?',
        resourceTopicId: 'js-performance-memory',
      },
      {
        id: 'qna-js-34',
        question: 'How do you identify whether a bug is in API layer, state flow, or rendering layer using DevTools?',
        resourceTopicId: 'js-devtools-debugging',
      },
      {
        id: 'qna-js-35',
        question: 'How would you explain debounce and throttle behavior in search and scroll scenarios?',
        resourceTopicId: 'js-performance-memory',
      },
      {
        id: 'qna-js-36',
        question: 'What trade-offs do you consider while choosing browser storage strategy for auth and caching?',
        resourceTopicId: 'js-browser-storage',
      },
      {
        id: 'qna-js-37',
        question: 'How would you structure modules in a large frontend app to reduce coupling?',
        resourceTopicId: 'js-modules-tooling',
      },
      {
        id: 'qna-js-38',
        question: 'How do call, apply, and bind help fix context bugs in event-driven code?',
        resourceTopicId: 'js-this-keyword',
      },
      {
        id: 'qna-js-39',
        question: 'Explain deep clone versus shallow clone and when each breaks assumptions.',
        resourceTopicId: 'js-arrays-objects',
      },
      {
        id: 'qna-js-40',
        question: 'How do you design robust error boundaries between async services and UI state?',
        resourceTopicId: 'js-error-handling',
      },
    ],
  },
  {
    section: 'FAANG Scenario Round',
    questions: [
      {
        id: 'qna-js-41',
        question: 'Scenario: A product page is lagging on scroll. How will you profile and fix it step by step?',
        resourceTopicId: 'js-devtools-debugging',
      },
      {
        id: 'qna-js-42',
        question: 'Scenario: You must load three APIs where two can fail but UI should still render partial results. Which promise strategy do you use?',
        resourceTopicId: 'js-promises',
      },
      {
        id: 'qna-js-43',
        question: 'Scenario: Click handler breaks because this is undefined after passing method as callback. How do you fix and compare options?',
        resourceTopicId: 'js-this-keyword',
      },
      {
        id: 'qna-js-44',
        question: 'Scenario: User navigates quickly and stale fetch responses overwrite latest data. How do you prevent race conditions?',
        resourceTopicId: 'js-fetch-api',
      },
      {
        id: 'qna-js-45',
        question: 'Scenario: Memory increases after opening and closing modals repeatedly. Which leak checks and cleanup patterns do you apply?',
        resourceTopicId: 'js-performance-memory',
      },
      {
        id: 'qna-js-46',
        question: 'Scenario: A third-party script introduces XSS risk. What frontend hardening steps do you take immediately?',
        resourceTopicId: 'js-security',
      },
      {
        id: 'qna-js-47',
        question: 'Scenario: You need offline-ready read cache for important API payloads. How do Cache Storage and fallback strategies fit?',
        resourceTopicId: 'js-browser-storage',
      },
      {
        id: 'qna-js-48',
        question: 'Scenario: Team is confused by async stack traces in production. How do source maps and DevTools workflows help?',
        resourceTopicId: 'js-modules-tooling',
      },
      {
        id: 'qna-js-49',
        question: 'Scenario: Output prediction round with closures inside loops using var and let. Explain behavior and fixes.',
        resourceTopicId: 'js-hoisting-tdz',
      },
      {
        id: 'qna-js-50',
        question: 'Scenario: Event delegation should support nested elements and stop accidental parent actions. How do you implement safely?',
        resourceTopicId: 'js-events',
      },
      {
        id: 'qna-js-51',
        question: 'Scenario: API response shape changes and causes runtime crashes. How do you design defensive parsing and error handling?',
        resourceTopicId: 'js-error-handling',
      },
      {
        id: 'qna-js-52',
        question: 'Scenario: Interview asks for end-to-end explanation of execution context, call stack, and event loop in one flow. How do you answer?',
        resourceTopicId: 'js-execution-context-call-stack',
      },
      {
        id: 'qna-js-53',
        question: 'Scenario: A click action freezes UI because of heavy computation. How do you solve it using Web Workers and what are the API limitations?',
        resourceTopicId: 'js-web-workers',
      },
      {
        id: 'qna-js-54',
        question: 'Scenario: Your team wants confidence for releases. How do you define unit, integration, and E2E test balance?',
        resourceTopicId: 'js-testing-strategy',
      },
      {
        id: 'qna-js-55',
        question: 'Scenario: Build a decoupled notification system. Which pattern (PubSub/Module) would you choose and why?',
        resourceTopicId: 'js-patterns-module-principles',
      },
      {
        id: 'qna-js-56',
        question: 'Scenario: Convert imperative data logic into functional style using pure functions, currying, and composition.',
        resourceTopicId: 'js-functional-programming',
      },
      {
        id: 'qna-js-57',
        question: 'Scenario: Design offline-first behavior using manifest, service worker caching, and Workbox strategies.',
        resourceTopicId: 'js-pwa-service-workers',
      },
      {
        id: 'qna-js-58',
        question: 'Scenario: Bundle size keeps growing. How do code splitting, tree shaking, and module federation help?',
        resourceTopicId: 'js-tooling-webpack-ecosystem',
      },
      {
        id: 'qna-js-59',
        question: 'Scenario: Legacy browser support is required. How do you configure Babel transpilation safely?',
        resourceTopicId: 'js-transpilation-babel',
      },
      {
        id: 'qna-js-60',
        question: 'Scenario: Team commits broken code often. How would ESLint, Husky, and git hooks improve quality gates?',
        resourceTopicId: 'js-code-quality-hooks',
      },
    ],
  },
];

export const CSS_INTERVIEW_QNA = [
  {
    section: 'Beginner Round',
    questions: [
      {
        id: 'qna-css-1',
        question: 'What is CSS and how is it different from HTML?',
        resourceTopicId: 'css-introduction',
      },
      {
        id: 'qna-css-2',
        question: 'What are selectors in CSS and why are they important?',
        resourceTopicId: 'css-selectors',
      },
      {
        id: 'qna-css-3',
        question: 'What is the difference between display: block, inline, and inline-block?',
        resourceTopicId: 'css-display',
      },
      {
        id: 'qna-css-4',
        question: 'What is the difference between margin and padding?',
        resourceTopicId: 'css-margin-padding',
      },
      {
        id: 'qna-css-5',
        question: 'What does the box model mean in CSS?',
        resourceTopicId: 'css-box-model',
      },
      {
        id: 'qna-css-6',
        question: 'How does position: relative, absolute, fixed, and sticky differ?',
        resourceTopicId: 'css-position',
      },
    ],
  },
  {
    section: 'Intermediate Round',
    questions: [
      {
        id: 'qna-css-7',
        question: 'How does specificity work in CSS?',
        resourceTopicId: 'css-specificity',
      },
      {
        id: 'qna-css-8',
        question: 'How do inheritance and cascade interact in real-world stylesheets?',
        resourceTopicId: 'css-syntax',
      },
      {
        id: 'qna-css-9',
        question: 'When should you use flexbox and when should you use grid?',
        resourceTopicId: 'css-grid',
      },
      {
        id: 'qna-css-10',
        question: 'How do you center items using flexbox and grid in interviews?',
        resourceTopicId: 'css-flexbox',
      },
      {
        id: 'qna-css-11',
        question: 'How do media queries support responsive design?',
        resourceTopicId: 'css-responsive',
      },
      {
        id: 'qna-css-12',
        question: 'How do rem, em, %, vh, and vw affect responsive typography and spacing?',
        resourceTopicId: 'css-units',
      },
      {
        id: 'qna-css-13',
        question: 'What is the role of pseudo-classes in interactive UI styling?',
        resourceTopicId: 'css-pseudo-classes',
      },
      {
        id: 'qna-css-14',
        question: 'When do you use pseudo-elements instead of adding extra markup?',
        resourceTopicId: 'css-pseudo-elements',
      },
    ],
  },
  {
    section: 'Advanced and FAANG-Level Round',
    questions: [
      {
        id: 'qna-css-15',
        question: 'How do you prevent CSS architecture from becoming hard to maintain at scale?',
        resourceTopicId: 'css-variables',
      },
      {
        id: 'qna-css-16',
        question: 'How do you design a scalable naming strategy for large component libraries?',
        resourceTopicId: 'css-selectors',
      },
      {
        id: 'qna-css-17',
        question: 'How do transitions and animations affect UX and performance?',
        resourceTopicId: 'css-animations',
      },
      {
        id: 'qna-css-18',
        question: 'When should you prefer transitions over keyframe animations?',
        resourceTopicId: 'css-transitions',
      },
      {
        id: 'qna-css-19',
        question: 'Why is specificity debt dangerous in large frontend systems?',
        resourceTopicId: 'css-specificity',
      },
      {
        id: 'qna-css-20',
        question: 'How do you debug complex layout issues quickly in production?',
        resourceTopicId: 'css-grid',
      },
      {
        id: 'qna-css-21',
        question: 'How would you explain responsive CSS strategy for a production learning platform?',
        resourceTopicId: 'css-responsive',
      },
      {
        id: 'qna-css-22',
        question: 'How do CSS variables help with theming, consistency, and future refactors?',
        resourceTopicId: 'css-variables',
      },
      {
        id: 'qna-css-23',
        question: 'How do you keep animation smooth while avoiding layout thrashing?',
        resourceTopicId: 'css-animations',
      },
      {
        id: 'qna-css-24',
        question: 'What accessibility checks must be done for focus states and contrast in CSS?',
        resourceTopicId: 'css-pseudo-classes',
      },
      {
        id: 'qna-css-25',
        question: 'How do you choose between utility-first CSS and component-scoped CSS in interviews?',
        resourceTopicId: 'css-introduction',
      },
      {
        id: 'qna-css-26',
        question: 'How do you avoid global style leaks in large React applications?',
        resourceTopicId: 'css-selectors',
      },
      {
        id: 'qna-css-27',
        question: 'What CSS topics are most frequently asked in frontend interviews and why?',
        resourceTopicId: 'css-interview-qna',
      },
      {
        id: 'qna-css-28',
        question: 'How would you optimize CSS delivery and reduce unused styles in production?',
        resourceTopicId: 'css-preprocessors-frameworks-cssinjs',
      },
      {
        id: 'qna-css-29',
        question: 'How do you explain paint, layout, and composite in CSS performance discussions?',
        resourceTopicId: 'css-animations',
      },
      {
        id: 'qna-css-30',
        question: 'What is your practical checklist before approving CSS in code review?',
        resourceTopicId: 'css-interview-qna',
      },
      {
        id: 'qna-css-31',
        question: 'How does CSSOM help debug computed styles and dynamic style changes?',
        resourceTopicId: 'css-cssom-cascade-inheritance',
      },
      {
        id: 'qna-css-32',
        question: 'How do cascade and inheritance combine with specificity in real component systems?',
        resourceTopicId: 'css-cssom-cascade-inheritance',
      },
      {
        id: 'qna-css-33',
        question: 'When do you still use float, and when should flex/grid be preferred?',
        resourceTopicId: 'css-layout-float-flex-grid',
      },
      {
        id: 'qna-css-34',
        question: 'How do transforms and SVG animations differ from regular keyframe use cases?',
        resourceTopicId: 'css-animations-transforms-svg',
      },
      {
        id: 'qna-css-35',
        question: 'How do you decide between Sass, utility frameworks, and CSS-in-JS in a production project?',
        resourceTopicId: 'css-preprocessors-frameworks-cssinjs',
      },
    ],
  },
];

Object.assign(HTML_LESSONS, {
  'html-request-lifecycle': {
    heading: 'Request Lifecycle',
    easySummary: 'Browser request lifecycle explains how a user click turns into a server response and rendered page update.',
    theory: [
      'When users click a link or submit a form, the browser resolves DNS, opens a connection, sends HTTP request data, waits for response headers/body, and then updates rendering. Understanding this sequence helps debug slow pages and API issues.',
      'Frontend interviews often ask request lifecycle to evaluate systems thinking. Strong answers include DNS lookup, TCP/TLS handshake, request/response, caching, and browser rendering pipeline.',
      'Even in SPAs, each API call follows lifecycle rules. Better frontend debugging starts when you can identify where latency or failure occurred in this chain.',
    ],
    practicalTips: [
      'Use the Network panel timeline to isolate DNS, connection, TTFB, and download delays.',
      'Set proper cache headers so repeat requests are faster.',
      'Validate method, URL, headers, and payload before assuming backend bug.',
    ],
    referenceSections: [
      {
        title: 'HTTP request lifecycle stages',
        intro: 'Core stages asked in interviews and used in production debugging.',
        columns: [
          { key: 'stage', label: 'Stage' },
          { key: 'meaning', label: 'What happens' },
          { key: 'why', label: 'Why it matters' },
        ],
        rows: [
          { stage: 'DNS lookup', meaning: 'Domain resolved to IP address', why: 'Slow DNS increases initial latency' },
          { stage: 'TCP/TLS handshake', meaning: 'Secure connection established', why: 'Critical for HTTPS and security' },
          { stage: 'Request sent', meaning: 'Method, headers, body transmitted', why: 'Wrong payload leads to API failures' },
          { stage: 'TTFB', meaning: 'Time to first byte from server', why: 'Highlights backend/network response delay' },
          { stage: 'Content download', meaning: 'Body streamed to browser', why: 'Large payload slows rendering' },
          { stage: 'Parse and render', meaning: 'HTML/CSS/JS processed and painted', why: 'Affects visible page speed' },
        ],
      },
    ],
    examples: [
      {
        title: 'Lifecycle quick map',
        description: 'Simple visual timeline from user action to UI update.',
        code: '<ol><li>Click button</li><li>Browser sends request</li><li>Server responds</li><li>Browser parses</li><li>UI updates</li></ol>',
        outputHtml: '<ol><li>Click button</li><li>Browser sends request</li><li>Server responds</li><li>Browser parses</li><li>UI updates</li></ol>',
      },
    ],
  },
  'html-responsive-images': {
    heading: 'Responsive Images',
    easySummary: 'Responsive images help deliver the right asset for device size and density, improving performance and clarity.',
    theory: [
      'Responsive images prevent downloading oversized files on small screens. The browser selects the best candidate from srcset and sizes based on viewport and pixel density.',
      'picture and source are used when art direction is needed, such as different crops on mobile and desktop. img remains the fallback element.',
      'Good image strategy improves LCP and user experience without sacrificing visual quality.',
    ],
    practicalTips: [
      'Use srcset and sizes for adaptive image delivery.',
      'Always provide meaningful alt text or empty alt for decorative images.',
      'Set width and height to reduce layout shifts.',
    ],
    referenceSections: [
      {
        title: 'Responsive image attributes',
        intro: 'Attributes and tags commonly used in interview examples.',
        columns: [
          { key: 'item', label: 'Item' },
          { key: 'use', label: 'Use' },
        ],
        rows: [
          { item: 'srcset', use: 'Provides multiple image candidates' },
          { item: 'sizes', use: 'Describes intended rendered width' },
          { item: 'picture/source', use: 'Art-direction and format selection' },
          { item: 'loading="lazy"', use: 'Defers offscreen image loading' },
          { item: 'width/height', use: 'Reserves layout space before load' },
        ],
      },
    ],
    examples: [
      {
        title: 'srcset and sizes sample',
        description: 'Browser chooses the best image candidate.',
        code: '<img src="/main-image.png" srcset="/main-image.png 480w, /main-image.png 960w" sizes="(max-width: 600px) 90vw, 480px" alt="Course hero" width="480" height="270" loading="lazy" />',
        outputHtml: '<img src="/main-image.png" alt="Course hero" width="240" height="135" loading="lazy" />',
      },
    ],
  },
  'html-forms-validation': {
    heading: 'Forms and Validation',
    easySummary: 'Form validation combines semantic inputs, built-in constraints, and clear error messaging.',
    theory: [
      'HTML supports built-in validation rules using attributes like required, minlength, maxlength, pattern, min, max, and type=email/url/number.',
      'Constraint Validation API gives JS control through methods such as checkValidity, reportValidity, and setCustomValidity.',
      'Accessible validation requires explicit labels, descriptive error messages, and focus management for invalid fields.',
    ],
    practicalTips: [
      'Use native validation first and add custom rules only when needed.',
      'Connect helper/error text using aria-describedby.',
      'Never rely on color alone for validation state.',
    ],
    referenceSections: [
      {
        title: 'Validation attributes and methods',
        intro: 'Core HTML and JS APIs for practical form validation.',
        columns: [
          { key: 'item', label: 'Item' },
          { key: 'type', label: 'Type' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { item: 'required, minlength, maxlength, pattern', type: 'HTML attributes', purpose: 'Native field-level constraints' },
          { item: 'form.checkValidity()', type: 'Method', purpose: 'Boolean pass/fail for full form' },
          { item: 'form.reportValidity()', type: 'Method', purpose: 'Show browser validation UI' },
          { item: 'input.setCustomValidity(msg)', type: 'Method', purpose: 'Set custom error message' },
          { item: 'input.validationMessage', type: 'Property', purpose: 'Read current validation message' },
        ],
      },
    ],
    examples: [
      {
        title: 'Native + custom validation',
        description: 'Validates email input and shows browser feedback.',
        code: '<form id="f"><label for="e">Email</label><input id="e" type="email" required /><button type="submit">Submit</button></form><p id="msg"></p><script>const form=document.getElementById("f");const email=document.getElementById("e");form.addEventListener("submit",(ev)=>{ev.preventDefault();email.setCustomValidity("");if(!email.value.endsWith("@gmail.com")){email.setCustomValidity("Use a gmail address for this demo.");}if(!form.checkValidity()){form.reportValidity();document.getElementById("msg").textContent="Invalid form";return;}document.getElementById("msg").textContent="Form valid";});</script>',
        outputHtml: '<p>Try invalid and valid email values to see native validation behavior.</p>',
      },
    ],
  },
  'html-atomic-design-systems': {
    heading: 'Atomic Design and Design Systems',
    easySummary: 'Atomic design organizes UI into reusable layers: atoms, molecules, organisms, templates, and pages.',
    theory: [
      'Atomic design improves UI consistency by defining small reusable components first and composing them into larger blocks.',
      'Design systems add tokens, spacing scales, typography, colors, and interaction guidelines so teams can ship faster with consistent UX.',
      'Interview answers should mention reuse, consistency, accessibility standards, and reduced UI drift across teams.',
    ],
    practicalTips: [
      'Define design tokens first before component-specific styling.',
      'Keep component APIs small and predictable.',
      'Document usage rules and accessibility expectations for each component.',
    ],
    referenceSections: [
      {
        title: 'Atomic design levels',
        intro: 'How component scale grows in a design system.',
        columns: [
          { key: 'level', label: 'Level' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { level: 'Atom', example: 'Button, label, icon' },
          { level: 'Molecule', example: 'Search input + button' },
          { level: 'Organism', example: 'Navbar with search and profile' },
          { level: 'Template', example: 'Course listing page layout' },
          { level: 'Page', example: 'Final rendered page with live data' },
        ],
      },
    ],
    examples: [
      {
        title: 'Atom to molecule example',
        description: 'Reusable input + button molecule.',
        code: '<div><label for="q">Search</label><input id="q" /><button type="button">Go</button></div>',
        outputHtml: '<div><label for="q">Search</label> <input id="q" /> <button type="button">Go</button></div>',
      },
    ],
  },
});

Object.assign(CSS_LESSONS, {
  'css-cssom-cascade-inheritance': {
    heading: 'CSSOM Cascade and Inheritance',
    easySummary: 'CSSOM is the browser object model of styles; cascade and inheritance decide final computed style.',
    theory: [
      'CSSOM (CSS Object Model) is how the browser represents stylesheets and computed styles in memory.',
      'Cascade resolution combines origin, importance, specificity, and source order to select winning declarations.',
      'Inheritance passes certain properties from parent to child by default, which is useful but must be understood during debugging.',
    ],
    practicalTips: [
      'Use getComputedStyle to inspect final values during debugging.',
      'Avoid unnecessary !important and deep selector fights.',
      'Know which properties inherit (for example color, font-family) and which do not (for example margin).',
    ],
    referenceSections: [
      {
        title: 'CSSOM inspection APIs',
        intro: 'Useful browser APIs for style introspection and dynamic changes.',
        columns: [
          { key: 'api', label: 'API' },
          { key: 'purpose', label: 'Purpose' },
        ],
        rows: [
          { api: 'getComputedStyle(element)', purpose: 'Read final computed property values' },
          { api: 'document.styleSheets', purpose: 'Access loaded stylesheets' },
          { api: 'CSSStyleRule.style.getPropertyValue()', purpose: 'Read a declaration value from rule' },
          { api: 'element.style.setProperty(name,value)', purpose: 'Set inline CSS property dynamically' },
          { api: 'window.matchMedia(query)', purpose: 'Check media query match status in JS' },
        ],
      },
    ],
    examples: [
      {
        title: 'Read computed styles',
        description: 'Checks computed color and font size from rendered element.',
        code: '<style>#demo{color:#1d4ed8;font-size:18px;}</style><p id="demo">CSSOM Demo</p><script>const cs=getComputedStyle(document.getElementById("demo"));document.body.innerHTML += `<pre>color=${cs.color}\nfontSize=${cs.fontSize}</pre>`;</script>',
        outputHtml: '<pre>Computed styles can be inspected with getComputedStyle.</pre>',
      },
    ],
  },
  'css-layout-float-flex-grid': {
    heading: 'Layout Systems and Float',
    easySummary: 'Modern layout uses flex and grid, while float remains useful for specific legacy/text-wrap scenarios.',
    theory: [
      'Float was historically used for layouts but is now mostly replaced by flex and grid. It is still useful for text wrapping around media.',
      'Flex is one-dimensional (row/column axis), while grid is two-dimensional and best for page-level spatial layouts.',
      'Display and positioning properties still shape foundational behavior around all layout systems.',
    ],
    practicalTips: [
      'Use flex for navbars and linear alignment.',
      'Use grid for cards/dashboard areas with row and column control.',
      'Use float only where content wrapping behavior is desired.',
    ],
    referenceSections: [
      {
        title: 'Layout technique comparison',
        intro: 'When to pick each layout method.',
        columns: [
          { key: 'technique', label: 'Technique' },
          { key: 'bestFor', label: 'Best for' },
        ],
        rows: [
          { technique: 'float', bestFor: 'Image/text wrapping and legacy tweaks' },
          { technique: 'flexbox', bestFor: 'One-dimensional alignment and spacing' },
          { technique: 'grid', bestFor: 'Two-dimensional component/page layouts' },
          { technique: 'position', bestFor: 'Overlays, badges, sticky/fixed elements' },
        ],
      },
    ],
    examples: [
      {
        title: 'Float wrap demo',
        description: 'Shows text wrapping around a floated media block.',
        code: '<style>.thumb{float:left;width:90px;height:90px;background:#bfdbfe;margin-right:12px;} .clear{clear:both;}</style><div class="thumb"></div><p>Float still helps wrapping text around media in editorial layouts.</p><div class="clear"></div>',
        outputHtml: '<p>Float example with wrapped text.</p>',
      },
    ],
  },
  'css-animations-transforms-svg': {
    heading: 'Animations Transforms and SVG',
    easySummary: 'Transforms and keyframe animation produce smooth motion; SVG is ideal for scalable vector graphics.',
    theory: [
      'Transform functions such as translate, scale, rotate, and skew are common for UI motion and are generally performant.',
      'SVG scales cleanly across resolutions and is often animated with CSS for icons, diagrams, and loaders.',
      'Animation should communicate state or guidance, not distract users.',
    ],
    practicalTips: [
      'Prefer transform + opacity for smoother animations.',
      'Use transform-origin intentionally for rotations/scaling.',
      'Keep SVG graphics semantic and lightweight.',
    ],
    referenceSections: [
      {
        title: 'Motion-related properties',
        intro: 'High-frequency transform and animation properties.',
        columns: [
          { key: 'item', label: 'Property/Function' },
          { key: 'use', label: 'Use' },
        ],
        rows: [
          { item: 'transform: translate()', use: 'Move element on x/y axis' },
          { item: 'transform: scale()', use: 'Grow/shrink element' },
          { item: 'transform: rotate()', use: 'Rotate element around origin' },
          { item: 'transform-origin', use: 'Set transform pivot point' },
          { item: 'animation-name/duration/timing-function', use: 'Define keyframe behavior' },
          { item: 'transition-property/duration', use: 'Smooth state changes' },
        ],
      },
    ],
    examples: [
      {
        title: 'SVG pulse animation',
        description: 'Simple SVG circle animated with CSS keyframes.',
        code: '<style>@keyframes pulse{0%,100%{transform:scale(1)}50%{transform:scale(1.15)}} svg{animation:pulse 1.2s ease-in-out infinite;}</style><svg width="80" height="80" viewBox="0 0 80 80"><circle cx="40" cy="40" r="22" fill="#60a5fa"/></svg>',
        outputHtml: '<svg width="80" height="80" viewBox="0 0 80 80"><circle cx="40" cy="40" r="22" fill="#60a5fa"/></svg>',
      },
    ],
  },
  'css-preprocessors-frameworks-cssinjs': {
    heading: 'Preprocessors Frameworks and CSS-in-JS',
    easySummary: 'Sass/Less add authoring features, frameworks provide utility/components, and CSS-in-JS scopes styles in JavaScript apps.',
    theory: [
      'Preprocessors (Sass/Less) add nesting, variables, mixins, and functions that compile to CSS.',
      'Frameworks (for example Tailwind, Bootstrap) speed development with conventions and utilities.',
      'CSS-in-JS libraries (styled-components, emotion) colocate styles with components and can support dynamic theming.',
    ],
    practicalTips: [
      'Pick one styling strategy per project area to reduce inconsistency.',
      'Keep tokens (colors/spacing/type) centralized regardless of tooling choice.',
      'Avoid over-nesting in preprocessors to prevent specificity issues.',
    ],
    referenceSections: [
      {
        title: 'Tooling choices quick map',
        intro: 'When each CSS approach is usually chosen.',
        columns: [
          { key: 'approach', label: 'Approach' },
          { key: 'bestFit', label: 'Best fit' },
        ],
        rows: [
          { approach: 'Sass/Less', bestFit: 'Teams wanting CSS-like syntax with compile-time features' },
          { approach: 'Utility CSS frameworks', bestFit: 'Fast UI composition with predefined scale' },
          { approach: 'Component-scoped CSS', bestFit: 'Applications emphasizing local style isolation' },
          { approach: 'CSS-in-JS', bestFit: 'Dynamic theme and component-driven styling in JS apps' },
        ],
      },
    ],
    examples: [
      {
        title: 'Preprocessor-style nesting concept',
        description: 'Sass-like nested rules compiled to normal CSS.',
        code: '<pre>// Sass style\n.card {\n  padding: 12px;\n  .title { color: #1d4ed8; }\n}\n\n/* compiled CSS */\n.card { padding: 12px; }\n.card .title { color: #1d4ed8; }</pre>',
        outputHtml: '<pre>Sass nesting compiles to regular CSS selectors.</pre>',
      },
    ],
  },
});

Object.assign(JS_LESSONS, {
  'js-testing-strategy': {
    heading: 'Testing Strategy and Libraries',
    easySummary: 'Testing combines unit, integration, and end-to-end checks to keep releases safe.',
    theory: [
      'Testing strategy means deciding what to test, where to test it, and how much confidence each test layer gives. The core model is unit, integration, and end-to-end (E2E). Unit tests check isolated logic, integration tests verify modules working together, and E2E tests verify complete user journeys across UI, network, and backend boundaries.',
      'Unit testing definition: validate one function or component behavior in isolation with mocked dependencies. Example: taxTotal(100, 18) should return 118. Integration testing definition: verify a real flow across multiple pieces. Example: form submit triggers validation, calls API mock, and updates success state. E2E definition: run browser-like scenario from login to checkout with actual app wiring.',
      'Jest is commonly used as test runner/assertion/mocking toolkit. Important APIs: describe and it for structuring cases, expect for assertions, beforeEach/afterEach for lifecycle setup and cleanup, and jest.fn()/jest.mock() for spies and stubs. These APIs are not just syntax; they model predictable test contracts.',
      'Testing Library is behavior-first. It encourages querying what the user sees (for example screen.getByRole("button", { name: /save/i })) instead of internal class names. This aligns tests with accessibility and reduces brittle implementation-coupled test failures.',
      'Test pyramid trade-off: too many E2E tests create slow and flaky pipelines; too many unit tests without integration coverage miss wiring failures. Strong strategy is many fast unit tests, focused integration tests for feature boundaries, and critical-path E2E tests for release confidence.',
      'Flaky tests are non-deterministic tests that fail randomly. Causes include uncontrolled timers, race conditions, real network dependency, and shared mutable state across tests. Good practices: fake timers when needed, deterministic mocks, proper cleanup, and isolated fixtures.',
      'Interview-ready explanation usually includes coverage intent, failure isolation speed, CI cost, and practical policy such as: fail build on unit/integration failures, run smoke E2E on pull request, and full E2E on nightly or release branches.',
    ],
    practicalTips: [
      'Test behavior and outcomes, not implementation details.',
      'Mock network calls thoughtfully and verify error paths too.',
      'Keep flaky tests out of CI by controlling timers and async waits.',
    ],
    referenceSections: [
      {
        title: 'Testing APIs and utilities',
        intro: 'Common concepts, APIs, and test helpers with definitions and practical usage.',
        columns: [
          { key: 'item', label: 'Item' },
          { key: 'definition', label: 'Definition' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { item: 'Unit / Integration / E2E', definition: 'Three testing levels from isolated logic to full user journey.', purpose: 'Balance speed and confidence.', example: 'Unit: add() function, Integration: form submit + API mock, E2E: login to dashboard flow.' },
          { item: 'describe / it(test)', definition: 'Test declaration blocks in Jest-like frameworks.', purpose: 'Group related scenarios and define expected behavior.', example: 'describe("sum", () => { it("adds", ... ) })' },
          { item: 'expect(...).toBe / toEqual', definition: 'Assertion APIs that compare actual and expected results.', purpose: 'Validate output correctness and state.', example: 'expect(total).toBe(42), expect(obj).toEqual({ id: 1 })' },
          { item: 'jest.fn(), jest.mock()', definition: 'Mocking utilities for spies and dependency isolation.', purpose: 'Verify calls and decouple external modules.', example: 'const api = jest.fn(); expect(api).toHaveBeenCalled()' },
          { item: 'render, screen, fireEvent', definition: 'Testing Library helpers to render components and trigger user interactions.', purpose: 'Test behavior from user perspective.', example: 'render(<Login />); fireEvent.click(screen.getByText("Submit"))' },
          { item: 'beforeEach / afterEach', definition: 'Lifecycle hooks that run before/after each test case.', purpose: 'Consistent setup and cleanup.', example: 'beforeEach(() => localStorage.clear())' },
        ],
      },
    ],
    examples: [
      {
        title: 'Unit test shape',
        description: 'Jest-style sample for utility function.',
        code: '<pre>function add(a,b){ return a + b; }\n\ndescribe("add", () => {\n  it("adds two numbers", () => {\n    expect(add(2,3)).toBe(5);\n  });\n});</pre>',
        outputHtml: '<pre>Unit test: expect(add(2,3)).toBe(5)</pre>',
      },
      {
        title: 'Mock API and assertion flow',
        description: 'Demonstrates spy creation and call verification.',
        code: '<pre>const fetchUser = jest.fn().mockResolvedValue({ id: 7, name: "Asha" });\n\nit("calls API once", async () => {\n  await fetchUser();\n  expect(fetchUser).toHaveBeenCalledTimes(1);\n});</pre>',
        outputHtml: '<pre>Mock verifies call count and isolates external behavior.</pre>',
      },
      {
        title: 'Testing Library interaction sample',
        description: 'Behavior-first component test style.',
        code: '<pre>render(<button onClick={onSave}>Save</button>);\nfireEvent.click(screen.getByText("Save"));\nexpect(onSave).toHaveBeenCalled();</pre>',
        outputHtml: '<pre>Interaction test checks user-visible behavior, not internals.</pre>',
      },
    ],
  },
  'js-patterns-module-principles': {
    heading: 'Patterns and Module Principles',
    easySummary: 'Patterns like Singleton, Factory, Module, Prototype, and PubSub solve recurring design problems.',
    theory: [
      'A design pattern is a repeatable architectural approach to a recurring problem, not a strict template. Patterns reduce accidental complexity by giving names to proven structures. In interviews, the key is not memorizing names but explaining when a pattern improves clarity and when it introduces unnecessary abstraction.',
      'Singleton definition: one shared instance for global service/state (for example config registry, logger). Benefit: consistent shared behavior. Risk: hidden global state and test coupling. Factory definition: creator function/class encapsulating object construction rules. Benefit: centralized creation logic. Risk: overuse can hide simple constructor intent.',
      'Module pattern definition: encapsulate private implementation and expose a minimal public API. This improves maintainability because internals can change without breaking consumers. In ES modules, this principle appears as controlled exports and private helper functions.',
      'Prototype pattern definition: methods live on prototype chain and are shared across instances, reducing per-object memory duplication. Example: User.prototype.greet is shared by all User instances. This concept also helps understand class syntax because class methods are prototype methods underneath.',
      'PubSub definition: publishers emit events without knowing subscribers. Subscribers react to topics independently. Benefit: loose coupling for cross-feature communication. Risk: hard-to-trace event flows if topic naming and ownership are weak.',
      'Module principles for large frontend systems: high cohesion (a module has one responsibility), low coupling (few external assumptions), explicit contracts (clear inputs/outputs), and dependency direction control (core logic should not depend on UI details).',
      'Interview answers should include trade-off language. Example: "I use PubSub for cross-cutting notifications, but for critical transactional flows I prefer explicit function calls to preserve traceability." This shows architectural judgment, not just pattern vocabulary.',
    ],
    practicalTips: [
      'Choose the simplest pattern that solves the current problem.',
      'Document module boundaries and public APIs clearly.',
      'Avoid over-engineering with unnecessary abstractions.',
    ],
    referenceSections: [
      {
        title: 'Core frontend patterns',
        intro: 'Pattern definitions, when to use them, and lightweight examples.',
        columns: [
          { key: 'pattern', label: 'Pattern' },
          { key: 'definition', label: 'Definition' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { pattern: 'Singleton', definition: 'Ensures only one instance exists for shared state/service.', purpose: 'Single shared instance (for example app config).', example: 'const config = AppConfig.getInstance()' },
          { pattern: 'Factory function', definition: 'Function that creates objects without exposing constructor details.', purpose: 'Create objects with controlled shape/behavior.', example: 'createUser({ role: "admin" })' },
          { pattern: 'Module pattern', definition: 'Encapsulates private variables and exposes a public API.', purpose: 'Hide implementation and reduce accidental coupling.', example: 'const cart = (() => { let items=[]; return { add(){...} }; })()' },
          { pattern: 'Prototype pattern', definition: 'Shares methods via prototype chain instead of per-instance copies.', purpose: 'Memory-efficient shared behavior.', example: 'User.prototype.greet = function(){...}' },
          { pattern: 'PubSub', definition: 'Event bus where publishers and subscribers are decoupled.', purpose: 'Cross-module communication without tight dependencies.', example: 'bus.publish("order:created", payload)' },
          { pattern: 'Module boundary principle', definition: 'Expose minimal public surface and keep internals private.', purpose: 'Maintainability and safer refactoring.', example: 'export { getUser } but keep parseUserInternal private' },
        ],
      },
    ],
    examples: [
      {
        title: 'PubSub mini implementation',
        description: 'Decoupled communication using subscribe/publish.',
        code: '<script>const bus={events:{},subscribe(t,cb){(this.events[t]??=[]).push(cb);},publish(t,p){(this.events[t]||[]).forEach((cb)=>cb(p));}};bus.subscribe("saved",(v)=>{document.body.innerHTML=`<p>saved:${v.id}</p>`;});bus.publish("saved",{id:101});</script>',
        outputHtml: '<p>saved:101</p>',
      },
      {
        title: 'Factory function example',
        description: 'Creates role-specific user objects with a single creator API.',
        code: '<script>function createUser(name, role){return {name, role, canEdit: role === "admin"};} const u=createUser("Riya","admin"); document.body.innerHTML = `<pre>${JSON.stringify(u)}</pre>`;</script>',
        outputHtml: '<pre>{"name":"Riya","role":"admin","canEdit":true}</pre>',
      },
      {
        title: 'Module pattern with private state',
        description: 'Demonstrates encapsulation and controlled public methods.',
        code: '<script>const counter = (() => { let value = 0; return { inc(){ value += 1; }, get(){ return value; } }; })(); counter.inc(); counter.inc(); document.body.innerHTML = `<pre>count=${counter.get()}</pre>`;</script>',
        outputHtml: '<pre>count=2</pre>',
      },
    ],
  },
  'js-functional-programming': {
    heading: 'Functional Programming Essentials',
    easySummary: 'Functional programming favors pure functions, immutability, composition, and predictable data flow.',
    theory: [
      'Functional programming (FP) is a style where logic is modeled as transformations of data rather than sequences of stateful commands. The core benefit is predictability: same input gives same output, which makes reasoning, testing, and refactoring easier.',
      'Pure function definition: no side effects and deterministic result. Example: discount(100, 10) always returns 90. Side effect definition: observable external change such as DOM writes, network calls, localStorage mutation, or changing shared variables. FP does not ban side effects; it isolates them at system boundaries.',
      'Immutability definition: do not mutate existing data structures; produce new versions. Example: nextUsers = [...users, newUser] instead of users.push(newUser). This avoids hidden state bugs and works especially well with state management in React-like UIs.',
      'Currying definition: transform f(a,b,c) into f(a)(b)(c). Practical value: partial application and reusable preconfigured functions. Example: const addTax = addPercent(18); then addTax(price). This increases composition options in pipelines.',
      'Composition definition: combine small functions into a larger transformation. Example: pipe(trim, toLower, slugify)(title). Each function stays simple, and chain order explains business intent clearly. Point-free style is a composition style where you define pipelines without naming data arguments repeatedly.',
      'FP in frontend apps: list rendering (map), filtering (filter), aggregation (reduce), and selector derivation are natural FP zones. Strong implementations keep transformations pure and perform effects (API, routing, analytics) in explicit action layers.',
      'Trade-off discussion: excessive abstraction can reduce readability for beginners. Good FP practice is pragmatic: use pure/composable transformations where they improve clarity, but do not force point-free style when explicit variables communicate intent better.',
    ],
    practicalTips: [
      'Keep side effects near app edges (I/O, DOM, network).',
      'Prefer small composable functions over large imperative blocks.',
      'Use map/filter/reduce as foundation for functional pipelines.',
    ],
    referenceSections: [
      {
        title: 'Functional concepts map',
        intro: 'Core FP concepts with definitions and simple transformation examples.',
        columns: [
          { key: 'concept', label: 'Concept' },
          { key: 'definition', label: 'Definition' },
          { key: 'meaning', label: 'Meaning' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { concept: 'Pure function', definition: 'Function where output depends only on input and no external mutation occurs.', meaning: 'No side effects, deterministic output.', example: 'sum(2,3) always returns 5' },
          { concept: 'Side effect', definition: 'Any observable state change outside function return value.', meaning: 'External state change (DOM, I/O, mutable global).', example: 'document.body.textContent = "done"' },
          { concept: 'Immutability', definition: 'Data is not changed in place; new values are produced.', meaning: 'Avoid in-place mutation for predictability.', example: 'next = [...prev, item]' },
          { concept: 'Currying', definition: 'Converts multi-argument function into nested unary functions.', meaning: 'f(a,b) -> f(a)(b).', example: 'add(2)(3) => 5' },
          { concept: 'Composition', definition: 'Build bigger behavior by chaining smaller functions.', meaning: 'Combine functions right-to-left or left-to-right.', example: 'pipe(trim, lower, slugify)(title)' },
          { concept: 'Point-free style', definition: 'Transformation expressed without explicitly naming the data argument.', meaning: 'Define transformation without explicit value argument.', example: 'const sanitize = pipe(trim, lower)' },
        ],
      },
    ],
    examples: [
      {
        title: 'Currying and composition',
        description: 'Shows curry helper and composed output transformation.',
        code: '<script>const add=(a)=>(b)=>a+b;const double=(n)=>n*2;const toText=(n)=>`value=${n}`;const pipe=(...fns)=>(x)=>fns.reduce((v,f)=>f(v),x);const run=pipe(add(3),double,toText);document.body.innerHTML=`<pre>${run(4)}</pre>`;</script>',
        outputHtml: '<pre>value=14</pre>',
      },
      {
        title: 'Pure vs side effect example',
        description: 'Contrasts deterministic pure function with DOM side effect.',
        code: '<script>const pureTotal=(a,b)=>a+b;const out=[];out.push(`pureTotal(2,3)=${pureTotal(2,3)}`);function side(){document.body.setAttribute("data-state","changed");}side();out.push(`sideEffectApplied=${document.body.getAttribute("data-state")}`);document.body.innerHTML=`<pre>${out.join("\\n")}</pre>`;</script>',
        outputHtml: '<pre>pureTotal(2,3)=5\nsideEffectApplied=changed</pre>',
      },
      {
        title: 'Point-free pipeline with map/filter/reduce',
        description: 'Functional pipeline for data transformation.',
        code: '<script>const pipe=(...fns)=>(x)=>fns.reduce((v,f)=>f(v),x);const even=(xs)=>xs.filter((n)=>n%2===0);const square=(xs)=>xs.map((n)=>n*n);const sum=(xs)=>xs.reduce((a,b)=>a+b,0);const result=pipe(even,square,sum)([1,2,3,4,5,6]);document.body.innerHTML=`<pre>result=${result}</pre>`;</script>',
        outputHtml: '<pre>result=56</pre>',
      },
    ],
  },
  'js-pwa-service-workers': {
    heading: 'PWA Service Workers and Workbox',
    easySummary: 'PWAs use manifests, service workers, and caching strategies to support installable and offline-capable experiences.',
    theory: [
      'Progressive Web App (PWA) is a web application model that combines reach of web with app-like capabilities such as installability, offline resilience, and background capabilities. A PWA is not one API; it is a set of standards working together: manifest, service worker, secure context, and responsive UX.',
      'Manifest definition: a JSON metadata file that tells the browser how the app should appear when installed. Core fields include name, short_name, icons, start_url, display, theme_color, and background_color. Example: display="standalone" removes typical browser chrome for installed experience.',
      'Service worker definition: a script running in separate worker context, independent of page lifetime, that can intercept requests and manage caches. It has lifecycle phases: install, activate, and operational events like fetch, sync, and push.',
      'install event purpose: pre-cache app shell assets for fast startup. activate event purpose: remove old cache versions and take control safely. fetch event purpose: apply runtime strategy (cache-first, network-first, stale-while-revalidate) depending on resource type.',
      'Background Sync definition: defer failed write operations until connectivity returns. Example: posting feedback offline and retrying automatically when online. Push API definition: server can trigger notifications even when page is not open, through push events handled in service worker.',
      'Workbox definition: Google-maintained library that provides declarative routing and tested caching strategies. Instead of writing full custom fetch handlers for every case, registerRoute and strategy classes reduce error-prone boilerplate.',
      'Trade-offs and rules: cache aggressively for static assets but carefully for API data to avoid stale business states. Always version caches and provide update logic so users are not stuck on outdated app shells. Interview-grade answers mention both capability and consistency risks.',
    ],
    practicalTips: [
      'Version cache names and clean old caches during activate.',
      'Pick caching strategy per resource type (network-first, cache-first, stale-while-revalidate).',
      'Keep service worker code deterministic and test updates carefully.',
    ],
    referenceSections: [
      {
        title: 'Service worker and PWA APIs',
        intro: 'Definitions and use-cases for PWA concepts, service worker APIs, and Workbox helpers.',
        columns: [
          { key: 'item', label: 'API' },
          { key: 'definition', label: 'Definition' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { item: 'Web App Manifest', definition: 'JSON metadata that defines install behavior and app identity.', purpose: 'Enable install prompt and standalone launch.', example: 'name, icons, start_url, display' },
          { item: 'navigator.serviceWorker.register()', definition: 'Browser API to register a service worker script.', purpose: 'Start background worker lifecycle.', example: 'register("/sw.js")' },
          { item: 'self.addEventListener("install")', definition: 'Lifecycle event fired when SW is first installed.', purpose: 'Precache shell assets.', example: 'event.waitUntil(caches.open("v1"))' },
          { item: 'self.addEventListener("activate")', definition: 'Lifecycle event after install before controlling pages.', purpose: 'Delete outdated caches and claim clients.', example: 'clients.claim() + old cache cleanup' },
          { item: 'self.addEventListener("fetch")', definition: 'Intercepts network requests from controlled pages.', purpose: 'Apply runtime caching strategy.', example: 'cache-first for images' },
          { item: 'caches.open/match/put', definition: 'Cache Storage API operations.', purpose: 'Read and write cached responses.', example: 'const hit = await cache.match(req)' },
          { item: 'self.addEventListener("sync")', definition: 'Background Sync event when connectivity returns.', purpose: 'Retry failed offline actions.', example: 'sync tag: "retry-posts"' },
          { item: 'self.addEventListener("push")', definition: 'Push event for background notification payload.', purpose: 'Show user notifications.', example: 'self.registration.showNotification(...)' },
          { item: 'workbox.routing.registerRoute()', definition: 'Workbox route helper for request matching and strategy mapping.', purpose: 'Simplify service worker cache logic.', example: 'registerRoute(/\\.png$/, new CacheFirst())' },
        ],
      },
    ],
    examples: [
      {
        title: 'Manifest essentials',
        description: 'Minimal installable app manifest structure.',
        code: '<pre>{\n  "name": "Algodoor Learn",\n  "short_name": "Algodoor",\n  "start_url": "/",\n  "display": "standalone",\n  "background_color": "#ffffff",\n  "theme_color": "#15803d"\n}</pre>',
        outputHtml: '<pre>Manifest defines install metadata and launch behavior.</pre>',
      },
      {
        title: 'Service worker fetch cache strategy',
        description: 'Simple cache-first example for static assets.',
        code: '<pre>self.addEventListener("fetch", (event) => {\n  event.respondWith(\n    caches.match(event.request).then((cached) => cached || fetch(event.request))\n  );\n});</pre>',
        outputHtml: '<pre>Service worker can serve cached response before network.</pre>',
      },
      {
        title: 'Service worker registration snippet',
        description: 'Registers worker from app entry with support check.',
        code: '<pre>if ("serviceWorker" in navigator) {\n  navigator.serviceWorker.register("/sw.js")\n    .then(() => console.log("SW registered"))\n    .catch(console.error);\n}</pre>',
        outputHtml: '<pre>Registration initializes SW lifecycle (install, activate, fetch).</pre>',
      },
      {
        title: 'Workbox runtime route example',
        description: 'Caches images using CacheFirst strategy.',
        code: '<pre>import { registerRoute } from "workbox-routing";\nimport { CacheFirst } from "workbox-strategies";\n\nregisterRoute(({ request }) => request.destination === "image", new CacheFirst({ cacheName: "img-v1" }));</pre>',
        outputHtml: '<pre>Workbox wraps route matching and cache strategies declaratively.</pre>',
      },
    ],
  },
  'js-tooling-webpack-ecosystem': {
    heading: 'Tooling Webpack Parcel Rollup',
    easySummary: 'Bundlers build production-ready assets with code splitting, tree shaking, optimization, and plugin ecosystems.',
    theory: [
      'Build tooling transforms source code (JS, CSS, assets) into optimized production artifacts. Bundlers resolve dependency graphs, apply transforms, split chunks, and emit deployable files. Understanding this pipeline helps diagnose large bundles, runtime errors, and environment differences.',
      'Webpack is highly configurable with rich plugin ecosystem. Rollup is known for efficient ESM-oriented output and is often used in libraries or production pipeline layers. Parcel emphasizes zero-config developer experience. Choosing a tool is often about control vs simplicity and team workflow maturity.',
      'Entry/output definitions specify where graph traversal starts and how emitted files are named. Loader/transformer concepts (for example babel-loader) convert file types. Plugin concepts extend lifecycle tasks like HTML injection, env replacement, compression, or bundle analysis.',
      'Code splitting definition: break app into lazy chunks loaded on demand, reducing initial payload. Example: import("./Admin") when admin route opens. Tree shaking definition: remove unused ESM exports from final output, improving performance and parse time.',
      'Module federation definition: runtime sharing of modules between independently deployed apps (microfrontends). Example: host consumes remote widget without rebuilding host. Benefit: independent deployment. Risk: version compatibility and runtime coupling management.',
      'Minification and production optimization include dead-code elimination, constant folding, compression, and cache-friendly filenames (content hashes). These steps reduce transfer and improve browser execution performance.',
      'Interview answers should describe both mechanics and metrics: why bundle analysis, chunk budgets, and cache policies matter to user experience (LCP, TTI, interaction smoothness).',
    ],
    practicalTips: [
      'Use dynamic import for route or feature-level code splitting.',
      'Validate tree shaking with ESM exports and production mode builds.',
      'Use bundle analysis regularly to control growth.',
    ],
    referenceSections: [
      {
        title: 'Bundler concepts and knobs',
        intro: 'Definitions for tooling concepts, APIs, and optimization patterns used in real projects.',
        columns: [
          { key: 'concept', label: 'Concept' },
          { key: 'definition', label: 'Definition' },
          { key: 'note', label: 'Note' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { concept: 'Webpack / Parcel / Rollup', definition: 'JavaScript bundlers with different default behaviors and plugin ecosystems.', note: 'All produce optimized deployable assets.', example: 'Vite often uses Rollup for production output' },
          { concept: 'Entry and output', definition: 'Build input file(s) and emitted artifact naming/location.', note: 'Define build start point and emitted files.', example: 'entry: ./src/index.js, output: dist/main.[hash].js' },
          { concept: 'Loaders/transformers', definition: 'Pipeline hooks to process specific file types.', note: 'Handle JS/TS/CSS/assets conversion.', example: 'babel-loader for JS, css-loader for CSS' },
          { concept: 'Plugins', definition: 'Lifecycle extensions that augment bundling behavior.', note: 'Extend build pipeline behavior.', example: 'HtmlWebpackPlugin injects script tags' },
          { concept: 'Code splitting', definition: 'Split bundle into lazy chunks loaded on demand.', note: 'Generate smaller lazy-loaded chunks.', example: 'import("./AdminPanel")' },
          { concept: 'Tree shaking', definition: 'Eliminate unused exports from final bundles.', note: 'Remove unused ESM exports in production.', example: 'Unused helper function dropped in prod build' },
          { concept: 'Module federation', definition: 'Runtime sharing of code between independently deployed apps.', note: 'Share modules across independently deployed apps.', example: 'Host app consumes remote component' },
          { concept: 'Minification', definition: 'Compress and shorten code for transfer efficiency.', note: 'Reduce transfer size for production.', example: 'Terser removes whitespace and dead code' },
        ],
      },
    ],
    examples: [
      {
        title: 'Webpack config skeleton',
        description: 'Entry/output/loaders/plugins/minification starter structure.',
        code: '<pre>module.exports = {\n  mode: "production",\n  entry: "./src/index.js",\n  output: { filename: "bundle.[contenthash].js" },\n  module: { rules: [{ test: /\\.js$/, use: "babel-loader" }] },\n  optimization: { splitChunks: { chunks: "all" } },\n  plugins: []\n};</pre>',
        outputHtml: '<pre>Bundler config controls build pipeline end-to-end.</pre>',
      },
      {
        title: 'Dynamic import for code splitting',
        description: 'Loads feature chunk only when needed.',
        code: '<pre>document.getElementById("open-report").addEventListener("click", async () => {\n  const mod = await import("./reporting.js");\n  mod.openReport();\n});</pre>',
        outputHtml: '<pre>Dynamic import creates lazy-loaded chunk and reduces initial bundle.</pre>',
      },
      {
        title: 'Module federation host/remote sketch',
        description: 'Shows host consuming remote module at runtime.',
        code: '<pre>// host app\nconst ProfileCard = await import("remoteApp/ProfileCard");\n// remoteApp exposes module via ModuleFederationPlugin</pre>',
        outputHtml: '<pre>Federation enables independent deployment with shared runtime modules.</pre>',
      },
    ],
  },
  'js-transpilation-babel': {
    heading: 'Transpilation with Babel',
    easySummary: 'Babel transpiles modern JavaScript syntax to support older runtimes and controlled target environments.',
    theory: [
      'Transpilation means converting modern JavaScript syntax into backward-compatible syntax while preserving behavior. This is essential when product browser support includes environments that do not natively support the latest language features.',
      'Babel architecture has parser, transform plugins, and code generator stages. Presets are plugin bundles for common goals. @babel/preset-env chooses transforms based on target environments, so code is transformed only as needed instead of blindly downgrading everything.',
      'Syntax transforms and polyfills are different: transforms rewrite syntax (for example optional chaining), while polyfills provide missing runtime APIs (for example Promise.finally in old runtimes). Good answers explicitly distinguish these two concerns.',
      'plugin-transform-runtime centralizes Babel helper functions and avoids duplicating helper code in every output file. This can reduce bundle bloat and improve cache efficiency.',
      'babel-loader integrates Babel into Webpack-based pipelines, so module graph resolution and syntax transformation occur in one build step. Source maps map transformed code back to original author code for debugging stack traces and breakpoints.',
      'Target configuration strategy matters. Overly broad targets increase transforms and bundle size; overly narrow targets break old environments. Teams usually align targets with analytics/browserlist data and release policy.',
      'Interview-level explanation should include compatibility, bundle impact, debugging, and migration safety. Example: "We keep modern source syntax for readability, transpile by browser targets, and validate with CI across supported environments."',
    ],
    practicalTips: [
      'Define browser targets explicitly to avoid unnecessary transforms.',
      'Use source maps in production debugging workflows.',
      'Pair Babel with linting and tests for safer upgrades.',
    ],
    referenceSections: [
      {
        title: 'Babel configuration building blocks',
        intro: 'Babel concepts, APIs, and config keys with definitions and examples.',
        columns: [
          { key: 'item', label: 'Item' },
          { key: 'definition', label: 'Definition' },
          { key: 'purpose', label: 'Purpose' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { item: 'Transpilation', definition: 'Converting modern JS syntax into compatible syntax for older targets.', purpose: 'Run code across wider browser support matrix.', example: 'Optional chaining transformed for legacy browsers' },
          { item: '@babel/preset-env', definition: 'Preset that selects transforms based on target environments.', purpose: 'Target-based syntax transforms.', example: 'targets: "defaults"' },
          { item: '@babel/plugin-transform-runtime', definition: 'Moves Babel helpers to runtime package to avoid duplication.', purpose: 'Reuse helper code and reduce bundle bloat.', example: 'Single helper import instead of repeated inline helpers' },
          { item: 'babel-loader', definition: 'Webpack loader that passes files through Babel.', purpose: 'Integrate Babel with Webpack pipeline.', example: 'rules: [{ test: /\\.js$/, use: "babel-loader" }]' },
          { item: 'sourceMaps', definition: 'Metadata mapping transpiled code back to original source.', purpose: 'Debug transformed code effectively.', example: 'devtool: "source-map"' },
          { item: 'Polyfill strategy', definition: 'Inject missing runtime APIs based on usage or entry config.', purpose: 'Support features not natively available.', example: 'core-js with preset-env usage mode' },
        ],
      },
    ],
    examples: [
      {
        title: 'Babel config sample',
        description: 'Minimal preset-env based configuration.',
        code: '<pre>{\n  "presets": [["@babel/preset-env", { "targets": "defaults" }]],\n  "plugins": ["@babel/plugin-transform-runtime"]\n}</pre>',
        outputHtml: '<pre>Babel transpilation settings are usually defined in babel.config or package config.</pre>',
      },
      {
        title: 'Before vs after transpilation idea',
        description: 'Optional chaining transformed for broader compatibility.',
        code: '<pre>// source\nconst city = user?.address?.city ?? "NA";\n\n// transpiled shape (conceptual)\nconst city = user && user.address && user.address.city ? user.address.city : "NA";</pre>',
        outputHtml: '<pre>Babel rewrites modern syntax into equivalent compatible constructs.</pre>',
      },
      {
        title: 'Webpack + Babel integration snippet',
        description: 'Combines Babel loader with source maps in production.',
        code: '<pre>module.exports = {\n  module: { rules: [{ test: /\\.js$/, exclude: /node_modules/, use: "babel-loader" }] },\n  devtool: "source-map"\n};</pre>',
        outputHtml: '<pre>Babel is commonly integrated through bundler loaders.</pre>',
      },
    ],
  },
  'js-code-quality-hooks': {
    heading: 'ESLint Husky and Git Hooks',
    easySummary: 'Code quality automation uses linting and git hooks to catch issues before merge.',
    theory: [
      'Code quality automation is the process of enforcing correctness and consistency before code reaches shared branches. It combines static analysis, test checks, and git workflow gates to reduce regressions and review overhead.',
      'ESLint definition: pluggable static analyzer for JavaScript/TypeScript that reports rule violations such as unused variables, unsafe patterns, and style inconsistencies. This catches many defects before runtime and creates predictable codebase conventions.',
      'Git hook definition: script executed automatically at specific git lifecycle points (pre-commit, pre-push, commit-msg, etc.). Hooks are local guardrails that stop bad commits early, reducing failed CI cycles and noisy pull requests.',
      'Husky manages hook scripts inside repository so teams share the same checks. lint-staged runs linters/formatters only on staged files, balancing strictness with speed. Example: run ESLint --fix only on changed JS files during pre-commit.',
      'Pre-commit hooks should be fast (format/lint/type checks on staged files). Pre-push hooks can run heavier checks (unit tests, build smoke). CI remains the final source of truth for full pipeline validation on clean environment.',
      'Quality-gate principle: fail fast on critical issues (syntax errors, test failures, security lint violations) and avoid blocking developers for low-value noise. Well-designed gates improve trust without harming productivity.',
      'Interview-quality explanation should mention developer experience trade-offs and adoption sequencing: start with lint + format, then add staged hooks, then integrate CI policy and branch protections.',
    ],
    practicalTips: [
      'Run lint in CI and locally before pushing.',
      'Keep hook commands fast to avoid developer friction.',
      'Fail commits on critical lint/test errors, not minor formatting noise.',
    ],
    referenceSections: [
      {
        title: 'Quality pipeline tools',
        intro: 'Definitions and examples for linting, hooks, and quality gate tools.',
        columns: [
          { key: 'tool', label: 'Tool' },
          { key: 'definition', label: 'Definition' },
          { key: 'usage', label: 'Usage' },
          { key: 'example', label: 'Example' },
        ],
        rows: [
          { tool: 'ESLint', definition: 'Static analyzer that enforces syntax and code-quality rules.', usage: 'Catch bugs and style violations early.', example: 'eslint src --max-warnings=0' },
          { tool: 'Husky', definition: 'Utility to manage git hook scripts in repository.', usage: 'Attach scripts to pre-commit/pre-push lifecycle.', example: '.husky/pre-commit runs lint-staged' },
          { tool: 'lint-staged', definition: 'Runs commands only on staged files.', usage: 'Fast quality checks during commit.', example: 'src/**/*.{js,jsx}: eslint --fix' },
          { tool: 'pre-commit hook', definition: 'Git hook triggered before commit object creation.', usage: 'Block commit if lint/test fails.', example: 'npx lint-staged' },
          { tool: 'pre-push hook', definition: 'Git hook triggered before pushing commits to remote.', usage: 'Run heavier checks before remote push.', example: 'npm test and npm run build' },
          { tool: 'Conventional quality gate', definition: 'Combined lint+test+build checks as merge criteria.', usage: 'Keep main branch healthy.', example: 'CI requires lint, unit tests, and build success' },
        ],
      },
    ],
    examples: [
      {
        title: 'Husky + lint-staged sample',
        description: 'Pre-commit lint flow in package.json.',
        code: '<pre>{\n  "scripts": {\n    "lint": "eslint src --max-warnings=0"\n  },\n  "lint-staged": {\n    "src/**/*.{js,jsx}": ["eslint --fix"]\n  }\n}\n\n# .husky/pre-commit\nnpx lint-staged</pre>',
        outputHtml: '<pre>Pre-commit hook can enforce lint checks automatically.</pre>',
      },
      {
        title: 'Sample ESLint rule and violation',
        description: 'Shows no-unused-vars style rule impact.',
        code: '<pre>// .eslintrc.js\nmodule.exports = { rules: { "no-unused-vars": "error" } };\n\n// code\nconst total = 10; // error if not used</pre>',
        outputHtml: '<pre>Lint rules convert common mistakes into visible actionable errors.</pre>',
      },
      {
        title: 'Pre-push quality hook example',
        description: 'Runs tests before remote push.',
        code: '<pre># .husky/pre-push\nnpm run lint\nnpm test</pre>',
        outputHtml: '<pre>Pre-push hook prevents unstable code from reaching remote branches.</pre>',
      },
    ],
  },
});

export const TOPIC_LOOKUP = LEARN_TREE.reduce((acc, tech) => {
  tech.topics.forEach((topic) => {
    acc[topic.id] = {
      ...topic,
      techId: tech.id,
      techLabel: tech.label,
      techFullForm: tech.fullForm,
    };
  });
  return acc;
}, {});
